//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class WebPortalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all access requests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAccessRequests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessRequests(_response);
        });
    }

    protected processGetAccessRequests(response: Response): Promise<QueryOfAccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAccessRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAccessRequest>(null as any);
    }

    /**
     * Post a new user.
     */
    postAccessRequest(body: AccessRequestCreation): Promise<AccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAccessRequest(_response);
        });
    }

    protected processPostAccessRequest(response: Response): Promise<AccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRequest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRequest>(null as any);
    }

    /**
     * Get a specific access request.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAccessRequest(key: string, select?: string | undefined, expand?: string | undefined): Promise<AccessRequest> {
        let url_ = this.baseUrl + "/api/v3/accessrequests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessRequest(_response);
        });
    }

    protected processGetAccessRequest(response: Response): Promise<AccessRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRequest>(null as any);
    }

    /**
     * Delete a specific file.
     */
    deleteAccessRequest(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/accessrequests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAccessRequest(_response);
        });
    }

    protected processDeleteAccessRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all alerts.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAlertNotifications(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertNotifications(_response);
        });
    }

    protected processGetAlertNotifications(response: Response): Promise<QueryOfAlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAlertNotification>(null as any);
    }

    /**
     * Post a new alert.
     */
    postAlertNotification(body: AlertNotificationCreation): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAlertNotification(_response);
        });
    }

    protected processPostAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    /**
     * Get a specific alert.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAlertNotification(key: string, select?: string | undefined, expand?: string | undefined): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertNotification(_response);
        });
    }

    protected processGetAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    patchAlertNotification(body: AlertNotificationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<AlertNotification> {
        let url_ = this.baseUrl + "/api/v3/alertNotifications/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchAlertNotification(_response);
        });
    }

    protected processPatchAlertNotification(response: Response): Promise<AlertNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertNotification;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertNotification>(null as any);
    }

    /**
     * Get all alerts.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAlerts(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAlert> {
        let url_ = this.baseUrl + "/api/v3/alerts?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: Response): Promise<QueryOfAlert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAlert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAlert>(null as any);
    }

    /**
     * Post a new alert.
     */
    postAlert(body: AlertCreation): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAlert(_response);
        });
    }

    protected processPostAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    /**
     * Get a specific alert.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getAlert(key: string, select?: string | undefined, expand?: string | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlert(_response);
        });
    }

    protected processGetAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    patchAlert(body: AlertMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/alerts/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchAlert(_response);
        });
    }

    protected processPatchAlert(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    /**
     * Get all analysis batches
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAnalysisBatches(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAnalysisBatch> {
        let url_ = this.baseUrl + "/api/v3/analysisbatch?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalysisBatches(_response);
        });
    }

    protected processGetAnalysisBatches(response: Response): Promise<QueryOfAnalysisBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAnalysisBatch;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAnalysisBatch>(null as any);
    }

    /**
     * Post an analysis batch
     */
    postAnalysisBatch(body: AnalysisBatchCreation): Promise<AnalysisBatchCreation> {
        let url_ = this.baseUrl + "/api/v3/analysisbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAnalysisBatch(_response);
        });
    }

    protected processPostAnalysisBatch(response: Response): Promise<AnalysisBatchCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnalysisBatchCreation;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalysisBatchCreation>(null as any);
    }

    /**
     * Get all analysis set types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/analysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalysisSetTypes(_response);
        });
    }

    protected processGetAnalysisSetTypes(response: Response): Promise<QueryOfAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfAnalysisSetType>(null as any);
    }

    /**
     * Get the annotated ecg (HL7) file for a specific ecg recording
     */
    annotatedEcg(body: AnnotatedEcgRequest): Promise<AnnotatedEcgWrapper> {
        let url_ = this.baseUrl + "/api/v3/annotatedecg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnnotatedEcg(_response);
        });
    }

    protected processAnnotatedEcg(response: Response): Promise<AnnotatedEcgWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnotatedEcgWrapper;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnotatedEcgWrapper>(null as any);
    }

    /**
     * Post a new audit trail event.
     */
    postAuditTrailEvent(body: AuditTrailEvent): Promise<AuditTrailEvent> {
        let url_ = this.baseUrl + "/api/v3/audittrailevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAuditTrailEvent(_response);
        });
    }

    protected processPostAuditTrailEvent(response: Response): Promise<AuditTrailEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditTrailEvent;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditTrailEvent>(null as any);
    }

    /**
     * Get all blood glucose sample methods.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseSampleMethods(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseSampleMethod> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesamplemethods?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSampleMethods(_response);
        });
    }

    protected processGetBloodGlucoseSampleMethods(response: Response): Promise<QueryOfBloodGlucoseSampleMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseSampleMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseSampleMethod>(null as any);
    }

    /**
     * Get all Blood Glucose sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSessions(_response);
        });
    }

    protected processGetBloodGlucoseSessions(response: Response): Promise<QueryOfBloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseSession>(null as any);
    }

    /**
     * Post a new Blood Glucose session.
     */
    postBloodGlucoseSession(body: BloodGlucoseSessionCreation): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodGlucoseSession(_response);
        });
    }

    protected processPostBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    /**
     * Get a specific Blood Glucose session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodGlucoseSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSession(_response);
        });
    }

    protected processGetBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    /**
     * Patch an existing BloodGlucose session.
     * @param auditAnnotation (optional) 
     */
    patchBloodGlucoseSession(body: BloodGlucoseSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodGlucoseSession> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodGlucoseSession(_response);
        });
    }

    protected processPatchBloodGlucoseSession(response: Response): Promise<BloodGlucoseSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseSession>(null as any);
    }

    /**
     * Get all blood glucose session statuses.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseSessionStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseSessionStatus> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosesessionstatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseSessionStatuses(_response);
        });
    }

    protected processGetBloodGlucoseSessionStatuses(response: Response): Promise<QueryOfBloodGlucoseSessionStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseSessionStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseSessionStatus>(null as any);
    }

    /**
     * Get all Blood Glucose tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodGlucoseTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseTests(_response);
        });
    }

    protected processGetBloodGlucoseTests(response: Response): Promise<QueryOfBloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodGlucoseTest>(null as any);
    }

    /**
     * Post a new Blood Glucose test.
     */
    postBloodGlucoseTest(body: BloodGlucoseTestCreation): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodGlucoseTest(_response);
        });
    }

    protected processPostBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    /**
     * Get a specific Blood Glucose test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodGlucoseTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodGlucoseTest(_response);
        });
    }

    protected processGetBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    /**
     * Patch an existing Blood Glucose test.
     * @param auditAnnotation (optional) 
     */
    patchBloodGlucoseTest(body: BloodGlucoseTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodGlucoseTest> {
        let url_ = this.baseUrl + "/api/v3/bloodglucosetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodGlucoseTest(_response);
        });
    }

    protected processPatchBloodGlucoseTest(response: Response): Promise<BloodGlucoseTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodGlucoseTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTest>(null as any);
    }

    /**
     * Get all Blood Pressure sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodPressureSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureSessions(_response);
        });
    }

    protected processGetBloodPressureSessions(response: Response): Promise<QueryOfBloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodPressureSession>(null as any);
    }

    /**
     * Post a new Blood Pressure session.
     */
    postBloodPressureSession(body: BloodPressureSessionCreation): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodPressureSession(_response);
        });
    }

    protected processPostBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    /**
     * Get a specific Blood Pressure session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodPressureSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureSession(_response);
        });
    }

    protected processGetBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    /**
     * Patch an existing BloodPressure session.
     * @param auditAnnotation (optional) 
     */
    patchBloodPressureSession(body: BloodPressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodPressureSession> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuresessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodPressureSession(_response);
        });
    }

    protected processPatchBloodPressureSession(response: Response): Promise<BloodPressureSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureSession>(null as any);
    }

    /**
     * Get all Blood Pressure tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBloodPressureTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureTests(_response);
        });
    }

    protected processGetBloodPressureTests(response: Response): Promise<QueryOfBloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBloodPressureTest>(null as any);
    }

    /**
     * Post a new Blood Pressure test.
     */
    postBloodPressureTest(body: BloodPressureTestCreation): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBloodPressureTest(_response);
        });
    }

    protected processPostBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    /**
     * Get a specific Blood Pressure test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBloodPressureTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBloodPressureTest(_response);
        });
    }

    protected processGetBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    /**
     * Patch an existing Blood Pressure test.
     * @param auditAnnotation (optional) 
     */
    patchBloodPressureTest(body: BloodPressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BloodPressureTest> {
        let url_ = this.baseUrl + "/api/v3/bloodpressuretests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBloodPressureTest(_response);
        });
    }

    protected processPatchBloodPressureTest(response: Response): Promise<BloodPressureTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BloodPressureTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureTest>(null as any);
    }

    /**
     * Get all borg scales.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getBorgScales(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfBorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBorgScales(_response);
        });
    }

    protected processGetBorgScales(response: Response): Promise<QueryOfBorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfBorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfBorgScale>(null as any);
    }

    /**
     * Post a new borg scale.
     */
    postBorgScale(body: BorgScaleCreation): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostBorgScale(_response);
        });
    }

    protected processPostBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    /**
     * Get a specific borg scale.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getBorgScale(key: string, select?: string | undefined, expand?: string | undefined): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBorgScale(_response);
        });
    }

    protected processGetBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    /**
     * Patch an existing borg scale.
     * @param auditAnnotation (optional) 
     */
    patchBorgScale(body: BorgScaleMutation, key: string, auditAnnotation?: string | null | undefined): Promise<BorgScale> {
        let url_ = this.baseUrl + "/api/v3/borgscales/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchBorgScale(_response);
        });
    }

    protected processPatchBorgScale(response: Response): Promise<BorgScale> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BorgScale;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BorgScale>(null as any);
    }

    /**
     * Get all calibrations.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCalibrations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalibrations(_response);
        });
    }

    protected processGetCalibrations(response: Response): Promise<QueryOfCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalibration>(null as any);
    }

    /**
     * Post a new calibration.
     */
    postCalibration(body: CalibrationCreation): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCalibration(_response);
        });
    }

    protected processPostCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    /**
     * Get a specific calibration.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCalibration(key: string, select?: string | undefined, expand?: string | undefined): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalibration(_response);
        });
    }

    protected processGetCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    /**
     * Patch an existing calibration.
     * @param auditAnnotation (optional) 
     */
    patchCalibration(body: CalibrationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Calibration> {
        let url_ = this.baseUrl + "/api/v3/calibrations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCalibration(_response);
        });
    }

    protected processPatchCalibration(response: Response): Promise<Calibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Calibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Calibration>(null as any);
    }

    /**
     * Get all challenge sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getChallengeSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallengeSessions(_response);
        });
    }

    protected processGetChallengeSessions(response: Response): Promise<QueryOfChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfChallengeSession>(null as any);
    }

    /**
     * Post a new challenge session.
     */
    postChallengeSession(body: ChallengeSessionCreation): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostChallengeSession(_response);
        });
    }

    protected processPostChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    /**
     * Get a specific challenge session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getChallengeSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallengeSession(_response);
        });
    }

    protected processGetChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    /**
     * Patch an existing challenge session.
     * @param auditAnnotation (optional) 
     */
    patchChallengeSession(body: ChallengeSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<ChallengeSession> {
        let url_ = this.baseUrl + "/api/v3/challengesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchChallengeSession(_response);
        });
    }

    protected processPatchChallengeSession(response: Response): Promise<ChallengeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChallengeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeSession>(null as any);
    }

    /**
     * Get all configuration items.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getConfigurableDataItems(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfConfigurableDataItem> {
        let url_ = this.baseUrl + "/api/v3/configurabledataitems?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfigurableDataItems(_response);
        });
    }

    protected processGetConfigurableDataItems(response: Response): Promise<QueryOfConfigurableDataItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfConfigurableDataItem;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfConfigurableDataItem>(null as any);
    }

    /**
     * Get all cough analysis set comments.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSetComments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetComments(_response);
        });
    }

    protected processGetCoughAnalysisSetComments(response: Response): Promise<QueryOfCoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSetComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSetComment>(null as any);
    }

    /**
     * Post a cough analysis set event comment.
     */
    postCoughAnalysisSetComment(body: CoughAnalysisSetCommentCreation): Promise<CoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSetComment(_response);
        });
    }

    protected processPostCoughAnalysisSetComment(response: Response): Promise<CoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetComment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetComment>(null as any);
    }

    /**
     * Get a specific cough analysis set comment.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSetComment(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSetComment> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetComment(_response);
        });
    }

    protected processGetCoughAnalysisSetComment(response: Response): Promise<CoughAnalysisSetComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetComment>(null as any);
    }

    /**
     * Delete an existing cough analysis set event comment.
     */
    deleteCoughAnalysisSetComment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCoughAnalysisSetComment(_response);
        });
    }

    protected processDeleteCoughAnalysisSetComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all cough analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSetEvents(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetEvents(_response);
        });
    }

    protected processGetCoughAnalysisSetEvents(response: Response): Promise<QueryOfCoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSetEvent;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSetEvent>(null as any);
    }

    /**
     * Post a new cough analysis set event.
     */
    postCoughAnalysisSetEvent(body: CoughAnalysisSetEventCreation): Promise<CoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSetEvent(_response);
        });
    }

    protected processPostCoughAnalysisSetEvent(response: Response): Promise<CoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetEvent;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetEvent>(null as any);
    }

    /**
     * Get a specific cough analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSetEvent(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetEvent(_response);
        });
    }

    protected processGetCoughAnalysisSetEvent(response: Response): Promise<CoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetEvent;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetEvent>(null as any);
    }

    patchCoughAnalysisSetEvent(body: CoughAnalysisSetEventMutation, key: string, auditAnnotation?: string | null | undefined): Promise<CoughAnalysisSetEvent> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCoughAnalysisSetEvent(_response);
        });
    }

    protected processPatchCoughAnalysisSetEvent(response: Response): Promise<CoughAnalysisSetEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSetEvent;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSetEvent>(null as any);
    }

    /**
     * Delete an existing cough analysis set event comment.
     */
    deleteCoughAnalysisSetEvent(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissetevents/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCoughAnalysisSetEvent(_response);
        });
    }

    protected processDeleteCoughAnalysisSetEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all cough analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSets(_response);
        });
    }

    protected processGetCoughAnalysisSets(response: Response): Promise<QueryOfCoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSet>(null as any);
    }

    /**
     * Post a new cough analysis set.
     */
    postCoughAnalysisSet(body: CoughAnalysisSet): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughAnalysisSet(_response);
        });
    }

    protected processPostCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * Get a specific cough analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSet(_response);
        });
    }

    protected processGetCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * Create new cough analysis set with type WeeklyQA based on input cough analysis set with input external code
     * @param externalCode (optional) 
     */
    postWeeklyQA(externalCode?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissets/weeklyqa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalCode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostWeeklyQA(_response);
        });
    }

    protected processPostWeeklyQA(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get all the cough analysis set types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/coughanalysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughAnalysisSetTypes(_response);
        });
    }

    protected processGetCoughAnalysisSetTypes(response: Response): Promise<QueryOfCoughAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSetType>(null as any);
    }

    /**
     * Get all the default cough event types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughEventTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/cougheventtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughEventTypes(_response);
        });
    }

    protected processGetCoughEventTypes(response: Response): Promise<QueryOfCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughEventType>(null as any);
    }

    /**
     * Get all Cough sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSessions(_response);
        });
    }

    protected processGetCoughSessions(response: Response): Promise<QueryOfCoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughSession>(null as any);
    }

    /**
     * Post a new Cough session.
     */
    postCoughSession(body: CoughSessionCreation): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCoughSession(_response);
        });
    }

    protected processPostCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    /**
     * Get a specific Cough session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCoughSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSession(_response);
        });
    }

    protected processGetCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    /**
     * Patch an existing cough session.
     * @param auditAnnotation (optional) 
     */
    patchCoughSession(body: CoughSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<CoughSession> {
        let url_ = this.baseUrl + "/api/v3/coughsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCoughSession(_response);
        });
    }

    protected processPatchCoughSession(response: Response): Promise<CoughSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughSession>(null as any);
    }

    batchProcessCoughSessions(body: BatchProcessRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/coughsessions/batchprocess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBatchProcessCoughSessions(_response);
        });
    }

    protected processBatchProcessCoughSessions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all cough session statuses.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughSessionStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughSessionStatus> {
        let url_ = this.baseUrl + "/api/v3/coughsessionstatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughSessionStatuses(_response);
        });
    }

    protected processGetCoughSessionStatuses(response: Response): Promise<QueryOfCoughSessionStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughSessionStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughSessionStatus>(null as any);
    }

    /**
     * Get all cough waveform types
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCoughWaveformTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughWaveformType> {
        let url_ = this.baseUrl + "/api/v3/coughwaveformtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoughWaveformTypes(_response);
        });
    }

    protected processGetCoughWaveformTypes(response: Response): Promise<QueryOfCoughWaveformType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughWaveformType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughWaveformType>(null as any);
    }

    /**
     * Get all countries regardless of study association.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCountries(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCountry> {
        let url_ = this.baseUrl + "/api/v3/countries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<QueryOfCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCountry>(null as any);
    }

    /**
     * Get all custom calculations.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getCustomCalculations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomCalculations(_response);
        });
    }

    protected processGetCustomCalculations(response: Response): Promise<QueryOfCustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCustomCalculation>(null as any);
    }

    /**
     * Post a custom calculation
     */
    postCustomCalculation(body: CustomCalculationCreation): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCustomCalculation(_response);
        });
    }

    protected processPostCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    /**
     * Get a specific custom calculation.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getCustomCalculation(key: string, select?: string | undefined, expand?: string | undefined): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomCalculation(_response);
        });
    }

    protected processGetCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    /**
     * Patch a custom calculation
     * @param auditAnnotation (optional) 
     */
    patchCustomCalculation(body: CustomCalculationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<CustomCalculation> {
        let url_ = this.baseUrl + "/api/v3/customCalculations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchCustomCalculation(_response);
        });
    }

    protected processPatchCustomCalculation(response: Response): Promise<CustomCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomCalculation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomCalculation>(null as any);
    }

    /**
     * Get all configuration items.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDataItemConfigurations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDataItemConfigurations(_response);
        });
    }

    protected processGetDataItemConfigurations(response: Response): Promise<QueryOfDataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDataItemConfiguration>(null as any);
    }

    /**
     * Post a configuration item.
     */
    postDataItemConfiguration(body: DataItemConfigurationCreation): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDataItemConfiguration(_response);
        });
    }

    protected processPostDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    /**
     * Get a specific configuration item.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDataItemConfiguration(key: string, select?: string | undefined, expand?: string | undefined): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDataItemConfiguration(_response);
        });
    }

    protected processGetDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    /**
     * Patch a configuration item.
     * @param auditAnnotation (optional) 
     */
    patchDataItemConfiguration(body: DataItemConfigurationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DataItemConfiguration> {
        let url_ = this.baseUrl + "/api/v3/dataitemconfigurations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDataItemConfiguration(_response);
        });
    }

    protected processPatchDataItemConfiguration(response: Response): Promise<DataItemConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataItemConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataItemConfiguration>(null as any);
    }

    /**
     * Get all DCF correction types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfCorrectionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfCorrectionType> {
        let url_ = this.baseUrl + "/api/v3/dcfcorrectiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfCorrectionTypes(_response);
        });
    }

    protected processGetDcfCorrectionTypes(response: Response): Promise<QueryOfDcfCorrectionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfCorrectionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfCorrectionType>(null as any);
    }

    /**
     * Get all DCF Requests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfRequests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequests(_response);
        });
    }

    protected processGetDcfRequests(response: Response): Promise<QueryOfDcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfRequest>(null as any);
    }

    /**
     * Post a new DCF Request.
     */
    postDcfRequest(body: DcfRequestCreation): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDcfRequest(_response);
        });
    }

    protected processPostDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    /**
     * Get a specific DCF Request.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDcfRequest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequest(_response);
        });
    }

    protected processGetDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    /**
     * Patch an existing DCF Request.
     * @param auditAnnotation (optional) 
     */
    patchDcfRequest(body: DcfRequestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DcfRequest> {
        let url_ = this.baseUrl + "/api/v3/dcfrequests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDcfRequest(_response);
        });
    }

    protected processPatchDcfRequest(response: Response): Promise<DcfRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DcfRequest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DcfRequest>(null as any);
    }

    /**
     * Get all DCF Request statuses.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDcfRequestStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDcfRequestStatus> {
        let url_ = this.baseUrl + "/api/v3/dcfrequeststatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDcfRequestStatuses(_response);
        });
    }

    protected processGetDcfRequestStatuses(response: Response): Promise<QueryOfDcfRequestStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDcfRequestStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDcfRequestStatus>(null as any);
    }

    /**
     * Get all defined reports.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDefinedReports(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefinedReports(_response);
        });
    }

    protected processGetDefinedReports(response: Response): Promise<QueryOfDefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDefinedReport>(null as any);
    }

    /**
     * Post a new defined report.
     */
    postDefinedReport(body: DefinedReportCreation): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDefinedReport(_response);
        });
    }

    protected processPostDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    /**
     * Get a specific defined report.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDefinedReport(key: string, select?: string | undefined, expand?: string | undefined): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefinedReport(_response);
        });
    }

    protected processGetDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    /**
     * Patch a defined report.
     * @param auditAnnotation (optional) 
     */
    patchDefinedReport(body: DefinedReportMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DefinedReport> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDefinedReport(_response);
        });
    }

    protected processPatchDefinedReport(response: Response): Promise<DefinedReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinedReport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefinedReport>(null as any);
    }

    /**
     * Delete a defined report.
     */
    deleteDefinedReport(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/definedreports/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDefinedReport(_response);
        });
    }

    protected processDeleteDefinedReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all device audit trail entries.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDeviceAuditTrails(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceAuditTrails(_response);
        });
    }

    protected processGetDeviceAuditTrails(response: Response): Promise<QueryOfDeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDeviceAuditTrail;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDeviceAuditTrail>(null as any);
    }

    /**
     * Post a specific device audit trail entry.
     */
    postDeviceAuditTrail(body: DeviceAuditTrailCreation): Promise<DeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDeviceAuditTrail(_response);
        });
    }

    protected processPostDeviceAuditTrail(response: Response): Promise<DeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceAuditTrail;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceAuditTrail>(null as any);
    }

    /**
     * Get a specific device audit trail entry.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDeviceAuditTrail(key: string, select?: string | undefined, expand?: string | undefined): Promise<DeviceAuditTrail> {
        let url_ = this.baseUrl + "/api/v3/deviceaudittrail/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceAuditTrail(_response);
        });
    }

    protected processGetDeviceAuditTrail(response: Response): Promise<DeviceAuditTrail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceAuditTrail;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceAuditTrail>(null as any);
    }

    /**
     * Get the specific configuration file for a specific device
     */
    deviceConfiguration(body: ConfigurationRequest): Promise<DeviceConfiguration> {
        let url_ = this.baseUrl + "/api/v3/deviceconfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeviceConfiguration(_response);
        });
    }

    protected processDeviceConfiguration(response: Response): Promise<DeviceConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeviceConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceConfiguration>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDevices(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDevice> {
        let url_ = this.baseUrl + "/api/v3/devices?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: Response): Promise<QueryOfDevice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDevice;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDevice>(null as any);
    }

    /**
     * Handles creation of a new device
     */
    postDevice(body: DeviceCreation): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDevice(_response);
        });
    }

    protected processPostDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDevice(key: string, select?: string | undefined, expand?: string | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    /**
     * Handles editing of a device
     * @param auditAnnotation (optional) 
     */
    patchDevice(body: DeviceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDevice(_response);
        });
    }

    protected processPatchDevice(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    deleteDevice(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/devices/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevice(_response);
        });
    }

    protected processDeleteDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all device types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDeviceTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDeviceType> {
        let url_ = this.baseUrl + "/api/v3/devicetypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeviceTypes(_response);
        });
    }

    protected processGetDeviceTypes(response: Response): Promise<QueryOfDeviceType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDeviceType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDeviceType>(null as any);
    }

    /**
     * Get all diary compliances.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryCompliances(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryCompliances(_response);
        });
    }

    protected processGetDiaryCompliances(response: Response): Promise<QueryOfDiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryCompliance>(null as any);
    }

    /**
     * Post a new diary compliance.
     */
    postDiaryCompliance(body: DiaryComplianceCreation): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryCompliance(_response);
        });
    }

    protected processPostDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    /**
     * Get a specific diary compliance.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryCompliance(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryCompliance(_response);
        });
    }

    protected processGetDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    /**
     * Patch an exisiting diary compliance.
     * @param auditAnnotation (optional) 
     */
    patchDiaryCompliance(body: DiaryComplianceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiaryCompliance> {
        let url_ = this.baseUrl + "/api/v3/diarycompliance/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiaryCompliance(_response);
        });
    }

    protected processPatchDiaryCompliance(response: Response): Promise<DiaryCompliance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryCompliance;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryCompliance>(null as any);
    }

    /**
     * Get all diary configurations files.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryConfigurationFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryConfigurationFile> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurationfiles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryConfigurationFiles(_response);
        });
    }

    protected processGetDiaryConfigurationFiles(response: Response): Promise<QueryOfDiaryConfigurationFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryConfigurationFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryConfigurationFile>(null as any);
    }

    /**
     * Post a new diary configuration file.
     */
    postDiaryConfigurationFile(body: DiaryConfigurationFile): Promise<DiaryConfigurationFile> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurationfiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryConfigurationFile(_response);
        });
    }

    protected processPostDiaryConfigurationFile(response: Response): Promise<DiaryConfigurationFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryConfigurationFile;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryConfigurationFile>(null as any);
    }

    /**
     * Patch an exisiting diary configuration file.
     * @param auditAnnotation (optional) 
     */
    patchDiaryConfigurationFile(body: DiaryConfigurationFile, key: string, auditAnnotation?: string | null | undefined): Promise<DiaryConfigurationFile> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurationfiles/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiaryConfigurationFile(_response);
        });
    }

    protected processPatchDiaryConfigurationFile(response: Response): Promise<DiaryConfigurationFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryConfigurationFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryConfigurationFile>(null as any);
    }

    /**
     * Get all diary configurations.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryConfigurations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryConfiguration> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryConfigurations(_response);
        });
    }

    protected processGetDiaryConfigurations(response: Response): Promise<QueryOfDiaryConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryConfiguration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryConfiguration>(null as any);
    }

    /**
     * Post a new diary configuration.
     */
    postDiaryConfiguration(body: DiaryConfigurationCreation): Promise<DiaryConfiguration> {
        let url_ = this.baseUrl + "/api/v3/diaryconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryConfiguration(_response);
        });
    }

    protected processPostDiaryConfiguration(response: Response): Promise<DiaryConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryConfiguration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryConfiguration>(null as any);
    }

    /**
     * Get all diary package deployments.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryPackageDeployments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryPackageDeployment> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryPackageDeployments(_response);
        });
    }

    protected processGetDiaryPackageDeployments(response: Response): Promise<QueryOfDiaryPackageDeployment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryPackageDeployment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryPackageDeployment>(null as any);
    }

    /**
     * Post a new diary package deployment.
     */
    postDiaryPackageDeployment(body: DiaryPackageDeploymentCreation): Promise<DiaryPackageDeployment> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryPackageDeployment(_response);
        });
    }

    protected processPostDiaryPackageDeployment(response: Response): Promise<DiaryPackageDeployment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryPackageDeployment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryPackageDeployment>(null as any);
    }

    /**
     * Delete a specific diary package deployment.
     */
    deleteDiaryPackageDeployment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/diarypackagedeployments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDiaryPackageDeployment(_response);
        });
    }

    protected processDeleteDiaryPackageDeployment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all diary quality flags.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryQualityFlags(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryQualityFlag> {
        let url_ = this.baseUrl + "/api/v3/diaryqualityflags?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryQualityFlags(_response);
        });
    }

    protected processGetDiaryQualityFlags(response: Response): Promise<QueryOfDiaryQualityFlag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryQualityFlag;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryQualityFlag>(null as any);
    }

    /**
     * Get all diary resource strings.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryResourceStrings(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryResourceStrings(_response);
        });
    }

    protected processGetDiaryResourceStrings(response: Response): Promise<QueryOfDiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryResourceString;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryResourceString>(null as any);
    }

    /**
     * Post a new diary resource string.
     */
    postDiaryResourceString(body: DiaryResourceString): Promise<DiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryResourceString(_response);
        });
    }

    protected processPostDiaryResourceString(response: Response): Promise<DiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryResourceString;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryResourceString>(null as any);
    }

    /**
     * Get a specific diary resource string.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryResourceString(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryResourceString> {
        let url_ = this.baseUrl + "/api/v3/diaryresourcestrings/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryResourceString(_response);
        });
    }

    protected processGetDiaryResourceString(response: Response): Promise<DiaryResourceString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryResourceString;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryResourceString>(null as any);
    }

    /**
     * Get all diary sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiarySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiarySessions(_response);
        });
    }

    protected processGetDiarySessions(response: Response): Promise<QueryOfDiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiarySession>(null as any);
    }

    /**
     * Post a new diary session.
     */
    postDiarySession(body: DiarySessionCreation): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiarySession(_response);
        });
    }

    protected processPostDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    /**
     * Get a specific diary session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiarySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiarySession(_response);
        });
    }

    protected processGetDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    /**
     * Patch an exisiting diary session.
     * @param auditAnnotation (optional) 
     */
    patchDiarySession(body: DiarySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiarySession> {
        let url_ = this.baseUrl + "/api/v3/diarysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiarySession(_response);
        });
    }

    protected processPatchDiarySession(response: Response): Promise<DiarySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiarySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiarySession>(null as any);
    }

    /**
     * Get all diary tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDiaryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryTests(_response);
        });
    }

    protected processGetDiaryTests(response: Response): Promise<QueryOfDiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDiaryTest>(null as any);
    }

    /**
     * Post a new diary test.
     */
    postDiaryTest(body: DiaryTestCreation): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDiaryTest(_response);
        });
    }

    protected processPostDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    /**
     * Get a specific diary test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDiaryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiaryTest(_response);
        });
    }

    protected processGetDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    /**
     * Patch an exisiting diary test.
     * @param auditAnnotation (optional) 
     */
    patchDiaryTest(body: DiaryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DiaryTest> {
        let url_ = this.baseUrl + "/api/v3/diarytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDiaryTest(_response);
        });
    }

    protected processPatchDiaryTest(response: Response): Promise<DiaryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiaryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiaryTest>(null as any);
    }

    /**
     * Get all Directory files.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDirectoryFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFileViewModel> {
        let url_ = this.baseUrl + "/api/v3/directoryfiles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDirectoryFiles(_response);
        });
    }

    protected processGetDirectoryFiles(response: Response): Promise<QueryOfFileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFileViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFileViewModel>(null as any);
    }

    /**
     * Get all Dlco analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoAnalysisSets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSets(_response);
        });
    }

    protected processGetDlcoAnalysisSets(response: Response): Promise<QueryOfDlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoAnalysisSet>(null as any);
    }

    /**
     * Get a specific Dlco analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoAnalysisSets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSet(_response);
        });
    }

    protected processGetDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    /**
     * Post a new DLco analysis set.
     */
    postDlcoAnalysisSet(body: DlcoAnalysisSetCreation): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoAnalysisSet(_response);
        });
    }

    protected processPostDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    /**
     * Patch an existing DLco analysis set.
     * @param auditAnnotation (optional) 
     */
    patchDlcoAnalysisSet(body: DlcoAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoAnalysisSet(_response);
        });
    }

    protected processPatchDlcoAnalysisSet(response: Response): Promise<DlcoAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSet>(null as any);
    }

    /**
     * Get all dlco analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSetTests(_response);
        });
    }

    protected processGetDlcoAnalysisSetTests(response: Response): Promise<QueryOfDlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoAnalysisSetTest>(null as any);
    }

    /**
     * Post a new dlco analysis set test
     */
    postDlcoAnalysisSetTest(body: DlcoAnalysisSetTest): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoAnalysisSetTest(_response);
        });
    }

    protected processPostDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific dlco analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoAnalysisSetTest(_response);
        });
    }

    protected processGetDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    /**
     * Patch an dlco analysis set test
     * @param auditAnnotation (optional) 
     */
    patchDlcoAnalysisSetTest(body: DlcoAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoAnalysisSetTest(_response);
        });
    }

    protected processPatchDlcoAnalysisSetTest(response: Response): Promise<DlcoAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoAnalysisSetTest>(null as any);
    }

    /**
     * Get the DLco best testcalculation methods.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    dlcoCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/dlcocalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDlcoCalculationMethod(_response);
        });
    }

    protected processDlcoCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * Get the Kco best test calculation methods.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    kcoCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/kcocalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKcoCalculationMethod(_response);
        });
    }

    protected processKcoCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * Get the VA best test calculation methods.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    vaCalculationMethod(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCalculationMethod> {
        let url_ = this.baseUrl + "/api/v3/vacalculationmethod?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVaCalculationMethod(_response);
        });
    }

    protected processVaCalculationMethod(response: Response): Promise<QueryOfCalculationMethod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCalculationMethod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCalculationMethod>(null as any);
    }

    /**
     * Get all Dlco sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoSessions(_response);
        });
    }

    protected processGetDlcoSessions(response: Response): Promise<QueryOfDlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoSession>(null as any);
    }

    /**
     * Post a new Dlco session.
     */
    postDlcoSession(body: DlcoSessionCreation): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoSession(_response);
        });
    }

    protected processPostDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    /**
     * Get a specific Dlco session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoSession(_response);
        });
    }

    protected processGetDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    /**
     * Patch an existing Dlco session.
     * @param auditAnnotation (optional) 
     */
    patchDlcoSession(body: DlcoSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoSession> {
        let url_ = this.baseUrl + "/api/v3/dlcosessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoSession(_response);
        });
    }

    protected processPatchDlcoSession(response: Response): Promise<DlcoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoSession>(null as any);
    }

    /**
     * Get all Dlco tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getDlcoTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfDlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoTests(_response);
        });
    }

    protected processGetDlcoTests(response: Response): Promise<QueryOfDlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfDlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfDlcoTest>(null as any);
    }

    /**
     * Post a new Dlco test.
     */
    postDlcoTests(body: DlcoTestCreation): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDlcoTests(_response);
        });
    }

    protected processPostDlcoTests(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    /**
     * Get a specific Dlco test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getDlcoTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDlcoTest(_response);
        });
    }

    protected processGetDlcoTest(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    /**
     * Patch an existing Dlco test.
     * @param auditAnnotation (optional) 
     */
    patchDlcoTests(body: DlcoTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<DlcoTest> {
        let url_ = this.baseUrl + "/api/v3/dlcoTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDlcoTests(_response);
        });
    }

    protected processPatchDlcoTests(response: Response): Promise<DlcoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DlcoTest>(null as any);
    }

    /**
     * Get all ECG analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSets(_response);
        });
    }

    protected processGetEcgAnalysisSets(response: Response): Promise<QueryOfEcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSet>(null as any);
    }

    /**
     * Post a new ECG analysis set.
     */
    postEcgAnalysisSet(body: EcgAnalysisSetCreation): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgAnalysisSet(_response);
        });
    }

    protected processPostEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    /**
     * Get a specific ECG analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSet(_response);
        });
    }

    protected processGetEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    /**
     * Patch a ECG analysis set.
     * @param auditAnnotation (optional) 
     */
    patchEcgAnalysisSet(body: EcgAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgAnalysisSet(_response);
        });
    }

    protected processPatchEcgAnalysisSet(response: Response): Promise<EcgAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSet>(null as any);
    }

    /**
     * Get all ECG analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTests(_response);
        });
    }

    protected processGetEcgAnalysisSetTests(response: Response): Promise<QueryOfEcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSetTest>(null as any);
    }

    /**
     * Post a new ECG analysis set test
     */
    postEcgAnalysisSetTest(body: EcgAnalysisSetTest): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgAnalysisSetTest(_response);
        });
    }

    protected processPostEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific ECG analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTest(_response);
        });
    }

    protected processGetEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    /**
     * Patch a ECG analysis set test
     * @param auditAnnotation (optional) 
     */
    patchEcgAnalysisSetTest(body: EcgAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgAnalysisSetTest(_response);
        });
    }

    protected processPatchEcgAnalysisSetTest(response: Response): Promise<EcgAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgAnalysisSetTest>(null as any);
    }

    /**
     * Get all ECG analysis set types
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/ecganalysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgAnalysisSetTypes(_response);
        });
    }

    protected processGetEcgAnalysisSetTypes(response: Response): Promise<QueryOfEcgAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgAnalysisSetType>(null as any);
    }

    /**
     * Get all ECG sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgSessions(_response);
        });
    }

    protected processGetEcgSessions(response: Response): Promise<QueryOfEcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgSession>(null as any);
    }

    /**
     * Post a new ECG session.
     */
    postEcgSession(body: EcgSessionCreation): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgSession(_response);
        });
    }

    protected processPostEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    /**
     * Get a specific ECG session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgSession(_response);
        });
    }

    protected processGetEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    /**
     * Patch an exisiting ECG session.
     * @param auditAnnotation (optional) 
     */
    patchEcgSession(body: EcgSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgSession> {
        let url_ = this.baseUrl + "/api/v3/ecgsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgSession(_response);
        });
    }

    protected processPatchEcgSession(response: Response): Promise<EcgSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgSession>(null as any);
    }

    /**
     * Get all ECG tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getEcgTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfEcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgTests(_response);
        });
    }

    protected processGetEcgTests(response: Response): Promise<QueryOfEcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfEcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfEcgTest>(null as any);
    }

    /**
     * Post a new ECG test.
     */
    postEcgTest(body: EcgTestCreation): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEcgTest(_response);
        });
    }

    protected processPostEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    /**
     * Get a specific ECG test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getEcgTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEcgTest(_response);
        });
    }

    protected processGetEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    /**
     * Patch an exisiting ECG test.
     * @param auditAnnotation (optional) 
     */
    patchEcgTest(body: EcgTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<EcgTest> {
        let url_ = this.baseUrl + "/api/v3/ecgtests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEcgTest(_response);
        });
    }

    protected processPatchEcgTest(response: Response): Promise<EcgTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EcgTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcgTest>(null as any);
    }

    /**
     * Get all FENO quality check tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoQCs(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoQCs(_response);
        });
    }

    protected processGetFenoQCs(response: Response): Promise<QueryOfFenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoQC>(null as any);
    }

    /**
     * Post a new FENO quality check test.
     */
    postFenoQC(body: FenoQCCreation): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoQC(_response);
        });
    }

    protected processPostFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    /**
     * Get a specific FENO quality check test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoQC(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoQC(_response);
        });
    }

    protected processGetFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    /**
     * Patch an existing FENO quality check test.
     * @param auditAnnotation (optional) 
     */
    patchFenoQC(body: FenoQCMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoQC> {
        let url_ = this.baseUrl + "/api/v3/fenoqc/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoQC(_response);
        });
    }

    protected processPatchFenoQC(response: Response): Promise<FenoQC> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoQC;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoQC>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoSessions(_response);
        });
    }

    protected processGetFenoSessions(response: Response): Promise<QueryOfFenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoSession>(null as any);
    }

    /**
     * The POST endpoint for creating a new entity.
     */
    postFenoSession(body: FenoSessionCreation): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoSession(_response);
        });
    }

    protected processPostFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoSession(_response);
        });
    }

    protected processGetFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    /**
     * The PATCH endpoint for updating an entity.
     * @param auditAnnotation (optional) 
     */
    patchFenoSession(body: FenoSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoSession> {
        let url_ = this.baseUrl + "/api/v3/fenosessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoSession(_response);
        });
    }

    protected processPatchFenoSession(response: Response): Promise<FenoSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoSession;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFenoTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoTests(_response);
        });
    }

    protected processGetFenoTests(response: Response): Promise<QueryOfFenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFenoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFenoTest>(null as any);
    }

    /**
     * The POST endpoint for creating a new entity.
     */
    postFenoTest(body: FenoTestCreation): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFenoTest(_response);
        });
    }

    protected processPostFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFenoTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFenoTest(_response);
        });
    }

    protected processGetFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    /**
     * The PATCH endpoint for updating an entity.
     * @param auditAnnotation (optional) 
     */
    patchFenoTest(body: FenoTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FenoTest> {
        let url_ = this.baseUrl + "/api/v3/fenotests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFenoTest(_response);
        });
    }

    protected processPatchFenoTest(response: Response): Promise<FenoTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FenoTest;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FenoTest>(null as any);
    }

    /**
     * Get all files attachments.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFileAttachments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFileAttachment> {
        let url_ = this.baseUrl + "/api/v3/fileattachments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileAttachments(_response);
        });
    }

    protected processGetFileAttachments(response: Response): Promise<QueryOfFileAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFileAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFileAttachment>(null as any);
    }

    /**
     * Get all files.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFiles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFile> {
        let url_ = this.baseUrl + "/api/v3/files?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: Response): Promise<QueryOfFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFile>(null as any);
    }

    /**
     * Post a specific file
     */
    postFile(body: FileCreation): Promise<Device> {
        let url_ = this.baseUrl + "/api/v3/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFile(_response);
        });
    }

    protected processPostFile(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Device;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    /**
     * Get a specific file.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFile(key: string, select?: string | undefined, expand?: string | undefined): Promise<File> {
        let url_ = this.baseUrl + "/api/v3/files/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<File> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<File>(null as any);
    }

    /**
     * Delete a specific file.
     */
    deleteFile(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/files/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getFileStream(key: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v3/files/{key}/stream";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileStream(_response);
        });
    }

    protected processGetFileStream(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Appends the file contents to an existing upload
     */
    fileUpload(body: FileUpload): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v3/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFileUpload(_response);
        });
    }

    protected processFileUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes / cleans the partial upload state of a file upload
     */
    deleteFileUpload(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/FileUpload/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFileUpload(_response);
        });
    }

    protected processDeleteFileUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all fixed comments.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedComments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedComments(_response);
        });
    }

    protected processGetFixedComments(response: Response): Promise<QueryOfFixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedComment>(null as any);
    }

    /**
     * Post a new fixed comment.
     */
    postFixedComment(body: FixedCommentCreation): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFixedComment(_response);
        });
    }

    protected processPostFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    /**
     * Get a specific fixed comment.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFixedComment(key: string, select?: string | undefined, expand?: string | undefined): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedComment(_response);
        });
    }

    protected processGetFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    /**
     * Patch an existing fixed comment.
     * @param auditAnnotation (optional) 
     */
    patchFixedComment(body: FixedCommentCreation, key: string, auditAnnotation?: string | null | undefined): Promise<FixedComment> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFixedComment(_response);
        });
    }

    protected processPatchFixedComment(response: Response): Promise<FixedComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedComment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedComment>(null as any);
    }

    /**
     * Delete an existing fixed comment.
     */
    deleteFixedComment(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/fixedcomments/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFixedComment(_response);
        });
    }

    protected processDeleteFixedComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all fixed comment set entity types
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSetEntityTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSetEntityType> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsetentitytypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSetEntityTypes(_response);
        });
    }

    protected processGetFixedCommentSetEntityTypes(response: Response): Promise<QueryOfFixedCommentSetEntityType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSetEntityType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSetEntityType>(null as any);
    }

    /**
     * Get all fixed comments sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSets(_response);
        });
    }

    protected processGetFixedCommentSets(response: Response): Promise<QueryOfFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSet>(null as any);
    }

    /**
     * Post a new fixed comment set.
     */
    postFixedCommentSet(body: FixedCommentSet): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFixedCommentSet(_response);
        });
    }

    protected processPostFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    /**
     * Get a specific fixed comment set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFixedCommentSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSet(_response);
        });
    }

    protected processGetFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    /**
     * Patch an existing fixed comment set.
     * @param auditAnnotation (optional) 
     */
    patchFixedCommentSet(body: FixedCommentSet, key: string, auditAnnotation?: string | null | undefined): Promise<FixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFixedCommentSet(_response);
        });
    }

    protected processPatchFixedCommentSet(response: Response): Promise<FixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FixedCommentSet>(null as any);
    }

    /**
     * Get all fixed comment set types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFixedCommentSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFixedCommentSetType> {
        let url_ = this.baseUrl + "/api/v3/fixedcommentsettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFixedCommentSetTypes(_response);
        });
    }

    protected processGetFixedCommentSetTypes(response: Response): Promise<QueryOfFixedCommentSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFixedCommentSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFixedCommentSetType>(null as any);
    }

    /**
     * Get all FVC sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFvcSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcSessions(_response);
        });
    }

    protected processGetFvcSessions(response: Response): Promise<QueryOfFvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcSession>(null as any);
    }

    /**
     * Post a new FVC session.
     */
    postFvcSession(body: FvcSessionCreation): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFvcSession(_response);
        });
    }

    protected processPostFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    /**
     * Get a specific FVC session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFvcSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcSession(_response);
        });
    }

    protected processGetFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    /**
     * Patch an existing FVC session.
     * @param auditAnnotation (optional) 
     */
    patchFvcSession(body: FvcSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcSession> {
        let url_ = this.baseUrl + "/api/v3/fvcsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFvcSession(_response);
        });
    }

    protected processPatchFvcSession(response: Response): Promise<FvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcSession>(null as any);
    }

    /**
     * Get all FVC tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getFvcTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcTests(_response);
        });
    }

    protected processGetFvcTests(response: Response): Promise<QueryOfFvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcTest>(null as any);
    }

    /**
     * Post a new FVC test.
     */
    postFvcTest(body: FvcTestCreation): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostFvcTest(_response);
        });
    }

    protected processPostFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    /**
     * Get a specific FVC test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFvcTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFvcTest(_response);
        });
    }

    protected processGetFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    /**
     * Patch an existing FVC test.
     * @param auditAnnotation (optional) 
     */
    patchFvcTest(body: FvcTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcTest> {
        let url_ = this.baseUrl + "/api/v3/fvctests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFvcTest(_response);
        });
    }

    protected processPatchFvcTest(response: Response): Promise<FvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcTest>(null as any);
    }

    /**
     * Get all Inhaler Training sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getInhalerTrainingSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfInhalerTrainingSession> {
        let url_ = this.baseUrl + "/api/v3/inhalertrainingsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInhalerTrainingSessions(_response);
        });
    }

    protected processGetInhalerTrainingSessions(response: Response): Promise<QueryOfInhalerTrainingSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfInhalerTrainingSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfInhalerTrainingSession>(null as any);
    }

    /**
     * Post a new PCF session.
     */
    postInhalerTrainingSession(body: InhalerTrainingSessionCreation): Promise<InhalerTrainingSession> {
        let url_ = this.baseUrl + "/api/v3/inhalertrainingsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostInhalerTrainingSession(_response);
        });
    }

    protected processPostInhalerTrainingSession(response: Response): Promise<InhalerTrainingSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingSession>(null as any);
    }

    /**
     * Get a specific Inhaler Training session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getInhalerTrainingSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<InhalerTrainingSession> {
        let url_ = this.baseUrl + "/api/v3/inhalertrainingsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInhalerTrainingSession(_response);
        });
    }

    protected processGetInhalerTrainingSession(response: Response): Promise<InhalerTrainingSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingSession>(null as any);
    }

    /**
     * Patch an existing inhaler training session.
     * @param auditAnnotation (optional) 
     */
    patchInhalerTrainingSession(body: InhalerTrainingSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<InhalerTrainingSession> {
        let url_ = this.baseUrl + "/api/v3/inhalertrainingsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchInhalerTrainingSession(_response);
        });
    }

    protected processPatchInhalerTrainingSession(response: Response): Promise<InhalerTrainingSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingSession>(null as any);
    }

    /**
     * Get all inhaler training tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getInhalerTrainingTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfInhalerTrainingTest> {
        let url_ = this.baseUrl + "/api/v3/inhalerTrainingTests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInhalerTrainingTests(_response);
        });
    }

    protected processGetInhalerTrainingTests(response: Response): Promise<QueryOfInhalerTrainingTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfInhalerTrainingTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfInhalerTrainingTest>(null as any);
    }

    /**
     * Post a new inhaler training test.
     */
    postInhalerTrainingTest(body: InhalerTrainingTestCreation): Promise<InhalerTrainingTest> {
        let url_ = this.baseUrl + "/api/v3/inhalerTrainingTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostInhalerTrainingTest(_response);
        });
    }

    protected processPostInhalerTrainingTest(response: Response): Promise<InhalerTrainingTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingTest>(null as any);
    }

    /**
     * Get a specific inhaler training test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getInhalerTrainingTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<InhalerTrainingTest> {
        let url_ = this.baseUrl + "/api/v3/inhalerTrainingTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInhalerTrainingTest(_response);
        });
    }

    protected processGetInhalerTrainingTest(response: Response): Promise<InhalerTrainingTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingTest>(null as any);
    }

    /**
     * Patch an existing inhaler training test.
     * @param auditAnnotation (optional) 
     */
    patchInhalerTrainingTest(body: InhalerTrainingTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<InhalerTrainingTest> {
        let url_ = this.baseUrl + "/api/v3/inhalerTrainingTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchInhalerTrainingTest(_response);
        });
    }

    protected processPatchInhalerTrainingTest(response: Response): Promise<InhalerTrainingTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhalerTrainingTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InhalerTrainingTest>(null as any);
    }

    /**
     * Get all languages.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLanguages(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLanguage> {
        let url_ = this.baseUrl + "/api/v3/languages?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<QueryOfLanguage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLanguage;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLanguage>(null as any);
    }

    /**
     * Get all lung volume analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSets(_response);
        });
    }

    protected processGetLungVolumeAnalysisSets(response: Response): Promise<QueryOfLungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeAnalysisSet>(null as any);
    }

    /**
     * Post a new lv analysis set.
     */
    postLungVolumeAnalysisSet(body: LungVolumeAnalysisSetCreation): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeAnalysisSet(_response);
        });
    }

    protected processPostLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    /**
     * Get a specific lung volume analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSet(_response);
        });
    }

    protected processGetLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    /**
     * Patch an existing lv analysis set.
     * @param auditAnnotation (optional) 
     */
    patchLungVolumeAnalysisSet(body: LungVolumeAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeAnalysisSet(_response);
        });
    }

    protected processPatchLungVolumeAnalysisSet(response: Response): Promise<LungVolumeAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSet>(null as any);
    }

    /**
     * Get all lung volume analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSetTests(_response);
        });
    }

    protected processGetLungVolumeAnalysisSetTests(response: Response): Promise<QueryOfLungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * Post a new lung volume analysis set test
     */
    postLungVolumeAnalysisSetTest(body: LungVolumeAnalysisSetTest): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processPostLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific lung volume analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processGetLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * Patch an lung volume analysis set test
     * @param auditAnnotation (optional) 
     */
    patchLungVolumeAnalysisSetTest(body: LungVolumeAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumeanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeAnalysisSetTest(_response);
        });
    }

    protected processPatchLungVolumeAnalysisSetTest(response: Response): Promise<LungVolumeAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeAnalysisSetTest>(null as any);
    }

    /**
     * Get all lung volume sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeSessions(_response);
        });
    }

    protected processGetLungVolumeSessions(response: Response): Promise<QueryOfLungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeSession>(null as any);
    }

    /**
     * Post a new Lung Volume session.
     */
    postLungVolumeSession(body: LungVolumeSessionCreation): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeSession(_response);
        });
    }

    protected processPostLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    /**
     * Get a specific Lung Volume session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeSession(_response);
        });
    }

    protected processGetLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    /**
     * Patch an existing Lung Volume session.
     * @param auditAnnotation (optional) 
     */
    patchLungVolumeSession(body: LungVolumeSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeSession> {
        let url_ = this.baseUrl + "/api/v3/lungvolumesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeSession(_response);
        });
    }

    protected processPatchLungVolumeSession(response: Response): Promise<LungVolumeSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeSession;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeSession>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getLungVolumeTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfLungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeTests(_response);
        });
    }

    protected processGetLungVolumeTests(response: Response): Promise<QueryOfLungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfLungVolumeTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfLungVolumeTest>(null as any);
    }

    /**
     * The POST endpoint for creating a new entity.
     */
    postLungVolumeTest(body: LungVolumeTestCreation): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLungVolumeTest(_response);
        });
    }

    protected processPostLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    /**
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getLungVolumeTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLungVolumeTest(_response);
        });
    }

    protected processGetLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    /**
     * The PATCH endpoint for updating an entity.
     * @param auditAnnotation (optional) 
     */
    patchLungVolumeTest(body: LungVolumeTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<LungVolumeTest> {
        let url_ = this.baseUrl + "/api/v3/lungvolumetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchLungVolumeTest(_response);
        });
    }

    protected processPatchLungVolumeTest(response: Response): Promise<LungVolumeTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LungVolumeTest;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LungVolumeTest>(null as any);
    }

    /**
     * Get all mapped server directories.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMappedServerDirectories(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMappedServerDirectory> {
        let url_ = this.baseUrl + "/api/v3/mappedserverdirectories?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMappedServerDirectories(_response);
        });
    }

    protected processGetMappedServerDirectories(response: Response): Promise<QueryOfMappedServerDirectory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMappedServerDirectory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMappedServerDirectory>(null as any);
    }

    /**
     * Get a specific mapped server directories.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMappedServerDirectories2(key: string, select?: string | undefined, expand?: string | undefined): Promise<MappedServerDirectory> {
        let url_ = this.baseUrl + "/api/v3/mappedserverdirectories/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMappedServerDirectories2(_response);
        });
    }

    protected processGetMappedServerDirectories2(response: Response): Promise<MappedServerDirectory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MappedServerDirectory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MappedServerDirectory>(null as any);
    }

    /**
     * Get all medication records.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMedicationRecords(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationRecords(_response);
        });
    }

    protected processGetMedicationRecords(response: Response): Promise<QueryOfMedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMedicationRecord>(null as any);
    }

    /**
     * Post a new medication record.
     */
    postMedicationRecord(body: MedicationRecordCreation): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMedicationRecord(_response);
        });
    }

    protected processPostMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    /**
     * Get a specific medication record.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMedicationRecord(key: string, select?: string | undefined, expand?: string | undefined): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationRecord(_response);
        });
    }

    protected processGetMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    /**
     * Patch an existing medication record.
     * @param auditAnnotation (optional) 
     */
    patchMedicationRecord(body: MedicationRecordMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MedicationRecord> {
        let url_ = this.baseUrl + "/api/v3/medicationrecords/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMedicationRecord(_response);
        });
    }

    protected processPatchMedicationRecord(response: Response): Promise<MedicationRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedicationRecord;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationRecord>(null as any);
    }

    /**
     * Get all MEP analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSets(_response);
        });
    }

    protected processGetMepAnalysisSets(response: Response): Promise<QueryOfMepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepAnalysisSet>(null as any);
    }

    /**
     * Post a new MEP analysis set.
     */
    postMepAnalysisSet(body: MepAnalysisSetCreation): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepAnalysisSet(_response);
        });
    }

    protected processPostMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    /**
     * Get a specific MEP analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSet(_response);
        });
    }

    protected processGetMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    /**
     * Patch an existing MEP analysis set.
     * @param auditAnnotation (optional) 
     */
    patchMepAnalysisSet(body: MepAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepAnalysisSet(_response);
        });
    }

    protected processPatchMepAnalysisSet(response: Response): Promise<MepAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSet>(null as any);
    }

    /**
     * Get all MEP analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSetTests(_response);
        });
    }

    protected processGetMepAnalysisSetTests(response: Response): Promise<QueryOfMepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepAnalysisSetTest>(null as any);
    }

    /**
     * Post a new MEP analysis set test.
     */
    postMepAnalysisSetTest(body: MepAnalysisSetTestCreation): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepAnalysisSetTest(_response);
        });
    }

    protected processPostMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific MEP analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepAnalysisSetTest(_response);
        });
    }

    protected processGetMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    /**
     * Patch an MEP analysis set test.
     * @param auditAnnotation (optional) 
     */
    patchMepAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mepanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepAnalysisSetTest(_response);
        });
    }

    protected processPatchMepAnalysisSetTest(response: Response): Promise<MepAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepAnalysisSetTest>(null as any);
    }

    /**
     * Get all MEP sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepSessions(_response);
        });
    }

    protected processGetMepSessions(response: Response): Promise<QueryOfMepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepSession>(null as any);
    }

    /**
     * Post a new MEP session.
     */
    postMepSession(body: MepSessionCreation): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepSession(_response);
        });
    }

    protected processPostMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    /**
     * Get a specific MEP session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepSession(_response);
        });
    }

    protected processGetMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    /**
     * Patch an existing MEP session.
     * @param auditAnnotation (optional) 
     */
    patchMepSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepSession> {
        let url_ = this.baseUrl + "/api/v3/mepsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepSession(_response);
        });
    }

    protected processPatchMepSession(response: Response): Promise<MepSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepSession>(null as any);
    }

    /**
     * Get all MEP tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMepTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepTests(_response);
        });
    }

    protected processGetMepTests(response: Response): Promise<QueryOfMepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMepTest>(null as any);
    }

    /**
     * Post a new MEP test.
     */
    postMepTest(body: MepTestCreation): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMepTest(_response);
        });
    }

    protected processPostMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    /**
     * Get a specific MEP test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMepTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMepTest(_response);
        });
    }

    protected processGetMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    /**
     * Patch an existing MEP test.
     * @param auditAnnotation (optional) 
     */
    patchMepTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MepTest> {
        let url_ = this.baseUrl + "/api/v3/meptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMepTest(_response);
        });
    }

    protected processPatchMepTest(response: Response): Promise<MepTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MepTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MepTest>(null as any);
    }

    /**
     * Get all MIP analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSets(_response);
        });
    }

    protected processGetMipAnalysisSets(response: Response): Promise<QueryOfMipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipAnalysisSet>(null as any);
    }

    /**
     * Post a new MIP analysis set.
     */
    postMipAnalysisSet(body: MipAnalysisSetCreation): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipAnalysisSet(_response);
        });
    }

    protected processPostMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    /**
     * Get a specific MIP analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSet(_response);
        });
    }

    protected processGetMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    /**
     * Patch an existing MIP analysis set.
     * @param auditAnnotation (optional) 
     */
    patchMipAnalysisSet(body: MipAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipAnalysisSet(_response);
        });
    }

    protected processPatchMipAnalysisSet(response: Response): Promise<MipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSet>(null as any);
    }

    /**
     * Get all MIP analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSetTests(_response);
        });
    }

    protected processGetMipAnalysisSetTests(response: Response): Promise<QueryOfMipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipAnalysisSetTest>(null as any);
    }

    /**
     * Post a new MIP analysis set test.
     */
    postMipAnalysisSetTest(body: MipAnalysisSetTestCreation): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipAnalysisSetTest(_response);
        });
    }

    protected processPostMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific MIP analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipAnalysisSetTest(_response);
        });
    }

    protected processGetMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    /**
     * Patch an MIP analysis set test.
     * @param auditAnnotation (optional) 
     */
    patchMipAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/mipanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipAnalysisSetTest(_response);
        });
    }

    protected processPatchMipAnalysisSetTest(response: Response): Promise<MipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipAnalysisSetTest>(null as any);
    }

    /**
     * Get all MIP sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipSessions(_response);
        });
    }

    protected processGetMipSessions(response: Response): Promise<QueryOfMipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipSession>(null as any);
    }

    /**
     * Post a new MIP session.
     */
    postMipSession(body: MipSessionCreation): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipSession(_response);
        });
    }

    protected processPostMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    /**
     * Get a specific MIP session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipSession(_response);
        });
    }

    protected processGetMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    /**
     * Patch an existing MIP session.
     * @param auditAnnotation (optional) 
     */
    patchMipSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipSession> {
        let url_ = this.baseUrl + "/api/v3/mipsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipSession(_response);
        });
    }

    protected processPatchMipSession(response: Response): Promise<MipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipSession>(null as any);
    }

    /**
     * Get all MIP tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMipTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipTests(_response);
        });
    }

    protected processGetMipTests(response: Response): Promise<QueryOfMipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMipTest>(null as any);
    }

    /**
     * Post a new MIP test.
     */
    postMipTest(body: MipTestCreation): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMipTest(_response);
        });
    }

    protected processPostMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    /**
     * Get a specific MIP test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMipTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMipTest(_response);
        });
    }

    protected processGetMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    /**
     * Patch an existing MIP test.
     * @param auditAnnotation (optional) 
     */
    patchMipTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<MipTest> {
        let url_ = this.baseUrl + "/api/v3/miptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMipTest(_response);
        });
    }

    protected processPatchMipTest(response: Response): Promise<MipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MipTest>(null as any);
    }

    /**
     * Get all miscellaneous fields.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getMiscellaneousFields(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfMiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMiscellaneousFields(_response);
        });
    }

    protected processGetMiscellaneousFields(response: Response): Promise<QueryOfMiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfMiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfMiscField>(null as any);
    }

    /**
     * Post a new miscellaneous field.
     */
    postMiscellaneousField(body: MiscFieldCreation): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostMiscellaneousField(_response);
        });
    }

    protected processPostMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    /**
     * Get a specific miscellaneous field.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getMiscellaneousField(key: string, select?: string | undefined, expand?: string | undefined): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMiscellaneousField(_response);
        });
    }

    protected processGetMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    /**
     * Patch an existing miscellaneous field.
     * @param auditAnnotation (optional) 
     */
    patchMiscellaneousField(body: MiscFieldMuation, key: string, auditAnnotation?: string | null | undefined): Promise<MiscField> {
        let url_ = this.baseUrl + "/api/v3/miscellaneous/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMiscellaneousField(_response);
        });
    }

    protected processPatchMiscellaneousField(response: Response): Promise<MiscField> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MiscField;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscField>(null as any);
    }

    /**
     * Get all notification subscriptions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getNotificationSubscriptions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfNotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationSubscriptions(_response);
        });
    }

    protected processGetNotificationSubscriptions(response: Response): Promise<QueryOfNotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfNotificationSubscription;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfNotificationSubscription>(null as any);
    }

    /**
     * Post a new notification subscription.
     */
    postNotificationSubscription(body: NotificationSubscriptionCreation): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostNotificationSubscription(_response);
        });
    }

    protected processPostNotificationSubscription(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationSubscription;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    /**
     * Get a specific notification subscription.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getNotificationSubscription(key: string, select?: string | undefined, expand?: string | undefined): Promise<NotificationSubscription> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationSubscription(_response);
        });
    }

    protected processGetNotificationSubscription(response: Response): Promise<NotificationSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationSubscription;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription>(null as any);
    }

    /**
     * Patch an existing notification subscription.
     * @param auditAnnotation (optional) 
     */
    patchNotificationSubscription(body: NotificationSubscriptionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Alert> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchNotificationSubscription(_response);
        });
    }

    protected processPatchNotificationSubscription(response: Response): Promise<Alert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Alert;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alert>(null as any);
    }

    /**
     * Delete a specific notification subscription.
     */
    deleteNotificationSubscription(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/notificationsubscriptions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotificationSubscription(_response);
        });
    }

    protected processDeleteNotificationSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all Oscillometry analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSets(_response);
        });
    }

    protected processGetOscillometryAnalysisSets(response: Response): Promise<QueryOfOscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryAnalysisSet>(null as any);
    }

    /**
     * Post a new Oscillometry analysis set.
     */
    postOscillometryAnalysisSet(body: OscillometryAnalysisSetCreation): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryAnalysisSet(_response);
        });
    }

    protected processPostOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    /**
     * Get a specific Oscillometry analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/Oscillometryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSet(_response);
        });
    }

    protected processGetOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    /**
     * Patch an existing Oscillometry analysis set.
     * @param auditAnnotation (optional) 
     */
    patchOscillometryAnalysisSet(body: OscillometryAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryAnalysisSet(_response);
        });
    }

    protected processPatchOscillometryAnalysisSet(response: Response): Promise<OscillometryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSet>(null as any);
    }

    /**
     * Get all Oscillometry analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSetTests(_response);
        });
    }

    protected processGetOscillometryAnalysisSetTests(response: Response): Promise<QueryOfOscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryAnalysisSetTest>(null as any);
    }

    /**
     * Post a new Oscillometry analysis set test.
     */
    postOscillometryAnalysisSetTest(body: OscillometryAnalysisSetTestCreation): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryAnalysisSetTest(_response);
        });
    }

    protected processPostOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific Oscillometry analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryAnalysisSetTest(_response);
        });
    }

    protected processGetOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    /**
     * Patch an Oscillometry analysis set test.
     * @param auditAnnotation (optional) 
     */
    patchOscillometryAnalysisSetTest(body: OscillometryAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryAnalysisSetTest(_response);
        });
    }

    protected processPatchOscillometryAnalysisSetTest(response: Response): Promise<OscillometryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryAnalysisSetTest>(null as any);
    }

    /**
     * Get all Oscillometry sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometrySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometrySessions(_response);
        });
    }

    protected processGetOscillometrySessions(response: Response): Promise<QueryOfOscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometrySession>(null as any);
    }

    /**
     * Post a new Oscillometry session.
     */
    postOscillometrySession(body: OscillometrySessionCreation): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometrySession(_response);
        });
    }

    protected processPostOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    /**
     * Get a specific Oscillometry session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometrySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometrySession(_response);
        });
    }

    protected processGetOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    /**
     * Patch an existing Oscillometry session.
     * @param auditAnnotation (optional) 
     */
    patchOscillometrySession(body: OscillometrySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometrySession> {
        let url_ = this.baseUrl + "/api/v3/oscillometrysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometrySession(_response);
        });
    }

    protected processPatchOscillometrySession(response: Response): Promise<OscillometrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometrySession>(null as any);
    }

    /**
     * Get all Oscillometry tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOscillometryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryTests(_response);
        });
    }

    protected processGetOscillometryTests(response: Response): Promise<QueryOfOscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOscillometryTest>(null as any);
    }

    /**
     * Post a new Oscillometry test.
     */
    postOscillometryTest(body: OscillometryTestCreation): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostOscillometryTest(_response);
        });
    }

    protected processPostOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    /**
     * Get a specific Oscillometry test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getOscillometryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOscillometryTest(_response);
        });
    }

    protected processGetOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    /**
     * Patch an existing Oscillometry test.
     * @param auditAnnotation (optional) 
     */
    patchOscillometryTest(body: OscillometryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<OscillometryTest> {
        let url_ = this.baseUrl + "/api/v3/oscillometrytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchOscillometryTest(_response);
        });
    }

    protected processPatchOscillometryTest(response: Response): Promise<OscillometryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OscillometryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OscillometryTest>(null as any);
    }

    /**
     * Get all overread challenge statuses.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOverreadChallengeStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOverreadChallengeStatus> {
        let url_ = this.baseUrl + "/api/v3/overreadchallengestatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOverreadChallengeStatuses(_response);
        });
    }

    protected processGetOverreadChallengeStatuses(response: Response): Promise<QueryOfOverreadChallengeStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOverreadChallengeStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOverreadChallengeStatus>(null as any);
    }

    /**
     * Get all overread statuses.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getOverreadStatuses(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfOverreadStatus> {
        let url_ = this.baseUrl + "/api/v3/overreadstatuses?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOverreadStatuses(_response);
        });
    }

    protected processGetOverreadStatuses(response: Response): Promise<QueryOfOverreadStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfOverreadStatus;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfOverreadStatus>(null as any);
    }

    /**
     * Get all parameters.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getParameters(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfParameter> {
        let url_ = this.baseUrl + "/api/v3/parameters?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParameters(_response);
        });
    }

    protected processGetParameters(response: Response): Promise<QueryOfParameter> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfParameter;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfParameter>(null as any);
    }

    /**
     * Get all PCF analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSets(_response);
        });
    }

    protected processGetPcfAnalysisSets(response: Response): Promise<QueryOfPcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfAnalysisSet>(null as any);
    }

    /**
     * Post a new PCF analysis set.
     */
    postPcfAnalysisSet(body: PcfAnalysisSetCreation): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfAnalysisSet(_response);
        });
    }

    protected processPostPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    /**
     * Get a specific PCF analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSet(_response);
        });
    }

    protected processGetPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    /**
     * Patch an existing PCF analysis set.
     * @param auditAnnotation (optional) 
     */
    patchPcfAnalysisSet(body: PcfAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfAnalysisSet(_response);
        });
    }

    protected processPatchPcfAnalysisSet(response: Response): Promise<PcfAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSet>(null as any);
    }

    /**
     * Get all PCF analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSetTests(_response);
        });
    }

    protected processGetPcfAnalysisSetTests(response: Response): Promise<QueryOfPcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfAnalysisSetTest>(null as any);
    }

    /**
     * Post a new PCF analysis set test
     */
    postPcfAnalysisSetTest(body: PcfAnalysisSetTestCreation): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfAnalysisSetTest(_response);
        });
    }

    protected processPostPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific PCF analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfAnalysisSetTest(_response);
        });
    }

    protected processGetPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    /**
     * Patch an PCF analysis set test
     * @param auditAnnotation (optional) 
     */
    patchPcfAnalysisSetTest(body: PcfAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pcfanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfAnalysisSetTest(_response);
        });
    }

    protected processPatchPcfAnalysisSetTest(response: Response): Promise<PcfAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfAnalysisSetTest>(null as any);
    }

    /**
     * Get all PCF sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfSessions(_response);
        });
    }

    protected processGetPcfSessions(response: Response): Promise<QueryOfPcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfSession>(null as any);
    }

    /**
     * Post a new PCF session.
     */
    postPcfSession(body: PcfSessionCreation): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfSession(_response);
        });
    }

    protected processPostPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    /**
     * Get a specific PCF session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfSession(_response);
        });
    }

    protected processGetPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    /**
     * Patch an existing PCF session.
     * @param auditAnnotation (optional) 
     */
    patchPcfSession(body: PcfSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfSession> {
        let url_ = this.baseUrl + "/api/v3/pcfsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfSession(_response);
        });
    }

    protected processPatchPcfSession(response: Response): Promise<PcfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfSession>(null as any);
    }

    /**
     * Get all PCF tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPcfTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfTests(_response);
        });
    }

    protected processGetPcfTests(response: Response): Promise<QueryOfPcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPcfTest>(null as any);
    }

    /**
     * Post a new PCF test.
     */
    postPcfTest(body: PcfTestCreation): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPcfTest(_response);
        });
    }

    protected processPostPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    /**
     * Get a specific PCF test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPcfTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPcfTest(_response);
        });
    }

    protected processGetPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    /**
     * Patch an existing PCF test.
     * @param auditAnnotation (optional) 
     */
    patchPcfTest(body: PcfTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PcfTest> {
        let url_ = this.baseUrl + "/api/v3/pcftests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPcfTest(_response);
        });
    }

    protected processPatchPcfTest(response: Response): Promise<PcfTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PcfTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PcfTest>(null as any);
    }

    /**
     * Get all PEF analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSets(_response);
        });
    }

    protected processGetPefAnalysisSets(response: Response): Promise<QueryOfPefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefAnalysisSet>(null as any);
    }

    /**
     * Get a specific PEF analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSet(_response);
        });
    }

    protected processGetPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    /**
     * Patch an existing PEF analysis set.
     * @param auditAnnotation (optional) 
     */
    patchPefAnalysisSet(body: PefAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefAnalysisSet(_response);
        });
    }

    protected processPatchPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    /**
     * Post a new PEF analysis set.
     */
    postPefAnalysisSet(body: PefAnalysisSetCreation): Promise<PefAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefAnalysisSet(_response);
        });
    }

    protected processPostPefAnalysisSet(response: Response): Promise<PefAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSet>(null as any);
    }

    /**
     * Get all PEF analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSetTests(_response);
        });
    }

    protected processGetPefAnalysisSetTests(response: Response): Promise<QueryOfPefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefAnalysisSetTest>(null as any);
    }

    /**
     * Post a new PEF analysis set test
     */
    postPefAnalysisSetTest(body: PefAnalysisSetTestCreation): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefAnalysisSetTest(_response);
        });
    }

    protected processPostPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific PEF analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefAnalysisSetTest(_response);
        });
    }

    protected processGetPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    /**
     * Patch an PEF analysis set test
     * @param auditAnnotation (optional) 
     */
    patchPefAnalysisSetTest(body: PefAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pefAnalysisSetTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefAnalysisSetTest(_response);
        });
    }

    protected processPatchPefAnalysisSetTest(response: Response): Promise<PefAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefAnalysisSetTest>(null as any);
    }

    /**
     * Get all PEF sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefSession> {
        let url_ = this.baseUrl + "/api/v3/pefsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefSessions(_response);
        });
    }

    protected processGetPefSessions(response: Response): Promise<QueryOfPefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefSession>(null as any);
    }

    /**
     * Get a specific PEF session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/pefsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefSession(_response);
        });
    }

    protected processGetPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    /**
     * Post a new PEF session.
     */
    postPefSession(body: PefSessionCreation): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/PefSessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefSession(_response);
        });
    }

    protected processPostPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    /**
     * Patch an existing PEF session.
     * @param auditAnnotation (optional) 
     */
    patchPefSession(body: PefSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefSession> {
        let url_ = this.baseUrl + "/api/v3/PefSessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefSession(_response);
        });
    }

    protected processPatchPefSession(response: Response): Promise<PefSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefSession>(null as any);
    }

    /**
     * Get all PEF tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPefTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPefTest> {
        let url_ = this.baseUrl + "/api/v3/peftests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefTests(_response);
        });
    }

    protected processGetPefTests(response: Response): Promise<QueryOfPefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPefTest>(null as any);
    }

    /**
     * Get a specific PEF test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPefTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPefTest(_response);
        });
    }

    protected processGetPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    /**
     * Patch an existing PEF test.
     * @param auditAnnotation (optional) 
     */
    patchPefTest(body: PefTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPefTest(_response);
        });
    }

    protected processPatchPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    /**
     * Post a new PEF test.
     */
    postPefTest(body: PefTestCreation): Promise<PefTest> {
        let url_ = this.baseUrl + "/api/v3/PefTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPefTest(_response);
        });
    }

    protected processPostPefTest(response: Response): Promise<PefTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PefTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PefTest>(null as any);
    }

    /**
     * Get all permission categories.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPermissionCategories(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPermissionCategory> {
        let url_ = this.baseUrl + "/api/v3/permissioncategories?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissionCategories(_response);
        });
    }

    protected processGetPermissionCategories(response: Response): Promise<QueryOfPermissionCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPermissionCategory;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPermissionCategory>(null as any);
    }

    /**
     * Get all permissions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPermissions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPermission> {
        let url_ = this.baseUrl + "/api/v3/permissions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<QueryOfPermission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPermission;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPermission>(null as any);
    }

    /**
     * Get all pft accuracy test measurements.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPftAccuracyTestMeasurements(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPftAccuracyTestMeasurement> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytestmeasurements?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftAccuracyTestMeasurements(_response);
        });
    }

    protected processGetPftAccuracyTestMeasurements(response: Response): Promise<QueryOfPftAccuracyTestMeasurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPftAccuracyTestMeasurement;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPftAccuracyTestMeasurement>(null as any);
    }

    /**
     * Post a new pft accuracy test measurement.
     */
    postPftAccuracyTestMeasurement(body: PftAccuracyTestMeasurementCreation): Promise<PftAccuracyTestMeasurement> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytestmeasurements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPftAccuracyTestMeasurement(_response);
        });
    }

    protected processPostPftAccuracyTestMeasurement(response: Response): Promise<PftAccuracyTestMeasurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTestMeasurement;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTestMeasurement>(null as any);
    }

    /**
     * Get a specific pft accuracy test measurement.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPftAccuracyTestMeasurement(key: string, select?: string | undefined, expand?: string | undefined): Promise<PftAccuracyTestMeasurement> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytestmeasurements/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftAccuracyTestMeasurement(_response);
        });
    }

    protected processGetPftAccuracyTestMeasurement(response: Response): Promise<PftAccuracyTestMeasurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTestMeasurement;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTestMeasurement>(null as any);
    }

    /**
     * Patch an existing pft accuracy test measurement.
     * @param auditAnnotation (optional) 
     */
    patchPftAccuracyTestMeasurement(body: PftAccuracyTestMeasurementMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PftAccuracyTestMeasurement> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytestmeasurements/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPftAccuracyTestMeasurement(_response);
        });
    }

    protected processPatchPftAccuracyTestMeasurement(response: Response): Promise<PftAccuracyTestMeasurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTestMeasurement;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTestMeasurement>(null as any);
    }

    /**
     * Get all pft accuracy tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPftAccuracyTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPftAccuracyTest> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftAccuracyTests(_response);
        });
    }

    protected processGetPftAccuracyTests(response: Response): Promise<QueryOfPftAccuracyTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPftAccuracyTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPftAccuracyTest>(null as any);
    }

    /**
     * Post a new pft accuracy test.
     */
    postPftAccuracyTest(body: PftAccuracyTestCreation): Promise<PftAccuracyTest> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPftAccuracyTest(_response);
        });
    }

    protected processPostPftAccuracyTest(response: Response): Promise<PftAccuracyTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTest>(null as any);
    }

    /**
     * Get a specific pft accuracy test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPftAccuracyTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PftAccuracyTest> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftAccuracyTest(_response);
        });
    }

    protected processGetPftAccuracyTest(response: Response): Promise<PftAccuracyTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTest>(null as any);
    }

    /**
     * Patch an existing pft accuracy test.
     * @param auditAnnotation (optional) 
     */
    patchPftAccuracyTest(body: PftAccuracyTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PftAccuracyTest> {
        let url_ = this.baseUrl + "/api/v3/pftaccuracytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPftAccuracyTest(_response);
        });
    }

    protected processPatchPftAccuracyTest(response: Response): Promise<PftAccuracyTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftAccuracyTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftAccuracyTest>(null as any);
    }

    /**
     * Get all pft calibrations.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPftCalibrations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPftCalibration> {
        let url_ = this.baseUrl + "/api/v3/pftcalibrations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftCalibrations(_response);
        });
    }

    protected processGetPftCalibrations(response: Response): Promise<QueryOfPftCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPftCalibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPftCalibration>(null as any);
    }

    /**
     * Post a new pft calibration.
     */
    postPftCalibration(body: PftCalibrationCreation): Promise<PftCalibration> {
        let url_ = this.baseUrl + "/api/v3/pftcalibrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPftCalibration(_response);
        });
    }

    protected processPostPftCalibration(response: Response): Promise<PftCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftCalibration;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftCalibration>(null as any);
    }

    /**
     * Get a specific pft calibration.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPftCalibration(key: string, select?: string | undefined, expand?: string | undefined): Promise<PftCalibration> {
        let url_ = this.baseUrl + "/api/v3/pftcalibrations/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPftCalibration(_response);
        });
    }

    protected processGetPftCalibration(response: Response): Promise<PftCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftCalibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftCalibration>(null as any);
    }

    /**
     * Patch an existing pft calibration.
     * @param auditAnnotation (optional) 
     */
    patchPftCalibration(body: PftCalibrationMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PftCalibration> {
        let url_ = this.baseUrl + "/api/v3/pftcalibrations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPftCalibration(_response);
        });
    }

    protected processPatchPftCalibration(response: Response): Promise<PftCalibration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PftCalibration;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PftCalibration>(null as any);
    }

    /**
     * Get all phases.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPhases(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPhase> {
        let url_ = this.baseUrl + "/api/v3/phases?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPhases(_response);
        });
    }

    protected processGetPhases(response: Response): Promise<QueryOfPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPhase>(null as any);
    }

    /**
     * Get all population groups.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPopulationGroups(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPopulationGroups(_response);
        });
    }

    protected processGetPopulationGroups(response: Response): Promise<QueryOfPopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPopulationGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPopulationGroup>(null as any);
    }

    /**
     * Post a new population group.
     */
    postPopulationGroup(body: PopulationGroup): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPopulationGroup(_response);
        });
    }

    protected processPostPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    /**
     * Get a specific population group.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPopulationGroup(key: string, select?: string | undefined, expand?: string | undefined): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPopulationGroup(_response);
        });
    }

    protected processGetPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    /**
     * Patch a new population group.
     * @param auditAnnotation (optional) 
     */
    patchPopulationGroup(body: PopulationGroup, key: string, auditAnnotation?: string | null | undefined): Promise<PopulationGroup> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPopulationGroup(_response);
        });
    }

    protected processPatchPopulationGroup(response: Response): Promise<PopulationGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulationGroup;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PopulationGroup>(null as any);
    }

    deletePopulationGroup(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/populationgroups/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePopulationGroup(_response);
        });
    }

    protected processDeletePopulationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all predicted sets
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPredictedSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPredictedSet> {
        let url_ = this.baseUrl + "/api/v3/predictedsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPredictedSets(_response);
        });
    }

    protected processGetPredictedSets(response: Response): Promise<QueryOfPredictedSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPredictedSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPredictedSet>(null as any);
    }

    /**
     * Get all Pulse Oximetry analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSets(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSets(response: Response): Promise<QueryOfPulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryAnalysisSet>(null as any);
    }

    /**
     * Post a new Pulse Oximetry analysis set.
     */
    postPulseOximetryAnalysisSet(body: PulseOximetryAnalysisSet): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryAnalysisSet(_response);
        });
    }

    protected processPostPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    /**
     * Get a specific Pulse Oximetry analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSet(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    /**
     * Patch an existing Pulse Oximetry analysis set.
     * @param auditAnnotation (optional) 
     */
    patchPulseOximetryAnalysisSet(body: PulseOximetryAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryAnalysisSet(_response);
        });
    }

    protected processPatchPulseOximetryAnalysisSet(response: Response): Promise<PulseOximetryAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSet>(null as any);
    }

    /**
     * Get all Pulse Oximetry analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSetTests(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSetTests(response: Response): Promise<QueryOfPulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * Post a new Pulse Oximetry analysis set test.
     */
    postPulseOximetryAnalysisSetTest(body: PulseOximetryAnalysisSetTest): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processPostPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific Pulse Oximetry analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processGetPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * Patch an existing Pulse Oximetry analysis set test.
     * @param auditAnnotation (optional) 
     */
    patchPulseOximetryAnalysisSetTest(body: PulseOximetryAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryAnalysisSetTest(_response);
        });
    }

    protected processPatchPulseOximetryAnalysisSetTest(response: Response): Promise<PulseOximetryAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryAnalysisSetTest>(null as any);
    }

    /**
     * Get all Pulse Oximetry session.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetrySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetrySessions(_response);
        });
    }

    protected processGetPulseOximetrySessions(response: Response): Promise<QueryOfPulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetrySession>(null as any);
    }

    /**
     * Post a new Pulse Oximetry session.
     */
    postPulseOximetrySession(body: PulseOximetrySession): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetrySession(_response);
        });
    }

    protected processPostPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    /**
     * Get a specific Pulse Oximetry session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetrySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetrySession(_response);
        });
    }

    protected processGetPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    /**
     * Patch an existing Pulse Oximetry session.
     * @param auditAnnotation (optional) 
     */
    patchPulseOximetrySession(body: PulseOximetrySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetrySession> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetrySession(_response);
        });
    }

    protected processPatchPulseOximetrySession(response: Response): Promise<PulseOximetrySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetrySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetrySession>(null as any);
    }

    /**
     * Get all Pulse Oximetry tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getPulseOximetryTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfPulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryTests(_response);
        });
    }

    protected processGetPulseOximetryTests(response: Response): Promise<QueryOfPulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfPulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfPulseOximetryTest>(null as any);
    }

    /**
     * Post a new Pulse Oximetry test.
     */
    postPulseOximetryTest(body: PulseOximetryTest): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPulseOximetryTest(_response);
        });
    }

    protected processPostPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    /**
     * Get a specific Pulse Oximetry test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getPulseOximetryTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPulseOximetryTest(_response);
        });
    }

    protected processGetPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    /**
     * Patch an existing Pulse Oximetry test.
     * @param auditAnnotation (optional) 
     */
    patchPulseOximetryTest(body: PulseOximetryTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<PulseOximetryTest> {
        let url_ = this.baseUrl + "/api/v3/pulseoximetrytests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPulseOximetryTest(_response);
        });
    }

    protected processPatchPulseOximetryTest(response: Response): Promise<PulseOximetryTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PulseOximetryTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PulseOximetryTest>(null as any);
    }

    /**
     * Get all questionnaire test answers.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getQuestionnaireTestAnswers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfQuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTestAnswers(_response);
        });
    }

    protected processGetQuestionnaireTestAnswers(response: Response): Promise<QueryOfQuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfQuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfQuestionnaireTestAnswer>(null as any);
    }

    /**
     * Post a new questionnaire test answer.
     */
    postQuestionnaireTestAnswer(body: QuestionnaireTestAnswerCreation): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostQuestionnaireTestAnswer(_response);
        });
    }

    protected processPostQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    /**
     * Get a specific questionnaire test answer.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getQuestionnaireTestAnswer(key: string, select?: string | undefined, expand?: string | undefined): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTestAnswer(_response);
        });
    }

    protected processGetQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    /**
     * Patch an existing questionnaire test answer.
     * @param auditAnnotation (optional) 
     */
    patchQuestionnaireTestAnswer(body: QuestionnaireTestAnswerMutation, key: string, auditAnnotation?: string | null | undefined): Promise<QuestionnaireTestAnswer> {
        let url_ = this.baseUrl + "/api/v3/questionnairetestanswers/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchQuestionnaireTestAnswer(_response);
        });
    }

    protected processPatchQuestionnaireTestAnswer(response: Response): Promise<QuestionnaireTestAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTestAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTestAnswer>(null as any);
    }

    /**
     * Get all questionnaire tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getQuestionnaireTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfQuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTests(_response);
        });
    }

    protected processGetQuestionnaireTests(response: Response): Promise<QueryOfQuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfQuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfQuestionnaireTest>(null as any);
    }

    /**
     * Post a new questionniare test.
     */
    postQuestionnaireTest(body: QuestionnaireTestCreation): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostQuestionnaireTest(_response);
        });
    }

    protected processPostQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    /**
     * Get a specific questionnaire test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getQuestionnaireTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireTest(_response);
        });
    }

    protected processGetQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    /**
     * Patch an existing questionnaire test.
     * @param auditAnnotation (optional) 
     */
    patchQuestionnaireTest(body: QuestionnaireTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<QuestionnaireTest> {
        let url_ = this.baseUrl + "/api/v3/questionnairetests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchQuestionnaireTest(_response);
        });
    }

    protected processPatchQuestionnaireTest(response: Response): Promise<QuestionnaireTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireTest>(null as any);
    }

    /**
     * Get all core races.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRaces(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoreRace> {
        let url_ = this.baseUrl + "/api/v3/races?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRaces(_response);
        });
    }

    protected processGetRaces(response: Response): Promise<QueryOfCoreRace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoreRace;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoreRace>(null as any);
    }

    /**
     * Get all roles.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRoles(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfRole> {
        let url_ = this.baseUrl + "/api/v3/roles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<QueryOfRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfRole;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfRole>(null as any);
    }

    /**
     * Post a new role.
     */
    postRole(body: RoleCreation): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostRole(_response);
        });
    }

    protected processPostRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    /**
     * Get a specific role.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getRole(key: string, select?: string | undefined, expand?: string | undefined): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    /**
     * Patch a role.
     * @param auditAnnotation (optional) 
     */
    patchRole(body: RoleMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Role> {
        let url_ = this.baseUrl + "/api/v3/roles/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchRole(_response);
        });
    }

    protected processPatchRole(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Role;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(null as any);
    }

    /**
     * Get all Device Firmwares.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getServiceResources(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetServiceResources(_response);
        });
    }

    protected processGetServiceResources(response: Response): Promise<QueryOfServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfServiceResourceCreation>(null as any);
    }

    /**
     * Post a new Device Firmware.
     */
    postServiceResource(body: ServiceResourceCreation): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostServiceResource(_response);
        });
    }

    protected processPostServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    /**
     * Get a specific Device Firmware.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getServiceResource(key: string, select?: string | undefined, expand?: string | undefined): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetServiceResource(_response);
        });
    }

    protected processGetServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    /**
     * Patch an existing Device Firmware.
     * @param auditAnnotation (optional) 
     */
    patchServiceResource(body: ServiceResourceMutation, key: string, auditAnnotation?: string | null | undefined): Promise<ServiceResourceCreation> {
        let url_ = this.baseUrl + "/api/v3/serviceresources/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchServiceResource(_response);
        });
    }

    protected processPatchServiceResource(response: Response): Promise<ServiceResourceCreation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceResourceCreation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceResourceCreation>(null as any);
    }

    /**
     * Get all session attachnments.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionAttachments(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionAttachments(_response);
        });
    }

    protected processGetSessionAttachments(response: Response): Promise<QueryOfSessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionAttachment>(null as any);
    }

    /**
     * Post a specific file
     */
    postSessionAttachments(body: SessionAttachmentCreation): Promise<SessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSessionAttachments(_response);
        });
    }

    protected processPostSessionAttachments(response: Response): Promise<SessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionAttachment;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionAttachment>(null as any);
    }

    /**
     * Get a specific session attachment.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getFile2(key: string, select?: string | undefined, expand?: string | undefined): Promise<SessionAttachment> {
        let url_ = this.baseUrl + "/api/v3/sessionattachments/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile2(_response);
        });
    }

    protected processGetFile2(response: Response): Promise<SessionAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionAttachment;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionAttachment>(null as any);
    }

    /**
     * Get all session notes.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionNotes(_response);
        });
    }

    protected processGetSessionNotes(response: Response): Promise<QueryOfSessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionNote>(null as any);
    }

    /**
     * Post a new session note.
     */
    postSessionNote(body: SessionNoteCreation): Promise<SessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSessionNote(_response);
        });
    }

    protected processPostSessionNote(response: Response): Promise<SessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionNote>(null as any);
    }

    /**
     * Get a specific session note.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSessionNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<SessionNote> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionNote(_response);
        });
    }

    protected processGetSessionNote(response: Response): Promise<SessionNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SessionNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionNote>(null as any);
    }

    /**
     * patch existing session note.
     * @param auditAnnotation (optional) 
     */
    patchSessionNote(body: SessionNoteMutation, key: string, auditAnnotation?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/sessionnotes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSessionNote(_response);
        });
    }

    protected processPatchSessionNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSession> {
        let url_ = this.baseUrl + "/api/v3/sessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: Response): Promise<QueryOfSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSession>(null as any);
    }

    /**
     * Get a specific session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<Session> {
        let url_ = this.baseUrl + "/api/v3/sessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSession(_response);
        });
    }

    protected processGetSession(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Session;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(null as any);
    }

    /**
     * Get all session types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSessionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSessionType> {
        let url_ = this.baseUrl + "/api/v3/sessiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessionTypes(_response);
        });
    }

    protected processGetSessionTypes(response: Response): Promise<QueryOfSessionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSessionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSessionType>(null as any);
    }

    /**
     * Get all sites.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSites(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSite> {
        let url_ = this.baseUrl + "/api/v3/sites?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSites(_response);
        });
    }

    protected processGetSites(response: Response): Promise<QueryOfSite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSite;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSite>(null as any);
    }

    /**
     * Post a new site.
     */
    postSites(body: SiteCreation): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSites(_response);
        });
    }

    protected processPostSites(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    /**
     * Get a specific site.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSite(key: string, select?: string | undefined, expand?: string | undefined): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSite(_response);
        });
    }

    protected processGetSite(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    /**
     * Patch an existing site.
     * @param auditAnnotation (optional) 
     */
    patchSites(body: SiteMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Site> {
        let url_ = this.baseUrl + "/api/v3/sites/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSites(_response);
        });
    }

    protected processPatchSites(response: Response): Promise<Site> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Site;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Site>(null as any);
    }

    /**
     * Get all rest periods.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getRestPeriods(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRestPeriods(_response);
        });
    }

    protected processGetRestPeriods(response: Response): Promise<QueryOfSixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * Post a new rest period.
     */
    postRestPeriod(body: SixMinuteWalkRestPeriodCreation): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostRestPeriod(_response);
        });
    }

    protected processPostRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * Get a specific rest period.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getRestPeriod(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRestPeriod(_response);
        });
    }

    protected processGetRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * Patch an existing rest period.
     * @param auditAnnotation (optional) 
     */
    patchRestPeriod(body: SixMinuteWalkRestPeriodMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkRestPeriod> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalkrestperiods/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchRestPeriod(_response);
        });
    }

    protected processPatchRestPeriod(response: Response): Promise<SixMinuteWalkRestPeriod> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkRestPeriod;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkRestPeriod>(null as any);
    }

    /**
     * Get all six-minute-walk sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSixMinuteWalkSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkSessions(_response);
        });
    }

    protected processGetSixMinuteWalkSessions(response: Response): Promise<QueryOfSixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkSession>(null as any);
    }

    /**
     * Post a new six-minute-walk session.
     */
    postSixMinuteWalkSession(body: SixMinuteWalkSessionCreation): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSixMinuteWalkSession(_response);
        });
    }

    protected processPostSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    /**
     * Get a specific six-minute-walk session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSixMinuteWalkSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkSession(_response);
        });
    }

    protected processGetSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    /**
     * Patch an existing six-minute-walk session.
     * @param auditAnnotation (optional) 
     */
    patchSixMinuteWalkSession(body: SixMinuteWalkSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkSession> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalksessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSixMinuteWalkSession(_response);
        });
    }

    protected processPatchSixMinuteWalkSession(response: Response): Promise<SixMinuteWalkSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkSession>(null as any);
    }

    /**
     * Get all six-minute-walk tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSixMinuteWalkTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkTests(_response);
        });
    }

    protected processGetSixMinuteWalkTests(response: Response): Promise<QueryOfSixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSixMinuteWalkTest>(null as any);
    }

    /**
     * Post a new six-minute-walk test.
     */
    postSixMinuteWalkTest(body: SixMinuteWalkTestCreation): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSixMinuteWalkTest(_response);
        });
    }

    protected processPostSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    /**
     * Get a specific six-minute-walk test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSixMinuteWalkTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSixMinuteWalkTest(_response);
        });
    }

    protected processGetSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    /**
     * Patch an existing six-minute-walk test.
     * @param auditAnnotation (optional) 
     */
    patchSixMinuteWalkTest(body: SixMinuteWalkTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SixMinuteWalkTest> {
        let url_ = this.baseUrl + "/api/v3/sixminutewalktests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSixMinuteWalkTest(_response);
        });
    }

    protected processPatchSixMinuteWalkTest(response: Response): Promise<SixMinuteWalkTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SixMinuteWalkTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SixMinuteWalkTest>(null as any);
    }

    /**
     * Get all SNIP analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSets(_response);
        });
    }

    protected processGetSnipAnalysisSets(response: Response): Promise<QueryOfSnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipAnalysisSet>(null as any);
    }

    /**
     * Post a new SNIP analysis set.
     */
    postSnipAnalysisSet(body: SnipAnalysisSetCreation): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipAnalysisSet(_response);
        });
    }

    protected processPostSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    /**
     * Get a specific SNIP analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSet(_response);
        });
    }

    protected processGetSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    /**
     * Patch an existing SNIP analysis set.
     * @param auditAnnotation (optional) 
     */
    patchSnipAnalysisSet(body: SnipAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipAnalysisSet(_response);
        });
    }

    protected processPatchSnipAnalysisSet(response: Response): Promise<SnipAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSet>(null as any);
    }

    /**
     * Get all SNIP analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSetTests(_response);
        });
    }

    protected processGetSnipAnalysisSetTests(response: Response): Promise<QueryOfSnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipAnalysisSetTest>(null as any);
    }

    /**
     * Post a new SNIP analysis set test.
     */
    postSnipAnalysisSetTest(body: SnipAnalysisSetTestCreation): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipAnalysisSetTest(_response);
        });
    }

    protected processPostSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific SNIP analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipAnalysisSetTest(_response);
        });
    }

    protected processGetSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    /**
     * Patch an SNIP analysis set test.
     * @param auditAnnotation (optional) 
     */
    patchSnipAnalysisSetTest(body: PressureAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/snipanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipAnalysisSetTest(_response);
        });
    }

    protected processPatchSnipAnalysisSetTest(response: Response): Promise<SnipAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipAnalysisSetTest>(null as any);
    }

    /**
     * Get all SNIP sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipSessions(_response);
        });
    }

    protected processGetSnipSessions(response: Response): Promise<QueryOfSnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipSession>(null as any);
    }

    /**
     * Post a new SNIP session.
     */
    postSnipSession(body: SnipSessionCreation): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipSession(_response);
        });
    }

    protected processPostSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    /**
     * Get a specific SNIP session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipSession(_response);
        });
    }

    protected processGetSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    /**
     * Patch an existing SNIP session.
     * @param auditAnnotation (optional) 
     */
    patchSnipSession(body: PressureSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipSession> {
        let url_ = this.baseUrl + "/api/v3/snipsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipSession(_response);
        });
    }

    protected processPatchSnipSession(response: Response): Promise<SnipSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipSession>(null as any);
    }

    /**
     * Get all SNIP tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSnipTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipTests(_response);
        });
    }

    protected processGetSnipTests(response: Response): Promise<QueryOfSnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSnipTest>(null as any);
    }

    /**
     * Post a new SNIP test.
     */
    postSnipTest(body: SnipTestCreation): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSnipTest(_response);
        });
    }

    protected processPostSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    /**
     * Get a specific SNIP test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSnipTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSnipTest(_response);
        });
    }

    protected processGetSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    /**
     * Patch an existing SNIP test.
     * @param auditAnnotation (optional) 
     */
    patchSnipTest(body: PressureTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SnipTest> {
        let url_ = this.baseUrl + "/api/v3/sniptests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSnipTest(_response);
        });
    }

    protected processPatchSnipTest(response: Response): Promise<SnipTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnipTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnipTest>(null as any);
    }

    /**
     * Get all spirometry analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirometryAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSets(_response);
        });
    }

    protected processGetSpirometryAnalysisSets(response: Response): Promise<QueryOfFvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcAnalysisSet>(null as any);
    }

    /**
     * Post a new spirometry analysis set.
     */
    postSpirometryAnalysisSet(body: FvcAnalysisSetCreation): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSpirometryAnalysisSet(_response);
        });
    }

    protected processPostSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    /**
     * Get a specific spirometry analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSpirometryAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSet(_response);
        });
    }

    protected processGetSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    /**
     * Patch an existing spirometry analysis set.
     * @param auditAnnotation (optional) 
     */
    patchSpirometryAnalysisSet(body: FvcAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSpirometryAnalysisSet(_response);
        });
    }

    protected processPatchSpirometryAnalysisSet(response: Response): Promise<FvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSet>(null as any);
    }

    /**
     * Get all spirometry analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirometryAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfFvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSetTests(_response);
        });
    }

    protected processGetSpirometryAnalysisSetTests(response: Response): Promise<QueryOfFvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfFvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfFvcAnalysisSetTest>(null as any);
    }

    /**
     * Post a new spirometry analysis set test
     */
    postSpirometryAnalysisSetTest(body: FvcAnalysisSetTest): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSpirometryAnalysisSetTest(_response);
        });
    }

    protected processPostSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific spirometry analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSpirometryAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirometryAnalysisSetTest(_response);
        });
    }

    protected processGetSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    /**
     * Patch a spirometry analysis set test
     * @param auditAnnotation (optional) 
     */
    patchSpirometryAnalysisSetTest(body: FvcAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<FvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/spirometryanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSpirometryAnalysisSetTest(_response);
        });
    }

    protected processPatchSpirometryAnalysisSetTest(response: Response): Promise<FvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FvcAnalysisSetTest>(null as any);
    }

    /**
     * Get all core races.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSpirotracUserGroups(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSpirotracUserGroup> {
        let url_ = this.baseUrl + "/api/v3/spirotracusergroups?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpirotracUserGroups(_response);
        });
    }

    protected processGetSpirotracUserGroups(response: Response): Promise<QueryOfSpirotracUserGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSpirotracUserGroup;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSpirotracUserGroup>(null as any);
    }

    /**
     * Get all studies.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudies(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudy> {
        let url_ = this.baseUrl + "/api/v3/studies?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudies(_response);
        });
    }

    protected processGetStudies(response: Response): Promise<QueryOfStudy> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudy;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudy>(null as any);
    }

    /**
     * Post a new study.
     */
    postStudy(body: StudyCreation): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudy(_response);
        });
    }

    protected processPostStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * Get a specific study.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudy(key: string, select?: string | undefined, expand?: string | undefined): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudy(_response);
        });
    }

    protected processGetStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * Patch an existing study.
     * @param auditAnnotation (optional) 
     */
    patchStudy(body: StudyMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studies/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudy(_response);
        });
    }

    protected processPatchStudy(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * Get all study cough event types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyCoughEventTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCoughEventTypes(_response);
        });
    }

    protected processGetStudyCoughEventTypes(response: Response): Promise<QueryOfStudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyCoughEventType>(null as any);
    }

    /**
     * Post an new study cough event type.
     */
    postStudyCoughEventType(body: StudyCoughEventType): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudyCoughEventType(_response);
        });
    }

    protected processPostStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    /**
     * Get a specific study cough event type.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyCoughEventType(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCoughEventType(_response);
        });
    }

    protected processGetStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    /**
     * Patch an existing study cough event type.
     * @param auditAnnotation (optional) 
     */
    patchStudyCoughEventType(body: StudyCoughEventType, key: string, auditAnnotation?: string | null | undefined): Promise<StudyCoughEventType> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyCoughEventType(_response);
        });
    }

    protected processPatchStudyCoughEventType(response: Response): Promise<StudyCoughEventType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCoughEventType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCoughEventType>(null as any);
    }

    /**
     * Delete an existing study cough event type.
     */
    deleteStudyCoughEventType(key: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/studycougheventtypes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStudyCoughEventType(_response);
        });
    }

    protected processDeleteStudyCoughEventType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all study countries.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyCountries(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyCountry> {
        let url_ = this.baseUrl + "/api/v3/studycountries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyCountries(_response);
        });
    }

    protected processGetStudyCountries(response: Response): Promise<QueryOfStudyCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyCountry>(null as any);
    }

    /**
     * Patch an existing study country.
     * @param auditAnnotation (optional) 
     */
    patchStudyCountry(body: StudyCountry, key: string, auditAnnotation?: string | null | undefined): Promise<StudyCountry> {
        let url_ = this.baseUrl + "/api/v3/studycountries/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyCountry(_response);
        });
    }

    protected processPatchStudyCountry(response: Response): Promise<StudyCountry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyCountry;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyCountry>(null as any);
    }

    /**
     * Get all fixed comments sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyFixedCommentSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyFixedCommentSets(_response);
        });
    }

    protected processGetStudyFixedCommentSets(response: Response): Promise<QueryOfStudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyFixedCommentSet>(null as any);
    }

    /**
     * Post a new study fixed comment set.
     */
    postStudyFixedCommentSet(body: StudyFixedCommentSet): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudyFixedCommentSet(_response);
        });
    }

    protected processPostStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    /**
     * Get a specific fixed comment set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyFixedCommentSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyFixedCommentSet(_response);
        });
    }

    protected processGetStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    /**
     * Patch an existing fixed comment set.
     * @param auditAnnotation (optional) 
     */
    patchStudyFixedCommentSet(body: StudyFixedCommentSet, key: string, auditAnnotation?: string | null | undefined): Promise<StudyFixedCommentSet> {
        let url_ = this.baseUrl + "/api/v3/studyfixedcommentsets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyFixedCommentSet(_response);
        });
    }

    protected processPatchStudyFixedCommentSet(response: Response): Promise<StudyFixedCommentSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyFixedCommentSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyFixedCommentSet>(null as any);
    }

    /**
     * Get all study languages.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyLanguages(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyLanguage> {
        let url_ = this.baseUrl + "/api/v3/studylanguages?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyLanguages(_response);
        });
    }

    protected processGetStudyLanguages(response: Response): Promise<QueryOfStudyLanguage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyLanguage;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyLanguage>(null as any);
    }

    /**
     * Get all study phases.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySchedulePhases(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedulePhases(_response);
        });
    }

    protected processGetStudySchedulePhases(response: Response): Promise<QueryOfStudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyPhase>(null as any);
    }

    /**
     * Post a new study phase.
     */
    postStudySchedulePhase(body: StudyPhase): Promise<Study> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudySchedulePhase(_response);
        });
    }

    protected processPostStudySchedulePhase(response: Response): Promise<Study> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Study;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Study>(null as any);
    }

    /**
     * Get a specific study phases.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudySchedulePhase(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedulePhase(_response);
        });
    }

    protected processGetStudySchedulePhase(response: Response): Promise<StudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyPhase>(null as any);
    }

    /**
     * Patch an existing study phase.
     * @param auditAnnotation (optional) 
     */
    patchStudySchedulePhase(body: StudyPhase, key: string, auditAnnotation?: string | null | undefined): Promise<StudyPhase> {
        let url_ = this.baseUrl + "/api/v3/studyschedulephases/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudySchedulePhase(_response);
        });
    }

    protected processPatchStudySchedulePhase(response: Response): Promise<StudyPhase> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPhase;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyPhase>(null as any);
    }

    /**
     * Get all study schedules.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySchedules(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedules(_response);
        });
    }

    protected processGetStudySchedules(response: Response): Promise<QueryOfStudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudySchedule;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudySchedule>(null as any);
    }

    /**
     * Post a new study schedule.
     */
    postStudySchedule(body: StudyScheduleCreation): Promise<StudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostStudySchedule(_response);
        });
    }

    protected processPostStudySchedule(response: Response): Promise<StudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySchedule;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudySchedule>(null as any);
    }

    /**
     * Get a specific study schedule.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudySchedule(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudySchedule> {
        let url_ = this.baseUrl + "/api/v3/studyschedules/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySchedule(_response);
        });
    }

    protected processGetStudySchedule(response: Response): Promise<StudySchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySchedule;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudySchedule>(null as any);
    }

    /**
     * Get all study schedule sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyScheduleSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyScheduleSession> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleSessions(_response);
        });
    }

    protected processGetStudyScheduleSessions(response: Response): Promise<QueryOfStudyScheduleSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyScheduleSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyScheduleSession>(null as any);
    }

    /**
     * Get a specific study schedule session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyScheduleSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyScheduleSession> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleSession(_response);
        });
    }

    protected processGetStudyScheduleSession(response: Response): Promise<StudyScheduleSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyScheduleSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyScheduleSession>(null as any);
    }

    /**
     * Patch an existing study schedule session.
     * @param auditAnnotation (optional) 
     */
    patchStudyScheduleSession(body: StudyScheduleSession, key: string, auditAnnotation?: string | null | undefined): Promise<StudyScheduleSession> {
        let url_ = this.baseUrl + "/api/v3/studyschedulesessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStudyScheduleSession(_response);
        });
    }

    protected processPatchStudyScheduleSession(response: Response): Promise<StudyScheduleSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyScheduleSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyScheduleSession>(null as any);
    }

    /**
     * Get all study schedule visits.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudyScheduleVisits(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudyScheduleVisit> {
        let url_ = this.baseUrl + "/api/v3/studyschedulevisits?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleVisits(_response);
        });
    }

    protected processGetStudyScheduleVisits(response: Response): Promise<QueryOfStudyScheduleVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudyScheduleVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudyScheduleVisit>(null as any);
    }

    /**
     * Get a specific study schedule visit.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getStudyScheduleVisit(key: string, select?: string | undefined, expand?: string | undefined): Promise<StudyScheduleVisit> {
        let url_ = this.baseUrl + "/api/v3/studyschedulevisits/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyScheduleVisit(_response);
        });
    }

    protected processGetStudyScheduleVisit(response: Response): Promise<StudyScheduleVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyScheduleVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyScheduleVisit>(null as any);
    }

    /**
     * Get all study session types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getStudySessionTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfStudySessionType> {
        let url_ = this.baseUrl + "/api/v3/studysessiontypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudySessionTypes(_response);
        });
    }

    protected processGetStudySessionTypes(response: Response): Promise<QueryOfStudySessionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfStudySessionType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfStudySessionType>(null as any);
    }

    /**
     * Get all subject notes.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjectNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectNotes(_response);
        });
    }

    protected processGetSubjectNotes(response: Response): Promise<QueryOfSubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubjectNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubjectNote>(null as any);
    }

    /**
     * Post a new subject note.
     */
    postSubjectNote(body: SubjectNoteCreation): Promise<SubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSubjectNote(_response);
        });
    }

    protected processPostSubjectNote(response: Response): Promise<SubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectNote>(null as any);
    }

    /**
     * Get a specific subject note.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSubjectNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<SubjectNote> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectNote(_response);
        });
    }

    protected processGetSubjectNote(response: Response): Promise<SubjectNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectNote>(null as any);
    }

    /**
     * patch existing subject note.
     * @param auditAnnotation (optional) 
     */
    patchSubjectNote(body: SubjectNoteMutation, key: string, auditAnnotation?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/subjectnotes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSubjectNote(_response);
        });
    }

    protected processPatchSubjectNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all subjects.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjects(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubject> {
        let url_ = this.baseUrl + "/api/v3/subjects?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjects(_response);
        });
    }

    protected processGetSubjects(response: Response): Promise<QueryOfSubject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubject>(null as any);
    }

    /**
     * Post a new subject.
     */
    postSubjects(body: SubjectCreation): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSubjects(_response);
        });
    }

    protected processPostSubjects(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    /**
     * Get a specific subject.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSubject(key: string, select?: string | undefined, expand?: string | undefined): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubject(_response);
        });
    }

    protected processGetSubject(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    /**
     * Patch an existing subject.
     * @param auditAnnotation (optional) 
     */
    patchSubjects(body: SubjectMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Subject> {
        let url_ = this.baseUrl + "/api/v3/subjects/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSubjects(_response);
        });
    }

    protected processPatchSubjects(response: Response): Promise<Subject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subject;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subject>(null as any);
    }

    /**
     * Get all subject types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSubjectTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSubjectType> {
        let url_ = this.baseUrl + "/api/v3/subjecttypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubjectTypes(_response);
        });
    }

    protected processGetSubjectTypes(response: Response): Promise<QueryOfSubjectType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSubjectType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSubjectType>(null as any);
    }

    /**
     * Get all Survey answers.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSurveyAnswers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveyAnswers(_response);
        });
    }

    protected processGetSurveyAnswers(response: Response): Promise<QueryOfSurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSurveyAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSurveyAnswer>(null as any);
    }

    postSurveyAnswer(body: SurveyAnswerCreation): Promise<SurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSurveyAnswer(_response);
        });
    }

    protected processPostSurveyAnswer(response: Response): Promise<SurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyAnswer;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswer>(null as any);
    }

    /**
     * Get a specific survey answers.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSurveyAnswer(key: string, select?: string | undefined, expand?: string | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveyAnswer(_response);
        });
    }

    protected processGetSurveyAnswer(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    patchSurveyAnswer(body: SurveyAnswerMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SurveyAnswer> {
        let url_ = this.baseUrl + "/api/v3/surveyanswers/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSurveyAnswer(_response);
        });
    }

    protected processPatchSurveyAnswer(response: Response): Promise<SurveyAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyAnswer;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswer>(null as any);
    }

    /**
     * Get all Survey sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSurveySessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveySessions(_response);
        });
    }

    protected processGetSurveySessions(response: Response): Promise<QueryOfSurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSurveySession>(null as any);
    }

    postSurveySession(body: SurveySessionCreation): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSurveySession(_response);
        });
    }

    protected processPostSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    /**
     * Get a specific survey session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSurveySession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveySession(_response);
        });
    }

    protected processGetSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    patchSurveySession(body: SurveySessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSurveySession(_response);
        });
    }

    protected processPatchSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    putSurveySession(body: SurveySessionMutation, key: string): Promise<SurveySession> {
        let url_ = this.baseUrl + "/api/v3/surveysessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutSurveySession(_response);
        });
    }

    protected processPutSurveySession(response: Response): Promise<SurveySession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveySession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveySession>(null as any);
    }

    /**
     * Get all svc analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSets(_response);
        });
    }

    protected processGetSvcAnalysisSets(response: Response): Promise<QueryOfSvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSet>(null as any);
    }

    /**
     * Post a new svc analysis set.
     */
    postSvcAnalysisSet(body: SvcAnalysisSetCreation): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcAnalysisSet(_response);
        });
    }

    protected processPostSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    /**
     * Get a specific svc analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSet(_response);
        });
    }

    protected processGetSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    /**
     * Patch an existing svc analysis set.
     * @param auditAnnotation (optional) 
     */
    patchSvcAnalysisSet(body: SvcAnalysisSetMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissets/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcAnalysisSet(_response);
        });
    }

    protected processPatchSvcAnalysisSet(response: Response): Promise<SvcAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSet>(null as any);
    }

    /**
     * Get all SVC analysis set tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSetTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTests(_response);
        });
    }

    protected processGetSvcAnalysisSetTests(response: Response): Promise<QueryOfSvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSetTest>(null as any);
    }

    /**
     * Post a new SVC analysis set test
     */
    postSvcAnalysisSetTest(body: SvcAnalysisSetTest): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcAnalysisSetTest(_response);
        });
    }

    protected processPostSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    /**
     * Get a specific SVC analysis set test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcAnalysisSetTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTest(_response);
        });
    }

    protected processGetSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    /**
     * Patch an SVC analysis set test
     * @param auditAnnotation (optional) 
     */
    patchSvcAnalysisSetTest(body: SvcAnalysisSetTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcAnalysisSetTest> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcAnalysisSetTest(_response);
        });
    }

    protected processPatchSvcAnalysisSetTest(response: Response): Promise<SvcAnalysisSetTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcAnalysisSetTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcAnalysisSetTest>(null as any);
    }

    /**
     * Get all svc analysis set types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcAnalysisSetTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcAnalysisSetType> {
        let url_ = this.baseUrl + "/api/v3/svcanalysissettypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcAnalysisSetTypes(_response);
        });
    }

    protected processGetSvcAnalysisSetTypes(response: Response): Promise<QueryOfSvcAnalysisSetType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcAnalysisSetType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcAnalysisSetType>(null as any);
    }

    /**
     * Get all SVC sessions.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcSessions(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcSessions(_response);
        });
    }

    protected processGetSvcSessions(response: Response): Promise<QueryOfSvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcSession>(null as any);
    }

    /**
     * Post a new SVC session.
     */
    postSvcSession(body: SvcSessionCreation): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcSession(_response);
        });
    }

    protected processPostSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    /**
     * Get a specific SVC session.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcSession(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcSession(_response);
        });
    }

    protected processGetSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    /**
     * Patch an existing SVC session.
     * @param auditAnnotation (optional) 
     */
    patchSvcSession(body: SvcSessionMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcSession> {
        let url_ = this.baseUrl + "/api/v3/svcsessions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcSession(_response);
        });
    }

    protected processPatchSvcSession(response: Response): Promise<SvcSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcSession;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcSession>(null as any);
    }

    /**
     * Get all SVC tests.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getSvcTests(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfSvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcTests(_response);
        });
    }

    protected processGetSvcTests(response: Response): Promise<QueryOfSvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfSvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfSvcTest>(null as any);
    }

    /**
     * Post a new SVC test.
     */
    postSvcTest(body: SvcTestCreation): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSvcTest(_response);
        });
    }

    protected processPostSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    /**
     * Get a specific SVC test.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getSvcTest(key: string, select?: string | undefined, expand?: string | undefined): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSvcTest(_response);
        });
    }

    protected processGetSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    /**
     * Patch an existing SVC test.
     * @param auditAnnotation (optional) 
     */
    patchSvcTest(body: SvcTestMutation, key: string, auditAnnotation?: string | null | undefined): Promise<SvcTest> {
        let url_ = this.baseUrl + "/api/v3/svctests/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchSvcTest(_response);
        });
    }

    protected processPatchSvcTest(response: Response): Promise<SvcTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SvcTest;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SvcTest>(null as any);
    }

    /**
     * Get all test notes.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getTestNotes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfTestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTestNotes(_response);
        });
    }

    protected processGetTestNotes(response: Response): Promise<QueryOfTestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfTestNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfTestNote>(null as any);
    }

    /**
     * Post a new test note.
     */
    postTestNote(body: TestNoteCreation): Promise<TestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostTestNote(_response);
        });
    }

    protected processPostTestNote(response: Response): Promise<TestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestNote;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestNote>(null as any);
    }

    /**
     * Get a specific test note.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getTestNote(key: string, select?: string | undefined, expand?: string | undefined): Promise<TestNote> {
        let url_ = this.baseUrl + "/api/v3/testnotes/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTestNote(_response);
        });
    }

    protected processGetTestNote(response: Response): Promise<TestNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestNote;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestNote>(null as any);
    }

    /**
     * Post existing test note.
     * @param auditAnnotation (optional) 
     */
    patchTestNote(body: TestNoteMutation, key: string, auditAnnotation?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/testnotes/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchTestNote(_response);
        });
    }

    protected processPatchTestNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all session types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getTimeZones(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfTimeZone> {
        let url_ = this.baseUrl + "/api/v3/timezones?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: Response): Promise<QueryOfTimeZone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfTimeZone;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfTimeZone>(null as any);
    }

    /**
     * Get all unit types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUnitTypes(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfUnitType> {
        let url_ = this.baseUrl + "/api/v3/unittypes?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitTypes(_response);
        });
    }

    protected processGetUnitTypes(response: Response): Promise<QueryOfUnitType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfUnitType;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfUnitType>(null as any);
    }

    /**
     * Get all cough analysis sets.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUnrestrictedCoughAnalysisSets(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfCoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/unrestrictedcoughanalysissets?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnrestrictedCoughAnalysisSets(_response);
        });
    }

    protected processGetUnrestrictedCoughAnalysisSets(response: Response): Promise<QueryOfCoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfCoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfCoughAnalysisSet>(null as any);
    }

    /**
     * Get a specific cough analysis set.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getUnrestrictedCoughAnalysisSet(key: string, select?: string | undefined, expand?: string | undefined): Promise<CoughAnalysisSet> {
        let url_ = this.baseUrl + "/api/v3/unrestrictedcoughanalysissets/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnrestrictedCoughAnalysisSet(_response);
        });
    }

    protected processGetUnrestrictedCoughAnalysisSet(response: Response): Promise<CoughAnalysisSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoughAnalysisSet;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoughAnalysisSet>(null as any);
    }

    /**
     * Get all users.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getUsers(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfUser> {
        let url_ = this.baseUrl + "/api/v3/users?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<QueryOfUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfUser;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfUser>(null as any);
    }

    /**
     * Post a new user.
     */
    postUser(body: UserCreation): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostUser(_response);
        });
    }

    protected processPostUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * Get a specific user.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getUser(key: string, select?: string | undefined, expand?: string | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * Patch an existing user.
     * @param auditAnnotation (optional) 
     */
    patchUser(body: UserMutation, key: string, auditAnnotation?: string | null | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/v3/users/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchUser(_response);
        });
    }

    protected processPatchUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * Get all unit types.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getVisitObligations(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfVisitObligation> {
        let url_ = this.baseUrl + "/api/v3/visitobligations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisitObligations(_response);
        });
    }

    protected processGetVisitObligations(response: Response): Promise<QueryOfVisitObligation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfVisitObligation;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfVisitObligation>(null as any);
    }

    /**
     * Get all visits.
     * @param select (optional) Select specified properties to include in the response.
     * @param filter (optional) Filter the response with the specified conditions.
     * @param orderby (optional) Order the response by the specified properties.
     * @param expand (optional) Expand specified properies in the response.
     * @param top (optional) Return the specified number of results in the response.
     * @param skip (optional) Skip the specified number of results in the response.
     * @param apply (optional) Apply the specified aggregate methods to the response.
     * @param count (optional) Return an overall count of the results in the response.
     * @param compute (optional) Apply the specified compute methods in the response.
     * @param search (optional) Search the response for the given free text.
     */
    getVisits(select?: string | undefined, filter?: string | undefined, orderby?: string | undefined, expand?: string | undefined, top?: number | undefined, skip?: number | undefined, apply?: string | undefined, count?: boolean | undefined, compute?: string | undefined, search?: string | undefined): Promise<QueryOfVisit> {
        let url_ = this.baseUrl + "/api/v3/visits?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (apply === null)
            throw new Error("The parameter 'apply' cannot be null.");
        else if (apply !== undefined)
            url_ += "$apply=" + encodeURIComponent("" + apply) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        if (compute === null)
            throw new Error("The parameter 'compute' cannot be null.");
        else if (compute !== undefined)
            url_ += "$compute=" + encodeURIComponent("" + compute) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisits(_response);
        });
    }

    protected processGetVisits(response: Response): Promise<QueryOfVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOfVisit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOfVisit>(null as any);
    }

    /**
     * Post a new visit.
     */
    postVisit(body: VisitCreation): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostVisit(_response);
        });
    }

    protected processPostVisit(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }

    /**
     * Get a specific visit.
     * @param select (optional) Select specified properties to include in the response.
     * @param expand (optional) Expand specified properies in the response.
     */
    getVisit(key: string, select?: string | undefined, expand?: string | undefined): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "$expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisit(_response);
        });
    }

    protected processGetVisit(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }

    /**
     * Patch an exisiting visit.
     * @param auditAnnotation (optional) 
     */
    patchVisits(body: VisitMutation, key: string, auditAnnotation?: string | null | undefined): Promise<Visit> {
        let url_ = this.baseUrl + "/api/v3/visits/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Audit-Annotation": auditAnnotation !== undefined && auditAnnotation !== null ? "" + auditAnnotation : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchVisits(_response);
        });
    }

    protected processPatchVisits(response: Response): Promise<Visit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Visit;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Visit>(null as any);
    }
}

/** Defines the result of an OData query. */
export interface QueryOfAccessRequest {
    /** Entities returned by the query. */
    value?: AccessRequest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the access request model. */
export interface AccessRequest {
    /** Unique ID for the user */
    id?: string;
    /** The user's email address */
    email?: string | undefined;
    /** The user's full name */
    fullName?: string | undefined;
    /** Organization that user belongs to */
    organization?: string | undefined;
    /** User's country code */
    countryCode?: string | undefined;
    /** The request date and time */
    createdAt?: string;
    timeZoneId?: string | undefined;
    preferredLanguageCode?: string | undefined;
}

/** Class representing an API error */
export interface ErrorDto {
    /** Unique ID for the error */
    id?: string | undefined;
    /** A error code for the error */
    code?: string | undefined;
    /** The message content of the error */
    message?: string | undefined;
    /** The date and time the error was generated */
    generated?: string;
    /** Any additional metadata that relates to the error */
    meta?: any | undefined;
}

/** Class to define the access request creation model. */
export interface AccessRequestCreation {
    /** Unique ID for the user */
    id?: string;
}

export interface SingleResult {
    queryable?: any[] | undefined;
}

export interface SingleResultOfAccessRequest extends SingleResult {
    queryable?: AccessRequest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfAlertNotification {
    /** Entities returned by the query. */
    value?: AlertNotification[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents a record of a notification to a user of an alert */
export interface AlertNotificationMutation {
    /** Whether the notification has been read by the user or not */
    isRead?: boolean;
}

/** Represents a record of a notification to a user of an alert */
export interface AlertNotification extends AlertNotificationMutation {
    id?: string;
    /** The subscription the notification is part of */
    subscription?: NotificationSubscription | undefined;
    /** The alert that is being notificated */
    alert?: Alert | undefined;
    /** The date and time an alert notification occurred */
    occurred?: string;
}

export interface NotificationSubscriptionCreation {
    id?: string;
    pluginId?: string | undefined;
    pluginName?: string | undefined;
    notifyImmediately?: boolean;
    notifyAuthor?: boolean;
    notifySite?: boolean;
    active?: boolean;
    usersToNotifyIds?: string[] | undefined;
    rolesToNotifyIds?: string[] | undefined;
    rolesWithSitesToNotifyIds?: string[] | undefined;
    studyId?: string;
}

export interface NotificationSubscription extends NotificationSubscriptionCreation {
    usersToNotify?: User[] | undefined;
    rolesToNotify?: Role[] | undefined;
    rolesWithSitesToNotify?: Role[] | undefined;
}

export interface UserMutation {
    /** The user's email address */
    email?: string | undefined;
    /** Gets or sets the password */
    password?: string | undefined;
    /** Gets or sets the list of RoleIds to assign to the user */
    roleIds?: string[] | undefined;
    /** Gets or sets the site identifiers associated with this user */
    siteIds?: string[] | undefined;
    /** Gets or sets the EDiary PIN */
    eDiaryPin?: string | undefined;
    /** Gets or sets the Spirotrac User Group ID */
    spirotracUserGroupId?: string | undefined;
    /** Indicates whether or not a service account */
    isServiceAccount?: boolean;
    /** Indicates whether or not the user is registered for the mobile Spirometry app */
    isRegisteredForMobileApp?: boolean;
    /** Gets or sets the user's primary time zone */
    timeZoneId?: string | undefined;
    /** Indicates whether or not the user is disabled */
    isDisabled?: boolean;
    /** The user's first name */
    firstName?: string | undefined;
    /** The user's last name */
    lastName?: string | undefined;
    /** Gets or sets the user's primary country */
    countryId?: string | undefined;
    /** User's preferred language code, BCP-47 language tag format */
    preferredLanguageCode?: string | undefined;
}

export interface User extends UserMutation {
    /** Unique ID for the user */
    id?: string;
    /** Whether user has registered and requested access */
    hasRequest?: boolean;
    /** A collection of the roles that the user has */
    roles?: Role[] | undefined;
}

/** Class for the role mutation model. */
export interface RoleMutation {
    /** Unique identifier for the study. */
    studyId?: string | undefined;
    /** The name of the role. */
    name?: string | undefined;
    /** The unique identifiers of the role permissions. */
    permissionsIds?: string[] | undefined;
    /** The unique identifiers of the child roles. */
    childRolesIds?: string[] | undefined;
}

/** Class representing a role which is a collection of permissions. */
export interface Role extends RoleMutation {
    /** Unique identifier for the role. */
    id?: string;
    /** Study which the role belongs to */
    study?: Study | undefined;
    /** A collection of users that have the role */
    users?: User[] | undefined;
    /** A collection of permission within the role */
    permissions?: Permission[] | undefined;
    reports?: string[] | undefined;
}

/** Class to represent a study mutation */
export interface StudyMutation {
    /** The name of the study */
    name?: string | undefined;
    /** The study's protocol number */
    protocol?: string | undefined;
    /** A description of the study */
    description?: string | undefined;
    welcomeMessage?: string | undefined;
    logo?: string | undefined;
    logoMediaType?: string | undefined;
    targetSubjects?: number | undefined;
    targetSessions?: number | undefined;
    vitalographContactEmail?: string | undefined;
    sessionTypeIds?: string[] | undefined;
    countriesIds?: string[] | undefined;
    deviceTypeIds?: string[] | undefined;
    languageIds?: string[] | undefined;
    diaryConfiguration?: string | undefined;
    vitalRef?: string | undefined;
}

/** Class to represent a study creation. */
export interface StudyCreation extends StudyMutation {
    /** Unique ID of the study */
    id?: string;
}

/** Class to represent a study */
export interface Study extends StudyCreation {
    /** The date and time the study was created */
    created?: string;
    /** The date and time the study was modified */
    modified?: string;
    /** A collection of sites within the study */
    sites?: Site[] | undefined;
}

export interface SiteMutation {
    /** Id of the site. */
    id?: string;
    /** StudyId of the study which the site belongs to. */
    studyId?: string;
    /** SiteNumber of the site. */
    number?: string | undefined;
    /** Name of the site. */
    name?: string | undefined;
    /** Address of the site. */
    address?: string | undefined;
    /** Email address of the site. */
    email?: string | undefined;
    /** Phone number of the site. */
    phone?: string | undefined;
    /** Contact name for the site. */
    contact?: string | undefined;
    /** Fax number of the site. */
    fax?: string | undefined;
    /** Country which the site is in. */
    country?: string | undefined;
    /** TimeZone which the site is in. */
    timeZone?: string | undefined;
}

/** Class to represent a site */
export interface Site extends SiteMutation {
    /** The date and time the site was created */
    created?: string;
    /** The date and time the site was last modified */
    modified?: string;
    /** The study this site relates to */
    study?: Study | undefined;
    country?: string | undefined;
    /** A collection of subjects within this site */
    subjects?: Subject[] | undefined;
    /** The timezone in IANA format */
    timeZoneIana?: string | undefined;
}

/** Class to define the subject mutation model. */
export interface SubjectMutation {
    /** Site ID the subject belongs to. */
    siteId?: string;
    /** Population group ID the subject belongs to. */
    populationGroupId?: string | undefined;
    /** Status of the subject. */
    status?: string | undefined;
    /** Unique subject number. */
    number?: string | undefined;
    /** Alternative subject number. */
    alternativeNumber?: string | undefined;
    /** Gender of the subject. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Language code of the subject. */
    language?: string | undefined;
    /** Date of Birth of the subject, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM. */
    height?: number | undefined;
    /** Weight of subject in KG. */
    weight?: number | undefined;
    /** Body Mass Index of subject. */
    bmi?: number | undefined;
    /** Length of ulna in CM. */
    ulna?: number | undefined;
    /** Type of medication in use by subject. */
    medicationType?: string | undefined;
    /** Type of smoker the subject is. */
    smokerType?: string | undefined;
    /** Number of subject for randomization. */
    randomizationNumber?: string | undefined;
    /** Date of randomization, if specified the randomization number must be given. */
    randomized?: string | undefined;
    /** Wether subject is randomized or not. */
    isRandomized?: boolean;
    /** Optional - The subject's eDiary PIN */
    pin?: string | undefined;
    /** Optional - The subject's bed time */
    bedTime?: string | undefined;
    /** Optional - The subject's baseline PEF in L/min */
    baselinePef?: number | undefined;
    /** Optional - The subject's baseline FEV1 in Litres */
    baselineFev1?: number | undefined;
    /** Optional - A list of alarms that will be applied on the subject's eDiary */
    alarms?: SubjectAlarm[] | undefined;
    /** Optional - The subject's diary compliance start date */
    diaryComplianceDateTime?: string | undefined;
    /** Optional - The study cohort */
    studyPart?: string | undefined;
    /** Determines whether the subject is terminated from the study early or not. */
    terminationDate?: string | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline1?: number | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline2?: number | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline3?: number | undefined;
}

/** Class to define the subject model. */
export interface Subject extends SubjectMutation {
    /** Unique ID of subject.  */
    id?: string;
    /** Date and time the subject was first created. */
    created?: string;
    /** Date and time the subject was last modified. */
    modified?: string;
    /** Site the subject belongs to. */
    site?: Site | undefined;
    /** Language name the subject is configured to. */
    languageName?: string | undefined;
    /** Gender name the subject is configured to. */
    genderName?: string | undefined;
    /** Smoker Type name the subject is configured to. */
    smokerTypeName?: string | undefined;
    /** Population Group name the subject is configured to. */
    populationGroupName?: string | undefined;
    /** Visits belonging to subject. */
    visits?: Visit[] | undefined;
    /** Indicates whether the source of this subject is Spirotrac V or not */
    createdWithSpirotracV?: boolean;
    /** Key of the type that subject relates to */
    typeKey?: string | undefined;
    /** Name of the type that subject relates to */
    typeName?: string | undefined;
}

/** Class to define a visit mutation. */
export interface VisitMutation {
    /** The name of the visit */
    name?: string | undefined;
    /** Date and time a visit occurred */
    occurred?: string;
}

/** Class to define a visit creation. */
export interface VisitCreation extends VisitMutation {
    /** Unique ID of the visit */
    id?: string;
    /** The subject the visit belongs to */
    subjectId?: string;
}

/** Class to define a visit */
export interface Visit extends VisitCreation {
    /** Date and time the visit was created */
    created?: string;
    /** Date and time the visit was modified */
    modified?: string;
    /** The subject the visit belongs to */
    subject?: Subject | undefined;
    /** The visit schedule item the visit relates to */
    visitScheduleItemId?: string;
    /** A collection of sessions within the visit */
    sessions?: Session[] | undefined;
}

/** Class to define a session. */
export interface Session {
    /** Unique identifier for the session. */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The session type's user friendly name. */
    sessionTypeName?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Optional - the secondary device associated with the session. */
    secondaryDeviceType?: string | undefined;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Serial number of the device that performed the FVC session. */
    serialNumber?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string | undefined;
    /** Date and time the session was last received. */
    lastReceived?: string | undefined;
    /** Whether the session is suppressed or not */
    suppressed?: boolean;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The name of the technician */
    technician?: string | undefined;
    /** Notes relating to the FVC session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: AnalysisSet[] | undefined;
    /** Overread challenge status of the session that proceeded this session. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not. */
    challengeIsClosed?: boolean | undefined;
    /** The session schedule item external code. */
    sessionScheduleItemId?: string;
}

/** Class to capture a modification of a session note */
export interface SessionNoteMutation {
    /** Required - The related session for the note */
    sessionId?: string;
    /** The email address of the user modifying the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

/** Class to represent a session note. */
export interface SessionNote extends SessionNoteMutation {
    /** Unique ID of the session note */
    id?: string;
}

/** Represents a generic analysis set */
export interface AnalysisSet {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The status of analysis set */
    status?: string | undefined;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
}

/** Class to represent a subject diary alarm */
export interface SubjectAlarm {
    /** The time the alarm occurs */
    time?: string;
}

/** Class to define the permission model. */
export interface Permission {
    /** The identifier of the permission */
    id?: string | undefined;
    /** The name of the permission */
    name?: string | undefined;
    /** The description of the permission */
    description?: string | undefined;
    /** Whether or not the permission is disabled */
    isDisabled?: boolean;
    /** The category the permission is within */
    category?: PermissionCategory | undefined;
    /** Roles that implement this permission */
    roles?: Role[] | undefined;
}

/** Class to define the permission category model. */
export interface PermissionCategory {
    /** The identifier of the permission category */
    id?: number;
    /** The description of the permission category */
    description?: string | undefined;
    /** The display order of the permission in the user interface */
    displayOrder?: number;
    /** A collection of permissions within this category */
    permissions?: Permission[] | undefined;
}

export interface AlertMutation {
    alertTemplateId?: string | undefined;
    headline?: string | undefined;
    content?: string | undefined;
    active?: boolean | undefined;
    triggeredBySessionId?: string | undefined;
    occurred?: string;
    isRead?: boolean;
    originatingIdentifier?: string | undefined;
    siteId?: string | undefined;
    linkText?: string | undefined;
    linkUri?: string | undefined;
}

export interface Alert extends AlertMutation {
    id?: string;
    triggeredBySession?: Session | undefined;
    subject?: Subject | undefined;
}

/** Represents a record of a notification to a user of an alert */
export interface AlertNotificationCreation {
    id?: string;
    /** The date and time an alert notification occurred */
    occurred?: string;
}

export interface SingleResultOfAlertNotification extends SingleResult {
    queryable?: AlertNotification[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfAlert {
    /** Entities returned by the query. */
    value?: Alert[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface AlertCreation {
    id?: string;
    alertTemplateId?: string | undefined;
    headline?: string | undefined;
    content?: string | undefined;
    active?: boolean | undefined;
    triggeredBySessionId?: string | undefined;
    occurred?: string;
    originatingIdentifier?: string | undefined;
    siteId?: string | undefined;
    linkText?: string | undefined;
    linkUri?: string | undefined;
}

export interface SingleResultOfAlert extends SingleResult {
    queryable?: Alert[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfAnalysisBatch {
    /** Entities returned by the query. */
    value?: AnalysisBatch[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface AnalysisBatchCreation {
    id?: string;
    studyId?: string;
    name?: string | undefined;
    includedSessions?: string[] | undefined;
    selectedSessions?: string[] | undefined;
    batchLastAnalysisSetId?: string | undefined;
}

export interface AnalysisBatch extends AnalysisBatchCreation {
    sessionTypeId?: string | undefined;
    createdDateTime?: string | undefined;
}

export interface SingleResultOfAnalysisBatch extends SingleResult {
    queryable?: AnalysisBatch[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfAnalysisSetType {
    /** Entities returned by the query. */
    value?: AnalysisSetType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define an analysis set type. */
export interface AnalysisSetType {
    /** Gets the Id */
    id?: number;
    /** Gets the name */
    name?: string | undefined;
    /** Gets the external code */
    externalCode?: string | undefined;
}

export interface SingleResultOfAnalysisSetType extends SingleResult {
    queryable?: AnalysisSetType[] | undefined;
}

export interface AnnotatedEcgWrapper {
    text?: string | undefined;
}

export interface AnnotatedEcgRequest {
    testId?: string;
}

export interface AuditTrailEvent {
    id?: string;
    auditAction?: string | undefined;
    summary?: string | undefined;
    userAnnotation?: string | undefined;
}

export interface SingleResultOfAuditTrailEvent extends SingleResult {
    queryable?: AuditTrailEvent[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodGlucoseSampleMethod {
    /** Entities returned by the query. */
    value?: BloodGlucoseSampleMethod[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface BloodGlucoseSampleMethod {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SingleResultOfBloodGlucoseSampleMethod extends SingleResult {
    queryable?: BloodGlucoseSampleMethod[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodGlucoseSession {
    /** Entities returned by the query. */
    value?: BloodGlucoseSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents the mutation of a blood glucose session */
export interface BloodGlucoseSessionMutation {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Serial number of the device that performed the session. */
    serialNumber?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Revision of the hardware of the device at the time the session was performed. */
    hardwareVersion?: string | undefined;
    /** Version of software running on the device at the time the session was performed. */
    softwareVersion?: string | undefined;
    /** Name of the technician that uploaded the session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** The status of the blood glucose session, either BGSS_AWAITING_DATA or BGSS_RECEIVED_DATA */
    status?: string | undefined;
    /** Whether the session should be marked as actively configured or not */
    configured?: boolean;
    /** Name of the technician that configured the session on the device. */
    configurationTechnician?: string | undefined;
    /** The date and time the configuration occurred. */
    configurationOccurred?: string | undefined;
}

/** Represents a blood glucose session */
export interface BloodGlucoseSession extends BloodGlucoseSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received from an external application. */
    received?: string | undefined;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: BloodGlucoseTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
}

export interface BloodGlucoseTestMutation {
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** Amount of ketone in blood using SI units (mmol/L) */
    ketone?: number | undefined;
    /** Amount of glucose in the blood using SI units (mmol/L) */
    glucoseSI?: number | undefined;
    /** Amount of glucose in the blood using US units (mg/dL) */
    glucoseUS?: number | undefined;
    /** The identifier of the method used for the test sample */
    sampleMethod?: string | undefined;
    /** The name of the method used for the test sample */
    sampleMethodName?: string | undefined;
    /** Whether the test result has been accepted by the technician. */
    isAcceptedByTechnician?: boolean;
}

/** Class to define the Blood Glucose test query model. */
export interface BloodGlucoseTest extends BloodGlucoseTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: BloodGlucoseSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Represents the creation of a blood glucose session */
export interface BloodGlucoseSessionCreation {
    /** Unique identifier for the session. */
    id?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: BloodGlucoseTestCreation[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Serial number of the device that performed the session. */
    serialNumber?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Revision of the hardware of the device at the time the session was performed. */
    hardwareVersion?: string | undefined;
    /** Version of software running on the device at the time the session was performed. */
    softwareVersion?: string | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** The status of the blood glucose session, either BGSS_AWAITING_DATA or BGSS_RECEIVED_DATA */
    status?: string | undefined;
    /** Whether the session should be marked as actively configured or not */
    configured?: boolean;
    /** Name of the technician that configured the session on the device. */
    configurationTechnician?: string | undefined;
    /** The date and time the configuration occurred. */
    configurationOccurred?: string | undefined;
}

export interface BloodGlucoseTestCreation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: BloodGlucoseSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** Amount of ketone in blood using SI units (mmol/L) */
    ketone?: number | undefined;
    /** Amount of glucose in the blood using SI units (mmol/L) */
    glucoseSI?: number | undefined;
    /** Amount of glucose in the blood using US units (mg/dL) */
    glucoseUS?: number | undefined;
    /** The identifier of the method used for the test sample */
    sampleMethod?: string | undefined;
    /** The name of the method used for the test sample */
    sampleMethodName?: string | undefined;
}

export interface SingleResultOfBloodGlucoseSession extends SingleResult {
    queryable?: BloodGlucoseSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodGlucoseSessionStatus {
    /** Entities returned by the query. */
    value?: BloodGlucoseSessionStatus[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface BloodGlucoseSessionStatus {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SingleResultOfBloodGlucoseSessionStatus extends SingleResult {
    queryable?: BloodGlucoseSessionStatus[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodGlucoseTest {
    /** Entities returned by the query. */
    value?: BloodGlucoseTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfBloodGlucoseTest extends SingleResult {
    queryable?: BloodGlucoseTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodPressureSession {
    /** Entities returned by the query. */
    value?: BloodPressureSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface BaseSession {
    /** The serial number of the device that performed the session. */
    serialNumber?: string | undefined;
    /** Version of software on the devie at the time the session was performed. */
    softwareVersion?: string | undefined;
    softwareReference?: string | undefined;
    softwarePlatform?: string | undefined;
    /** Gets or sets the package version which typically represent the version number of the overall package including the configuration */
    packageVersion?: string | undefined;
    /** Revision of the hardware on the devie at the time the session was performed. */
    hardwareVersion?: string | undefined;
    /** Optional - the secondary device associated with the session. */
    secondaryDeviceType?: string | undefined;
}

export interface BloodPressureSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
}

export interface BloodPressureSession extends BloodPressureSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: BloodPressureTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
}

export interface BloodPressureTestMutation {
    /** Required - Date and time the test occurred. */
    occurred?: string;
    index?: number;
    /** Optional - Systolic is upper blood pressure in mm Hg */
    systolic?: number | undefined;
    /** Optional - Diastolic is lower blood pressure in mm Hg */
    diastolic?: number | undefined;
    /** Optional - Average blood pressure in an individual during a single cardiac cycle in mm Hg */
    meanArterialPressure?: number | undefined;
    /** Optional - Pulse Rate in BPM (Beats per minute) */
    pulseRate?: number | undefined;
    /** Optional - The arm used during blood pressure testing */
    arm?: string | undefined;
    /** Optional - Unique identifier of cuff size */
    cuffSize?: string | undefined;
}

/** Class to define the Blood Pressure test query model. */
export interface BloodPressureTest extends BloodPressureTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: BloodPressureSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

export interface BloodPressureSessionCreation extends BaseSession {
    /** Unique identifier for the session. */
    id?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: BloodPressureTestCreation[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
}

export interface BloodPressureTestCreation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: BloodPressureSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Required - Test index relative to session */
    index?: number;
    /** Optional - Systolic is upper blood pressure in mm Hg */
    systolic?: number | undefined;
    /** Optional - Diastolic is lower blood pressure in mm Hg */
    diastolic?: number | undefined;
    /** Optional - Average blood pressure in an individual during a single cardiac cycle in mm Hg */
    meanArterialPressure?: number | undefined;
    /** Optional - Pulse Rate in BPM (Beats per minute) */
    pulseRate?: number | undefined;
    /** Optional - The arm used during blood pressure testing */
    arm?: string | undefined;
    /** Optional - Unique identifier of cuff size */
    cuffSize?: string | undefined;
}

export interface SingleResultOfBloodPressureSession extends SingleResult {
    queryable?: BloodPressureSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBloodPressureTest {
    /** Entities returned by the query. */
    value?: BloodPressureTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfBloodPressureTest extends SingleResult {
    queryable?: BloodPressureTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfBorgScale {
    /** Entities returned by the query. */
    value?: BorgScale[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define borg scale mutation model. */
export interface BorgScaleMutation {
    /** borg scale description. */
    description?: string | undefined;
}

/** Class to define borg scale model. */
export interface BorgScale extends BorgScaleMutation {
    /** Borg scale ID. */
    id?: string;
    /** Study ID. */
    studyId?: string;
    /** borg scale grade. */
    grade?: number;
}

/** Class to define borg scale creation model. */
export interface BorgScaleCreation {
    /** Borg scale ID. */
    id?: string;
    /** Study ID. */
    studyId?: string;
    /** borg scale grade. */
    grade?: number;
    /** borg scale description. */
    description?: string | undefined;
}

export interface SingleResultOfBorgScale extends SingleResult {
    queryable?: BorgScale[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCalibration {
    /** Entities returned by the query. */
    value?: Calibration[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface BaseCalibration {
    /** Id of the calibration. */
    id?: string;
    /** Optional - Site Id of the site which the calibration belongs to */
    siteId?: string | undefined;
    /** Required - The type of the device that the calibration was performed on */
    deviceType?: string | undefined;
    /** Required - The date and time the calibration was checked */
    checked?: string;
    /** Optional - The user performing the calibration */
    user?: string | undefined;
    /** Optional - The serial number of the device performing the calibration */
    serialNumber?: string | undefined;
    temperature?: number | undefined;
    /** Optional - The pressure value at the time of the calibration */
    pressure?: number | undefined;
    /** Optional - The humidity value at the time of the calibration */
    humidity?: number | undefined;
    /** Optional - The altitude value at the time of the calibration */
    altitude?: number | undefined;
}

export interface CalibrationMutation extends BaseCalibration {
    /** Optional - The serial number of the syringe used for the calibration */
    syringeNumber?: string | undefined;
    /** Optional - The reference volume */
    referenceVol?: number;
    /** Optional - The measured expiratory value */
    measuredExp?: number | undefined;
    /** Optional - The measured inspiratory value */
    measuredInsp?: number | undefined;
    /** Optional - Whether the calibration value has been updated or not */
    updated?: boolean;
    /** Optional - Free text comments */
    comments?: string | undefined;
    /** Optional - The result of the calibration "PASS" or "FAIL" */
    result?: string | undefined;
}

export interface Calibration extends CalibrationMutation {
    /** Date and time the calibration was first created. */
    created?: string;
    /** Date and time the calibration was last modified. */
    modified?: string;
    /** Optional - Accuracy tests */
    accuracyTests?: FvcAccuracyTest[] | undefined;
}

export interface BaseAccuracyTest {
    id?: string;
    calibrationId?: string;
}

/** Class to represent a calibration accuracy test */
export interface AccuracyTest extends BaseAccuracyTest {
    /** Date and time the test was first created. */
    created?: string;
    modified?: string;
}

export interface FvcAccuracyTest extends AccuracyTest {
    sampleRate?: number;
    volumeData?: string | undefined;
    flowData?: string | undefined;
    expiratoryStartIndex?: number | undefined;
    expiratoryStartRealIndex?: number | undefined;
    expiratoryEndIndex?: number | undefined;
    inspiratoryStartIndex?: number | undefined;
    inspiratoryEndIndex?: number | undefined;
    strokeNumber?: number;
    occurred?: string;
}

export interface CalibrationCreation extends CalibrationMutation {
    /** Optional - Accuracy tests */
    accuracyTests?: FvcAccuracyTest[] | undefined;
}

export interface SingleResultOfCalibration extends SingleResult {
    queryable?: Calibration[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfChallengeSession {
    /** Entities returned by the query. */
    value?: ChallengeSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the challenge session mutation model. */
export interface ChallengeSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the session was performed. */
    postureType?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Challenge Type Identifier */
    challengeTypeId?: string | undefined;
    /** Pre-Challenge FEV1 */
    preChallengeFev1?: number | undefined;
    /** Baseline FEV1 */
    baselineFev1?: number | undefined;
    /** Delivery Method */
    deliveryMethod?: string | undefined;
    /** Provocation Dose */
    pd?: number | undefined;
}

/** Class to define the challenge session query model. */
export interface ChallengeSession extends ChallengeSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Unique identifier for the type of session. */
    sessionTypeId?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    received?: string | undefined;
}

/** Class to define the challenge session creation model. */
export interface ChallengeSessionCreation extends ChallengeSessionMutation {
    /** Optional - Unique identifier for the session. */
    id?: string;
}

export interface SingleResultOfChallengeSession extends SingleResult {
    queryable?: ChallengeSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfConfigurableDataItem {
    /** Entities returned by the query. */
    value?: ConfigurableDataItem[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface ConfigurableDataItem {
    id?: string | undefined;
    name?: string | undefined;
    defaultFormatId?: string | undefined;
    configurableDataItemId?: string | undefined;
    configurableEntityId?: string | undefined;
    defaultDisplayText?: string | undefined;
    defaultMinimumLength?: number | undefined;
    defaultMaximumLength?: number | undefined;
    defaultMinimumValue?: number | undefined;
    defaultMaximumValue?: number | undefined;
    defaultUnitTypeId?: string | undefined;
    defaultImportanceId?: string | undefined;
    customFormat?: string | undefined;
    isFormatAttributeAvailable?: boolean;
    isMinAndMaxLengthAttributesAvailable?: boolean;
    isMinAndMaxValueAttributesAvailable?: boolean;
    isImportanceAttributeAvailable?: boolean;
    isDisplayTextAttributeAvailable?: boolean;
    isUnitTypeAttributeAvailable?: boolean;
    isPrefixWithSiteNumberAttributeAvailable?: boolean;
    defaultPrefixWithSiteNumber?: boolean;
    /** The absolute maximum length a field can be set to */
    fieldLength?: number;
}

export interface SingleResultOfConfigurableDataItem extends SingleResult {
    queryable?: ConfigurableDataItem[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughAnalysisSetComment {
    /** Entities returned by the query. */
    value?: CoughAnalysisSetComment[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoughAnalysisSetCommentCreation {
    /** The analysis set the comment belongs to */
    analysisSetId?: string;
    /** The analysis set comment text */
    comment?: string | undefined;
    /** The start time of the comment on the recording file */
    commentStartTime?: number | undefined;
    /** The end time of the comment on the recording file */
    commentEndTime?: number | undefined;
    /** Id of the Parent Comment */
    parentCommentId?: string | undefined;
    /** Nested replies within the comment */
    replies?: CoughAnalysisSetComment[] | undefined;
    segmentOffset?: number;
}

export interface CoughAnalysisSetComment extends CoughAnalysisSetCommentCreation {
    userEmail?: string | undefined;
    created?: string | undefined;
    /** Unique ID of the analysis set event comment */
    id?: string;
}

export interface SingleResultOfCoughAnalysisSetComment extends SingleResult {
    queryable?: CoughAnalysisSetComment[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughAnalysisSetEvent {
    /** Entities returned by the query. */
    value?: CoughAnalysisSetEvent[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoughAnalysisSetEventMutation {
    disputedComment?: string | undefined;
    disputedAccepted?: boolean | undefined;
}

/** Class to define a cough analysis set event. */
export interface CoughAnalysisSetEventCreation extends CoughAnalysisSetEventMutation {
    /** Unique ID of the analysis set event */
    id?: string;
    /** The analysis set the event belongs to */
    analysisSetId?: string;
    /** The event type */
    eventTypeId?: string;
    /** The start time of the event on the raw recording file */
    rawStart?: number | undefined;
    /** The end time of the event on the raw recording file if applicable */
    rawEnd?: number | undefined;
    /** The start time of the event on the processed recording file */
    processedStart?: number | undefined;
    /** The end time of the event on the processed recording file if applicable */
    processedEnd?: number | undefined;
    /** The start time of the event on the sensor processed recording file */
    sensorProcessedStart?: number | undefined;
    /** The end time of the event on the sensor processed recording file if applicable */
    sensorProcessedEnd?: number | undefined;
    /** Value to indicate if an event is disputed */
    disputed?: boolean | undefined;
}

export interface CoughAnalysisSetEvent extends CoughAnalysisSetEventCreation {
    analysisSet?: CoughAnalysisSet | undefined;
}

export interface CoughAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** Whether the analysis set is considered a primary analysis set or not */
    primary?: boolean;
    /** Deadline for QA */
    qaDeadline?: string | undefined;
    /** Deadline for analysis */
    analysisDeadline?: string | undefined;
}

/** Class to define a cough analysis set. */
export interface CoughAnalysisSet extends CoughAnalysisSetMutation {
    /** The session the analysis set belongs to. */
    session?: Session | undefined;
    typeName?: string | undefined;
    statusName?: string | undefined;
    /** Whether this analysis set is considered a linked analysis set or not */
    isLinkedAnalysisSet?: boolean;
    /** A collection of analysis set links */
    linksSourcedFromThis?: AnalysisSetLink[] | undefined;
    /** A collection of analysis set links */
    linksTargetingThis?: AnalysisSetLink[] | undefined;
    /** Whether the quality review is required */
    reviewRequired?: boolean;
    /** Whether the quality review has been completed */
    reviewComplete?: boolean;
    /** The quality review status */
    reviewStatus?: string | undefined;
    hasReOpenComments?: boolean;
    /** Whether the quality review caused the analysis set analysis status to be re-opened */
    reOpenedDuringReview?: boolean;
    isSourceOfAnother?: boolean;
    /** The analyst of the analysis set */
    analyst?: string | undefined;
    lastAnalyst?: string | undefined;
    analystLastChangedDateTime?: string | undefined;
    firstAnalyst?: string | undefined;
    firstAnalystAssignedDateTime?: string | undefined;
    visualInspectionStatusLastChanged?: string | undefined;
    qaAnalyst?: string | undefined;
    qaAnalystStageDateTime?: string | undefined;
    visualReview?: boolean;
    visualReviewAnalystSelectionId?: number | undefined;
    /** The date and time the analysis of the set was started */
    started?: string | undefined;
    /** The date and time the analysis of the set first completed */
    firstComplete?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The waveform that is selected on the session
             */
    sessionWaveform?: string | undefined;
    adjudicationSourceSetId?: string | undefined;
    adjudicationTargetSetId?: string | undefined;
    statusReason?: string | undefined;
}

export interface AnalysisSetLink {
    linkType?: string | undefined;
    linkTypeName?: string | undefined;
    name?: string | undefined;
    targetId?: string;
    targetStatus?: string | undefined;
    targetStatusName?: string | undefined;
    targetCreated?: string;
    targetCoughType?: string | undefined;
}

export interface SingleResultOfCoughAnalysisSetEvent extends SingleResult {
    queryable?: CoughAnalysisSetEvent[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughAnalysisSet {
    /** Entities returned by the query. */
    value?: CoughAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfCoughAnalysisSet extends SingleResult {
    queryable?: CoughAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughAnalysisSetType {
    /** Entities returned by the query. */
    value?: CoughAnalysisSetType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoughAnalysisSetType {
    id?: string | undefined;
    name?: string | undefined;
    isQA?: boolean;
    canBePrimary?: boolean;
}

export interface SingleResultOfCoughAnalysisSetType extends SingleResult {
    queryable?: CoughAnalysisSetType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughEventType {
    /** Entities returned by the query. */
    value?: CoughEventType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoughEventType {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isPeriod?: boolean;
    defaultColor?: string | undefined;
}

export interface SingleResultOfCoughEventType extends SingleResult {
    queryable?: CoughEventType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughSession {
    /** Entities returned by the query. */
    value?: CoughSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the cough session mutation model. */
export interface CoughSessionMutation {
    /** Unique identifier for the cough session. */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** Type of medication in use by subject at the time the cough session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the cough session was performed. */
    postureType?: string | undefined;
    /** Device Type used to perform the cough session. */
    deviceType?: string | undefined;
    /** Gender of the subject at the time the cough session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the cough session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the cough session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the cough session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the cough session was performed. */
    weight?: number | undefined;
    /** Type of smoker the subject is at the time the cough session was performed. */
    smokerType?: string | undefined;
    /** User name of the technician that performed the cough session. */
    technician?: string | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Serial number of the device that performed the cough session. */
    serialNumber?: string | undefined;
    /** Serial number of the media (such as a CF card) within the device that performed the cough session. */
    mediaSerialNumber?: string | undefined;
    /** Version of software on the device at the time the cough session was performed. */
    softwareVersion?: string | undefined;
    /** The reference number of the software on the device at the time the cough session was performed. */
    softwareReference?: string | undefined;
    /** Revision of the hardware on the device at the time the cough session was performed. */
    hardwareVersion?: string | undefined;
    /** The date and time the recording started */
    recordingStart?: string | undefined;
    /** The identifier of the status the cough session is currently in */
    status?: string | undefined;
    /** Whether the session should be marked as actively suppressed or not */
    suppressed?: boolean;
    /** Whether the session should be marked as actively configured or not */
    configured?: boolean;
    /** Optional - A free text tracking number if the session is sent via post to Vitalograph */
    postalTrackingNumber?: string | undefined;
    /** Optional - The date and time the cough session was marked as postal received (if applicable) */
    postalReceived?: string | undefined;
    /** A collection of analysis set identifiers that are considered primary */
    primaryAnalysisSetIds?: string[] | undefined;
    uploadStartTime?: string | undefined;
    uploadEndTime?: string | undefined;
    /** The number of times an upload of the cough recording has been attempted. */
    uploadRecordingRetry?: number | undefined;
}

/** Class to define a cough session creation. */
export interface CoughSessionCreation extends CoughSessionMutation {
}

/** Class to define a cough session. */
export interface CoughSession extends CoughSessionCreation {
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    lastReceived?: string | undefined;
    /** Date and time the session was last analysed. */
    lastAnalysed?: string | undefined;
    /** The number of times an upload of the cough recording has been attempted. */
    uploadRecordingRetry?: number | undefined;
    /** The name of the status for the cough session. */
    statusName?: string | undefined;
    /** The selected waveform for the session. */
    waveform?: string | undefined;
    /** The duration of the raw recording */
    rawDuration?: number | undefined;
    /** The duration of the processed recording */
    processedDuration?: number | undefined;
    /** The duration of the sensor processed recording */
    sensorProcessedDuration?: number | undefined;
    /** The date and time the session was available for quality check */
    availableForQualityCheckDateTime?: string | undefined;
    /** Notes relating to the Cough session. */
    notes?: SessionNote[] | undefined;
    /** Analysis sets relating to the Cough session. */
    analysisSets?: CoughAnalysisSet[] | undefined;
}

export interface BatchProcessRequest {
    /** Required - The audit annotation for the batch process */
    auditAnnotation?: string | undefined;
}

export interface SingleResultOfCoughSession extends SingleResult {
    queryable?: CoughSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughSessionStatus {
    /** Entities returned by the query. */
    value?: CoughSessionStatus[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to represent a cough session status */
export interface CoughSessionStatus {
    /** Unique ID of the cough session status */
    id?: string | undefined;
    /** The name of the status */
    name?: string | undefined;
}

export interface SingleResultOfCoughSessionStatus extends SingleResult {
    queryable?: CoughSessionStatus[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoughWaveformType {
    /** Entities returned by the query. */
    value?: CoughWaveformType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoughWaveformType {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SingleResultOfCoughWaveformType extends SingleResult {
    queryable?: CoughWaveformType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCountry {
    /** Entities returned by the query. */
    value?: Country[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface Country {
    id?: string | undefined;
    name?: string | undefined;
    tollFreeNumber?: string | undefined;
    localPostalAddress?: string | undefined;
}

export interface SingleResultOfCountry extends SingleResult {
    queryable?: Country[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCustomCalculation {
    /** Entities returned by the query. */
    value?: CustomCalculation[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CustomCalculationMutation {
    active?: boolean;
}

export interface CustomCalculationCreation extends CustomCalculationMutation {
    id?: string;
    pluginId?: string | undefined;
    pluginName?: string | undefined;
}

export interface CustomCalculation extends CustomCalculationCreation {
}

export interface SingleResultOfCustomCalculation extends SingleResult {
    queryable?: CustomCalculation[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDataItemConfiguration {
    /** Entities returned by the query. */
    value?: DataItemConfiguration[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the configurations item mutation model. */
export interface DataItemConfigurationMutation {
    /** The minimum length permitted. */
    minimumLength?: number | undefined;
    /** The maximum length permitted. */
    maximumLength?: number | undefined;
    /** The minimum value permitted. */
    minimumValue?: number | undefined;
    /** The maximum value permitted. */
    maximumValue?: number | undefined;
    /** The format ID. */
    formatId?: string | undefined;
    /** The custom format. */
    customFormat?: string | undefined;
    /** The unit type ID. */
    unitTypeId?: string | undefined;
    /** The importance ID. */
    importanceId?: string | undefined;
    /** The display text. */
    displayText?: string | undefined;
    /** Indicating whether this field should have a prefix of the site number */
    prefixWithSiteNumber?: boolean;
    /** The character(s) that should be displayed between the prefix of the site number and the subject number. */
    prefixDelimiter?: string | undefined;
}

/** Class to define the configurations item query model. */
export interface DataItemConfiguration extends DataItemConfigurationMutation {
    /** Unique identifier for the configuration. */
    id?: string;
    /** Unique identifier for the study. */
    studyId?: string;
    /** Configurable data item ID. */
    configurableDataItemId?: string | undefined;
    /** Date and time of creation. */
    created?: string;
    /** Date and time of last modification. */
    modified?: string;
}

/** Class to define the configurations item query model. */
export interface DataItemConfigurationCreation extends DataItemConfigurationMutation {
    /** Optional - Unique identifier for the configuration. */
    id?: string;
    /** Required - Unique identifier for the study. */
    studyId?: string;
    /** Required - Configurable data item ID. */
    configurableDataItemId?: string | undefined;
}

export interface SingleResultOfDataItemConfiguration extends SingleResult {
    queryable?: DataItemConfiguration[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDcfCorrectionType {
    /** Entities returned by the query. */
    value?: DcfCorrectionType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents a DCF correction type */
export interface DcfCorrectionType {
    /** The unique identifier for the correction type */
    id?: string | undefined;
    /** The correction name */
    name?: string | undefined;
    /** The index of the correction type */
    index?: number;
}

export interface SingleResultOfDcfCorrectionType extends SingleResult {
    queryable?: DcfCorrectionType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDcfRequest {
    /** Entities returned by the query. */
    value?: DcfRequest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents a Data Correction Request */
export interface DcfRequestMutation {
    /** The unique identifier for the request */
    id?: string;
    entityId?: number;
    /** The user facing label for the request */
    label?: string | undefined;
    /** The status of the request */
    status?: string | undefined;
    /** The study ID the request relates to */
    studyId?: string;
    /** The site ID the request relates to */
    siteId?: string | undefined;
    /** The subject ID the request relates to */
    subjectId?: string | undefined;
    /** The visit ID the request relates to */
    visitId?: string | undefined;
    /** The session ID the request relates to */
    sessionId?: string | undefined;
    /** The date and time the request was created */
    created?: string;
    /** The date and time the request was last modified */
    modified?: string;
    /** The username of the user who created the DCF request */
    createdByUser?: string | undefined;
    /** Whether the request is site approved or not */
    siteApproved?: boolean;
    /** The user that site approved the request */
    siteApprovedByUser?: string | undefined;
    /** A free text annotation that relates to the site approval */
    siteApprovedAnnotation?: string | undefined;
    /** Whether the request is verification reviewed or not */
    verificationReviewed?: boolean;
    /** The user that verification reviewed the request */
    verificationReviewedByUser?: string | undefined;
    /** A free text annotation that relates to the verification review */
    verificationReviewedAnnotation?: string | undefined;
    /** Whether the request is action approved or not */
    actionedApproved?: boolean;
    /** The user that action approved the request */
    actionedByUser?: string | undefined;
    /** A free text annotation that relates to the action approval */
    actionedApprovedAnnotation?: string | undefined;
    /** Any additional comments to explain the request */
    additionalComments?: string | undefined;
    originalEntry?: string | undefined;
    newEntry?: string | undefined;
    /** Determine whether any client systems have implemented the data correction. */
    clientImplemented?: boolean;
    /** The user that implemented the request */
    implementedByUser?: string | undefined;
    /** A free text annotation that relates to the implementation of the request */
    implementedAnnotation?: string | undefined;
    rejectedWithSuggestions?: boolean;
    rejectedWithSuggestionsAnnotation?: string | undefined;
    /** The unique identifier for the correction type */
    correctionTypeId?: string | undefined;
    /** A collection of corrections that the DCF request wishes to be implemented */
    corrections?: DcfCorrection[] | undefined;
}

/** Represents a Data Correction Request */
export interface DcfRequest extends DcfRequestMutation {
    /** The study the request relates to */
    study?: Study | undefined;
    /** The site the request relates to */
    site?: Site | undefined;
    /** The subject the request relates to */
    subject?: Subject | undefined;
    /** The visit the request relates to */
    visit?: Visit | undefined;
    /** The session the request relates to */
    session?: Session | undefined;
    /** The date and time the site approved the request */
    siteApprovedDateTime?: string | undefined;
    /** The date and time the verification reviewer approved the request */
    verificationReviewedDateTime?: string | undefined;
    /** The date and time the request was actioned */
    actionedApprovedDateTime?: string | undefined;
    implementedDateTime?: string | undefined;
}

/** Represents a Data Correction */
export interface DcfCorrection {
    /** Unique identifier for the DCF Correction */
    id?: string;
    /** The database entity the DCF Correction relates to */
    entity?: string | undefined;
    /** The database field the DCF Correction relates to */
    field?: string | undefined;
    /** The DCF Request requesting this correction */
    requestId?: string;
    /** The original value that is being changed at the time the correction was raised */
    originalValue?: string | undefined;
    /** The intended value to correct to */
    correctedValue?: string | undefined;
}

/** Class to define a data correction request creation */
export interface DcfRequestCreation {
    /** Unique ID of the data correction request */
    id?: string;
    /** The request's label */
    label?: string | undefined;
    /** The study the request relates to */
    studyId?: string;
    /** Optional - The site the request relates to, if applicable */
    siteId?: string | undefined;
    /** Optional - The subject the request relates to, if applicable */
    subjectId?: string | undefined;
    /** Optional - The session ID the request relates to, if applicable */
    sessionId?: string | undefined;
    /** Optional - The visit ID the request relates to, if applicable
             */
    visitId?: string | undefined;
    /** The date and time the request was created */
    created?: string;
    /** The username of the user creating the request */
    createdByUser?: string | undefined;
    /** Any additional comments to explain the request */
    additionalComments?: string | undefined;
    /** If a misc request is created the original entry text for the request */
    originalEntry?: string | undefined;
    /** If a misc request is created the new entry text for the request */
    newEntry?: string | undefined;
    /** A collection of data correction that this request should implement */
    corrections?: DcfCorrection[] | undefined;
    /** The unique identifier for the correction type */
    correctionTypeId?: string | undefined;
}

export interface SingleResultOfDcfRequest extends SingleResult {
    queryable?: DcfRequest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDcfRequestStatus {
    /** Entities returned by the query. */
    value?: DcfRequestStatus[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents a DCF request overall status */
export interface DcfRequestStatus {
    /** The unique identifier for the request status */
    id?: string | undefined;
    /** The request status name */
    name?: string | undefined;
    /** The order ordinal for the status */
    order?: number;
}

export interface SingleResultOfDcfRequestStatus extends SingleResult {
    queryable?: DcfRequestStatus[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDefinedReport {
    /** Entities returned by the query. */
    value?: DefinedReport[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class for the defined report mutation model. */
export interface DefinedReportMutation {
    /** Path to the report. */
    path?: string | undefined;
    /** The title of the report. */
    name?: string | undefined;
    /** The description of the report. */
    description?: string | undefined;
    /** Indicates if the report is going to be a widget displayed in the dashboard or not. */
    isWidget?: boolean;
    /** User roles that are allowed to access the report. */
    rolesIds?: string[] | undefined;
    /** The way report parameters should be populated. */
    parameters?: DefinedReportParameter[] | undefined;
}

/** Class for the defined report query model. */
export interface DefinedReport extends DefinedReportMutation {
    /** Unique identifier for the defined report. */
    id?: string;
    /** Date and time the defined report was first created. */
    created?: string;
    /** Date and time the defined report was last modified. */
    modified?: string;
    studyIds?: string[] | undefined;
}

/** Class for the defined report parameter model. */
export interface DefinedReportParameter {
    /** Unique identifier for the parameter type. */
    parameterTypeId?: string | undefined;
    /** The name of the parameter. */
    name?: string | undefined;
}

/** Class for the defined report query model. */
export interface DefinedReportCreation extends DefinedReportMutation {
    /** Unique identifier for the defined report. */
    id?: string;
}

export interface SingleResultOfDefinedReport extends SingleResult {
    queryable?: DefinedReport[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDeviceAuditTrail {
    /** Entities returned by the query. */
    value?: DeviceAuditTrail[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DeviceAuditTrailCreation {
    /** A unique identifier for the audit event */
    id?: string;
    /** Optional - The unique identifier for the subject relating to the audit event */
    subjectId?: string | undefined;
    /** Optional - The unique identifier for the site relating to the audit event */
    siteId?: string | undefined;
    /** Optional - The unique identifier for the visit relating to the audit event */
    visitId?: string | undefined;
    /** Optional - The unique identifier for the device */
    deviceType?: string | undefined;
    /** The serial number of the device with the audit event */
    serialNumber?: string | undefined;
    /** The date and time the audit event occurred */
    occurred?: string;
    /** Optional - A device specific code to identify the audit event */
    code?: string | undefined;
    /** Optional - A summary of the audit event trail */
    summary?: string | undefined;
    /** Optional - The user account relating to the audit event */
    user?: string | undefined;
    /** Optional - A user annotation relating to audit event */
    annotation?: string | undefined;
    /** Optional - The sequence number of the audit event from the point of view of the device defining an order to the audit events */
    sequenceNumber?: string | undefined;
}

export interface DeviceAuditTrail extends DeviceAuditTrailCreation {
}

export interface SingleResultOfDeviceAuditTrail extends SingleResult {
    queryable?: DeviceAuditTrail[] | undefined;
}

export interface DeviceConfiguration {
    resource?: DeviceConfigurationItem[] | undefined;
}

export interface DeviceConfigurationItem {
    content?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    version?: string | undefined;
    softwareFileChecksum?: string | undefined;
    softwareRevisionNumber?: number;
    softwareFileName?: string | undefined;
    text?: string | undefined;
}

/** Represents a request for the device specific configuration */
export interface ConfigurationRequest {
    /** Required - The identifier for the device type */
    deviceType?: string | undefined;
    /** Required - The device serial number */
    serialNumber?: string | undefined;
    /** Optional - The identifier of the subject the device is allocated to */
    subjectId?: string | undefined;
    /** Optional - The local timezone to apply to the device configuration */
    timeZone?: string | undefined;
    /** Optional - The identifier of the study the device is allocated to */
    studyId?: string | undefined;
    /** Optional - Study Package version */
    version?: string | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDevice {
    /** Entities returned by the query. */
    value?: Device[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the device mutation model. */
export interface DeviceMutation {
    /** Required - The identifier of the study to allocate the device to */
    studyId?: string;
    /** Required - The identifier for the device type */
    deviceType?: string | undefined;
    /** Optional - The identifier of the site to allocate to this device */
    allocatedSiteId?: string | undefined;
    /** Optional - The identifier of the subject to allocate to this device */
    allocatedSubjectId?: string | undefined;
    /** Optional - Spirotrack Package Semantic Version */
    spirotracPackageVersion?: string | undefined;
}

/** Class to define the device creation model. */
export interface DeviceCreation extends DeviceMutation {
    /** Required - The public serial number of the device */
    serialNumber?: string | undefined;
}

/** Class to define the device query model. */
export interface Device extends DeviceCreation {
    id?: string;
    /** The site allocated to this device */
    allocatedSite?: Site | undefined;
    /** The subject allocated to this device */
    allocatedSubject?: Subject | undefined;
    /** The date and time the device was created */
    created?: string;
    /** The date and time the device was modified */
    modified?: string;
}

export interface SingleResultOfDevice extends SingleResult {
    queryable?: Device[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDeviceType {
    /** Entities returned by the query. */
    value?: DeviceType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a device type */
export interface DeviceType {
    /** Unique ID of the device type */
    id?: string | undefined;
    /** The name of the device type */
    name?: string | undefined;
    /** Whether the device type has a serial prefix or not */
    serialNumberPrefix?: string | undefined;
    /** Whether the prefix is stored on the device or added later */
    isPrefixOnDevice?: boolean;
}

export interface SingleResultOfDeviceType extends SingleResult {
    queryable?: DeviceType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryCompliance {
    /** Entities returned by the query. */
    value?: DiaryCompliance[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DiaryComplianceMutation {
    /** The unique identifier for the compliance record */
    id?: string;
    /** The expected number of events */
    expected?: number;
    /** The actual number of events */
    recorded?: number;
    duration?: number | undefined;
    /** The date and time the compliance was determined */
    occurred?: string;
    /** Whether the compliance has been confirmed as read by the user or not */
    confirmed?: boolean;
    /** Optional - The integer identifying number from the diary for the compliance */
    eDiarySessionComplianceIdentifier?: number;
    /** Optional - The name of the compliance ruleset */
    complianceName?: string | undefined;
}

export interface DiaryComplianceCreation extends DiaryComplianceMutation {
    sessionId?: string;
    complianceType?: number;
}

export interface DiaryCompliance extends DiaryComplianceCreation {
    session?: Session | undefined;
}

export interface SingleResultOfDiaryCompliance extends SingleResult {
    queryable?: DiaryCompliance[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryConfigurationFile {
    /** Entities returned by the query. */
    value?: DiaryConfigurationFile[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DiaryConfigurationFileCreation {
    name?: string | undefined;
    friendlyName?: string | undefined;
    fileSizeInBytes?: number | undefined;
    contentType?: string | undefined;
    /** The content of the file in bytes */
    fileContent?: string | undefined;
    configurationId?: string;
}

export interface DiaryConfigurationFile extends DiaryConfigurationFileCreation {
    id?: string;
    createdDateTime?: string;
    lastModifiedDateTime?: string | undefined;
    eDiaryConfiguration?: DiaryConfiguration | undefined;
    isStrings?: boolean;
}

export interface DiaryConfigurationCreation {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
}

export interface DiaryConfiguration extends DiaryConfigurationCreation {
    studies?: Study[] | undefined;
    files?: DiaryConfigurationFile[] | undefined;
}

export interface SingleResultOfDiaryConfigurationFile extends SingleResult {
    queryable?: DiaryConfigurationFile[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryConfiguration {
    /** Entities returned by the query. */
    value?: DiaryConfiguration[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfDiaryConfiguration extends SingleResult {
    queryable?: DiaryConfiguration[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryPackageDeployment {
    /** Entities returned by the query. */
    value?: DiaryPackageDeployment[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DiaryPackageDeploymentCreation {
    serialNumber?: string | undefined;
    sessionScheduleId?: string;
    subjectId?: string;
    visitId?: string;
}

export interface DiaryPackageDeployment extends DiaryPackageDeploymentCreation {
    id?: string;
    occurred?: string | undefined;
    visit?: Visit | undefined;
    sessionSchedule?: StudyScheduleSession | undefined;
}

export interface StudyScheduleSessionCreation {
    /** The unique identifier for the session */
    id?: string;
    /** The identifier for the study schedule visit that this session is related to */
    studyScheduleVisitId?: string;
    /** Optional - A related session that should be performed before this session */
    preStudyScheduleSessionId?: string | undefined;
    /** Obsolete */
    startOfTestWindow?: string | undefined;
    /** Obsolete */
    endOfTestWindow?: string | undefined;
    /** For eDiary only - Specifics whether the eDiary should be reset to blank when an upload containing this session is completed */
    resetDiaryOnUpload?: boolean | undefined;
    /** The session type for this session */
    sessionTypeId?: string | undefined;
    /** The device type that should be used for this session */
    deviceTypeId?: string | undefined;
    /** The user facing label of the session */
    label?: string | undefined;
    /** A description of the session */
    description?: string | undefined;
    /** Spirotrac VI specific rules relating to the session */
    rules?: string | undefined;
    /** An order that the session should be displayed in the user interface */
    ordinal?: number;
    /** Whether the session is disabled from use or not */
    disabled?: boolean;
    /** Whether completion of the session is mandatory or not */
    mandatory?: boolean;
    /** Optional - the name of the cohort the session belongs to */
    cohort?: string | undefined;
    /** Whether the session can be continuosly re-configured and performed again even if a session already exists of this type */
    rolling?: boolean;
    continueTest?: boolean;
    /** Optional - The expected minimum number of questionnaires that the subject is expected to perform as part of this session */
    expectedMinimumQuestionnaires?: number | undefined;
    /** Optional - The expected minimum number of tests that the subject is expected to perform as part of this session */
    expectedMinimumTests?: number | undefined;
    /** Optional - For diary sessions, whether the session is factored into the compliance that is shown in the Diary sessions daily summary colouring */
    includedInDailySummaryCompliance?: boolean | undefined;
    /** Optional - Additional metadata tags relating to the session */
    tags?: string | undefined;
    /** Optional - The session requires the entering of a dose time */
    requireDoseTime?: boolean;
    /** The group name of session */
    group?: string | undefined;
    /** Sessions with this flag set are only available for selection after the subject has been randomised */
    afterRandomisation?: boolean;
    /** Cough Sessions with this flag set will require a Visual Review process by a QA Inspector */
    visualReview?: boolean;
    /** E-Diary configuration unique identifier */
    eDiaryConfigurationId?: string | undefined;
    /** Whether the session is considered unscheduled */
    unscheduled?: boolean;
    /** Whether the MDE session can be created as a placeholder/shadow session. */
    supportsShadowAssessments?: boolean;
    /** Customized processing algorithms for specific cough sessions. */
    processingAlgorithms?: string[] | undefined;
}

/** Represents a session that should be performed as part of a study */
export interface StudyScheduleSession extends StudyScheduleSessionCreation {
    /** A collection of sessions that are required to be performed before this session */
    requiredSessions?: StudyScheduleSession[] | undefined;
    /** The study schedule visit that this session is related to */
    studyScheduleVisit?: StudyScheduleVisit | undefined;
}

export interface StudyScheduleVisit {
    id?: string;
    studyScheduleId?: string;
    phaseId?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    ordinal?: number;
    disabled?: boolean;
    mandatory?: boolean;
    obligation?: string | undefined;
    spanDays?: boolean;
    commentRequired?: boolean;
    confirmationRequired?: boolean;
    cohort?: string | undefined;
    studySchedule?: StudySchedule | undefined;
    studyScheduleSessions?: StudyScheduleSession[] | undefined;
    requiredVisits?: StudyScheduleVisit[] | undefined;
    blockedByVisits?: StudyScheduleVisit[] | undefined;
}

export interface StudySchedule {
    id?: string;
    studyId?: string;
    created?: string;
    modified?: string;
    studyScheduleVisits?: StudyScheduleVisit[] | undefined;
}

export interface SingleResultOfDiaryPackageDeployment extends SingleResult {
    queryable?: DiaryPackageDeployment[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryQualityFlag {
    /** Entities returned by the query. */
    value?: DiaryQualityFlag[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DiaryQualityFlag {
    id?: string | undefined;
    name?: string | undefined;
    flag?: number;
}

export interface SingleResultOfDiaryQualityFlag extends SingleResult {
    queryable?: DiaryQualityFlag[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryResourceString {
    /** Entities returned by the query. */
    value?: DiaryResourceString[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DiaryResourceString {
    id?: string;
    fileId?: string;
    file?: DiaryConfigurationFile | undefined;
    typeId?: string | undefined;
    parentResourceId?: string | undefined;
    resourceIndex?: string | undefined;
    value?: string | undefined;
}

export interface SingleResultOfDiaryResourceString extends SingleResult {
    queryable?: DiaryResourceString[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiarySession {
    /** Entities returned by the query. */
    value?: DiarySession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a diary session mutation. */
export interface DiarySessionMutation {
    /** The serial number of the eDiary that performed the session */
    serialNumber?: string | undefined;
    /** The version number of the application running on the eDiary at the time of the session */
    applicationVersion?: string | undefined;
    /** The date and time the session occurred */
    occurred?: string | undefined;
    /** The battery level on the eDiary at the time of the session */
    batteryLevel?: number;
    /** The date and time the accuracy was last checked on the ediary */
    accuracyChecked?: string | undefined;
    /** Determines whether the PEF is repeatable across the session */
    pefRepeatable?: boolean | undefined;
    /** The absolute PEF repeatability value for the session */
    pefRepeatability?: number | undefined;
}

/** Class to define a diary session. */
export interface DiarySession extends DiarySessionMutation {
    /** Unique identifier for the diary session */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** The identifier for the type of session */
    sessionType?: string | undefined;
    /** The identifier for the type of device that was used for this diary session */
    deviceType?: string | undefined;
    /** The date and time the diary session was created */
    created?: string;
    /** The date and time the diary session was last modified */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** A collection of free text notes relating to the session */
    notes?: SessionNote[] | undefined;
    /** A collection of diary tests that are part of the session */
    tests?: DiaryTest[] | undefined;
    /** A collection of questionnaire results */
    questionnaires?: QuestionnaireTest[] | undefined;
}

/** Class to define a diary test mutation. */
export interface DiaryTestMutation {
    /** The number of the test within the session */
    index?: number;
    /** Whether the test is acceptable or not */
    accepted?: boolean;
    /** A bitwise number representating the quality indicators detected in this test */
    qualityIndicators?: number;
    /** The FVC value in Litres */
    fvc?: number | undefined;
    /** The PEF value in Litres per minute */
    pef?: number | undefined;
    /** The FEV1 value in Litres */
    fev1?: number | undefined;
    /** The BEV / EV / VExt value in Litres */
    bev?: number | undefined;
    /** The FET value in seconds */
    fet?: number | undefined;
    /** The TExt value in milliseconds */
    tExt?: number | undefined;
    /** The TPef value in milliseconds */
    tPef?: number | undefined;
    /** The date and time the test occurred */
    occurred?: string;
}

/** Class to define a diary test creation. */
export interface DiaryTestCreation extends DiaryTestMutation {
    /** Unique identifier for the diary test */
    id?: string;
    /** Session ID the test belongs to */
    sessionId?: string;
}

/** Class representing a diary test */
export interface DiaryTest extends DiaryTestCreation {
    session?: DiarySession | undefined;
}

export interface QuestionnaireTestMutation {
    /** The general questionnaire score */
    score?: number | undefined;
    /** Specifically for the AQLQ12 questionnaire - symptom score */
    symptomScore?: number | undefined;
    /** Specifically for the AQLQ12 questionnaire - activity limitation score */
    activityLimitationScore?: number | undefined;
    /** Specifically for the AQLQ12 questionnaire - emotional function score */
    emotionalFunctionScore?: number | undefined;
    /** Specifically for the AQLQ12 questionnaire - environmental stimuli score */
    environmentalScore?: number | undefined;
}

export interface QuestionnaireTest extends QuestionnaireTestMutation {
    id?: string;
    sessionId?: string;
    session?: Session | undefined;
    questionnaireId?: string;
    name?: string | undefined;
    occurred?: string;
    answers?: QuestionnaireTestAnswer[] | undefined;
}

export interface QuestionnaireTestAnswerMutation {
    answerWeight?: number;
    answer?: string | undefined;
}

export interface QuestionnaireTestAnswerCreation extends QuestionnaireTestAnswerMutation {
    id?: string;
    questionnaireTestId?: string;
    questionIndex?: string | undefined;
    questionText?: string | undefined;
    answerIndex?: string | undefined;
    answerText?: string | undefined;
}

export interface QuestionnaireTestAnswer extends QuestionnaireTestAnswerCreation {
    questionnaireTest?: QuestionnaireTest | undefined;
}

/** Class to define a diary session creation. */
export interface DiarySessionCreation extends DiarySessionMutation {
    /** Unique identifier for the diary session */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** A collection of diary tests that are part of the session */
    tests?: DiaryTestCreation[] | undefined;
    /** A collection of questionnaire results */
    questionnaires?: QuestionnaireTestCreation[] | undefined;
}

export interface QuestionnaireTestCreation extends QuestionnaireTestMutation {
    id?: string;
    /** The session this questionnaire test relates to */
    sessionId?: string;
    /** The questionnaire that this questionnaire test provides answers to */
    questionnaireId?: string;
    name?: string | undefined;
    occurred?: string;
    answers?: QuestionnaireTestAnswerCreation[] | undefined;
}

export interface SingleResultOfDiarySession extends SingleResult {
    queryable?: DiarySession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDiaryTest {
    /** Entities returned by the query. */
    value?: DiaryTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfDiaryTest extends SingleResult {
    queryable?: DiaryTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFileViewModel {
    /** Entities returned by the query. */
    value?: FileViewModel[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface FileViewModel {
    icon?: string | undefined;
    name?: string | undefined;
    lastWriteTimeUtc?: string | undefined;
    lastWriteTime?: string;
    directoryName?: string | undefined;
    size?: string | undefined;
    length?: number;
    fullPath?: string | undefined;
}

export interface SingleResultOfFileViewModel extends SingleResult {
    queryable?: FileViewModel[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDlcoAnalysisSet {
    /** Entities returned by the query. */
    value?: DlcoAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DlcoAnalysisSetMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - The Best Dlco value. */
    bestDlco?: number | undefined;
    /** Optional - The Best Dlco Corr value. */
    bestDlcoCorr?: number | undefined;
    /** Optional - The Best Va value. */
    bestVa?: number | undefined;
    /** Optional - The Best Kco value. */
    bestKco?: number | undefined;
}

export interface DlcoAnalysisSet extends DlcoAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** Optional - The user (site technician or over-reader) that is responsible for the analysis */
    user?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The test analysis sets associated with the session. */
    tests?: DlcoAnalysisSetTest[] | undefined;
}

export interface DlcoAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

/** Class to define a analysis of a dlco test */
export interface DlcoAnalysisSetTest extends DlcoAnalysisSetTestMutation {
}

export interface AnalysisSetTestFixedComment {
    /** The unique identifier of the analysis set test */
    analysisSetTestId?: string;
    /** The unique identifier of the fixed comment */
    fixedCommentId?: string;
    /** A free text follow on comment that relates to the fixed comment. This field is required if a follow on comment is enforced by the fixed comment set */
    followOnComment?: string | undefined;
}

export interface AnalysisSetFixedComment {
    /** The unique identifier of the analysis set */
    analysisSetId?: string;
    /** The unique identifier of the fixed comment */
    fixedCommentId?: string;
    /** A free text follow on comment that relates to the fixed comment. This field is required if a follow on comment is enforced by the fixed comment set */
    followOnComment?: string | undefined;
}

export interface DlcoAnalysisSetCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the analysis set belongs to. */
    sessionId?: string;
    /** Required - The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** Required - The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - The Best Dlco value. */
    bestDlco?: number | undefined;
    /** Optional - The Best Dlco Corr value. */
    bestDlcoCorr?: number | undefined;
    /** Optional - The Best Va value. */
    bestVa?: number | undefined;
    /** Optional - The Best Kco value. */
    bestKco?: number | undefined;
}

export interface SingleResultOfDlcoAnalysisSet extends SingleResult {
    queryable?: DlcoAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDlcoAnalysisSetTest {
    /** Entities returned by the query. */
    value?: DlcoAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfDlcoAnalysisSetTest extends SingleResult {
    queryable?: DlcoAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCalculationMethod {
    /** Entities returned by the query. */
    value?: CalculationMethod[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CalculationMethod {
    id?: number;
    description?: string | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDlcoSession {
    /** Entities returned by the query. */
    value?: DlcoSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DlcoSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Subject ID the session belongs to. */
    subjectId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the Dlco session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the Dlco session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the Dlco session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the Dlco session was performed. */
    postureType?: string | undefined;
    /** Gender of the subject at the time the Dlco session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the Dlco session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the Dlco session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the Dlco session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the Dlco session was performed. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the Dlco session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the Dlco session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the Dlco session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Overread challenge status of the session that preceeded this session. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
    /** Optional - The HB value. */
    hb?: number | undefined;
    /** Optional - The Predicted Dlco value. */
    predictedDlco?: number | undefined;
    /** Optional - The Predicted Kco value. */
    predictedKco?: number | undefined;
    /** Optional - The Predicted Va value. */
    predictedVa?: number | undefined;
    /** Optional - The Predicted Fiv1 value. */
    predictedFiv1?: number | undefined;
    /** Optional - The Predicted Bht value. */
    predictedBht?: number | undefined;
    /** Optional - The Predicted Dlco Corr value. */
    predictedDlcoCorr?: number | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    coHb?: number | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    humidity?: number | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    atmosphericPressure?: number | undefined;
    /** Differentiates a real-time DLco session from a MDE DLco session  */
    isRealtimeTesting?: boolean | undefined;
    /** Optional - The Best VC from the most recent SVC session. */
    referenceVC?: number | undefined;
    /** Optional - The Predicted KCO corrected. */
    predictedKcoCorr?: number | undefined;
}

/** Class to define the DLco session model. */
export interface DlcoSession extends DlcoSessionMutation {
    /** Unique identifier for the Dlco session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    lastReceived?: string | undefined;
    /** Number of tests relating to the DLco session. */
    testsCount?: number;
    /** Tests relating to the Dlco session. */
    tests?: DlcoTest[] | undefined;
    /** Notes relating to the Dlco session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: DlcoAnalysisSet[] | undefined;
    /** Overreader name. */
    overreader?: string | undefined;
    /** The analysis status of the overreading analysis set */
    overreadStatus?: string | undefined;
}

export interface DlcoTestMutation {
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Date and time the test occurred. */
    occurred?: string;
    /** FvcSession ID the test belongs to. */
    fvcSessionId?: string;
    /** DLco test Type */
    testTypeId?: string | undefined;
    /** Optional - The Dlco value. */
    dlco?: number | undefined;
    /** Optional - The Kco value. */
    kco?: number | undefined;
    /** Optional - The Va value. */
    va?: number | undefined;
    /** Optional - The Iv value. */
    iv?: number | undefined;
    /** Optional - The Bht value. */
    bht?: number | undefined;
    /** Optional - The Dlco Corr value. */
    dlcoCorr?: number | undefined;
    /** Optional - Grade of test as determined at time of testing */
    grade?: string | undefined;
}

export interface DlcoTest extends DlcoTestMutation {
    /** Unique identifier for the Dlco test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
}

/** Class to define the Dlco session creation model. */
export interface DlcoSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the Dlco session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Subject ID the session belongs to. */
    subjectId?: string;
    /** Required - The name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - The date and time the session occurred. */
    occurred?: string;
    /** Optional - The user name of the technician that performed the Dlco session. */
    technician?: string | undefined;
    /** Optional - The temperate recorded on the device (if applicable) at the time the Dlco session was performed. */
    temperature?: number | undefined;
    /** Optional - Type of medication in use by subject at the time the Dlco session was performed. */
    medicationType?: string | undefined;
    /** Optional - The posture of the subject at the time the Dlco session was performed. */
    postureType?: string | undefined;
    /** Optional - Gender of the subject at the time the Dlco session was performed. */
    gender?: string | undefined;
    /** Optional - Age of the subject at the time the Dlco session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Date of Birth of the subject at the time the Dlco session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Height of subject in CM at the time the Dlco session was performed. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG at the time the Dlco session was performed. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Optional - Type of smoker the subject is at the time the Dlco session was performed. */
    smokerType?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the Dlco session was performed. */
    populationGroupId?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) in CM at the time the Dlco session was performed. */
    ulna?: number | undefined;
    /** Optional - The identifier of a session that should be considered the preceding session for this session. */
    preSessionId?: string | undefined;
    /** Optional - The HB value. */
    hb?: number | undefined;
    /** Optional - The Predicted Dlco value. */
    predictedDlco?: number | undefined;
    /** Optional - The Predicted Kco value. */
    predictedKco?: number | undefined;
    /** Optional - The Predicted Va value. */
    predictedVa?: number | undefined;
    /** Optional - The Predicted Fiv1 value. */
    predictedFiv1?: number | undefined;
    /** Optional - The Predicted Bht value. */
    predictedBht?: number | undefined;
    /** Optional - The Predicted Dlco Corr value. */
    predictedDlcoCorr?: number | undefined;
    /** Tests relating to the Dlco session. */
    tests?: DlcoTestCreation[] | undefined;
    /** Optional - Notes relating to the Dlco session. */
    notes?: SessionNote[] | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    coHb?: number | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    humidity?: number | undefined;
    /** Optional - The COHb value recorded as part of a Dlco session. */
    atmosphericPressure?: number | undefined;
    /** Differentiates a real-time DLco session from a MDE DLco session. Defaults to false  */
    isRealtimeTesting?: boolean | undefined;
    /** Optional - The Best VC from the most recent SVC session. */
    referenceVC?: number | undefined;
    /** Optional - The Predicted KCO corrected. */
    predictedKcoCorr?: number | undefined;
}

export interface DlcoTestCreation extends DlcoTestMutation {
    /** Unique identifier for the Dlco test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
}

export interface SingleResultOfDlcoSession extends SingleResult {
    queryable?: DlcoSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfDlcoTest {
    /** Entities returned by the query. */
    value?: DlcoTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfDlcoTest extends SingleResult {
    queryable?: DlcoTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfEcgAnalysisSet {
    /** Entities returned by the query. */
    value?: EcgAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define an ECG analysis set mutation. */
export interface EcgAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site, Over-read or Review */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** The date and time the analysis was started */
    started?: string | undefined;
}

/** Class to define an ECG analysis set. */
export interface EcgAnalysisSet extends EcgAnalysisSetMutation {
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: EcgSession | undefined;
    /** The analysis set tests associated with the session. */
    tests?: EcgAnalysisSetTest[] | undefined;
    /** The identifier of the QC batch this analysis set was generated with, if this analysis set is related to a batch generation */
    batchId?: string | undefined;
}

/** Class to define the ECG session mutation model. */
export interface EcgSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the FVC session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of Birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the FVC session was performed. */
    weight?: number | undefined;
    /** The Body Mass Index of the subject at the time the session was performed. */
    bmi?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** The average Heart rate across all recordings within this session */
    hrAvg?: number | undefined;
    /** The average QtcFri (Fridericia) across all recordings within this session */
    qtcFriAvg?: number | undefined;
    /** The average QtcFri (Framingham) across all recordings within this session */
    qtcFraAvg?: number | undefined;
    /** The average QtcBaz (Bazett) across all recordings within this session */
    qtcBazAvg?: number | undefined;
    /** The average QtcHod (Hodges) across all recordings within this session */
    qtcHodAvg?: number | undefined;
    /** The average RR interval in milliseconds across all recordings within this session */
    rrAvg?: number | undefined;
    /** The average PR interval in milliseconds across all recordings within this session */
    prAvg?: number | undefined;
    /** The average PQ interval in milliseconds across all recordings within this session */
    pqAvg?: number | undefined;
    /** The average QRS interval in milliseconds across all recordings within this session */
    qrsAvg?: number | undefined;
    /** The average QT (uncorrected) interval in milliseconds across all recordings within this session */
    qtAvg?: number | undefined;
    /** The average P in milliseconds across all recordings within this session */
    pAvg?: number | undefined;
    /** The average ST interval in milliseconds across all recordings within this session */
    stAvg?: number | undefined;
}

/** Class to define the ECG session model. */
export interface EcgSession extends EcgSessionMutation {
    /** Unique identifier for the FVC session. */
    id?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit relating to the session. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: EcgTest[] | undefined;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the ECG test mutation model. */
export interface EcgTestMutation {
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** Duration of recording in milliseconds. */
    duration?: number;
    /** Heart rate in beats per minute. */
    hr?: number | undefined;
    /** Duration of P wave in milliseconds. */
    p?: number | undefined;
    /** Duration of Q, R and S waves in milliseconds. */
    qrs?: number | undefined;
    /** Interval between the start of the P wave until the start of the QRS complex in milliseconds. */
    pr?: number | undefined;
    /** Interval between the start of the P wave until the start of the QRS complex in milliseconds. */
    pq?: number | undefined;
    /** Duration of S upto T wave in milliseconds. */
    st?: number | undefined;
    /** Interval of Q upto T wave in milliseconds. */
    qt?: number | undefined;
    /** Interval of R upto R wave in milliseconds. */
    rr?: number | undefined;
    /** Corrected QT interval using Fredericia formula in milliseconds. */
    qtcFri?: number | undefined;
    /** Corrected QT interval using Framinham formula in milliseconds. */
    qtcFra?: number | undefined;
    /** Corrected QT interval using Bazett formula in milliseconds. */
    qtcBaz?: number | undefined;
    /** Corrected QT interval using Hodge formula in milliseconds. */
    qtcHod?: number | undefined;
    /** Sample rate of recording in milliseconds. */
    sampleRate?: number;
    /** Scale factor of recording. */
    scale?: number;
    /** Right arm to left arm lead reading in millivolts, comma seperated integers. */
    leadI?: string | undefined;
    /** Right arm to left leg lead reading in millivolts, comma seperated integers. */
    leadII?: string | undefined;
    /** Left arm to left leg lead reading in millivolts, comma seperated integers. */
    leadIII?: string | undefined;
    /** Right arm lead reading in millivolts, comma seperated integers. */
    leadAvr?: string | undefined;
    /** Left arm lead reading in millivolts, comma seperated integers. */
    leadAvl?: string | undefined;
    /** Feet lead reading in millivolts, comma seperated integers. */
    leadAvf?: string | undefined;
    /** Chest lead 1 reading in millivolts, comma seperated integers. */
    leadV1?: string | undefined;
    /** Chest lead 2 reading in millivolts, comma seperated integers. */
    leadV2?: string | undefined;
    /** Chest lead 3 reading in millivolts, comma seperated integers. */
    leadV3?: string | undefined;
    /** Chest lead 4 reading in millivolts, comma seperated integers. */
    leadV4?: string | undefined;
    /** Chest lead 5 reading in millivolts, comma seperated integers. */
    leadV5?: string | undefined;
    /** Chest lead 6 reading in millivolts, comma seperated integers. */
    leadV6?: string | undefined;
    /** Optional - P Axis at the time the test was performed. */
    pAxis?: number | undefined;
    /** Optional - Qrs Axis at the time the test was performed. */
    qrsAxis?: number | undefined;
    /** Optional - T Axis at the time the test was performed. */
    tAxis?: number | undefined;
    /** Representative right arm to left arm lead reading in millivolts, comma seperated integers. */
    representativeLeadI?: string | undefined;
    /** Representative right arm to left leg lead reading in millivolts, comma seperated integers. */
    representativeLeadII?: string | undefined;
    /** Representative left arm to left leg lead reading in millivolts, comma seperated integers. */
    representativeLeadIII?: string | undefined;
    /** Representative right arm lead reading in millivolts, comma seperated integers. */
    representativeLeadAvr?: string | undefined;
    /** Representative left arm lead reading in millivolts, comma seperated integers. */
    representativeLeadAvl?: string | undefined;
    /** Representative feet lead reading in millivolts, comma seperated integers. */
    representativeLeadAvf?: string | undefined;
    /** Representative chest lead 1 reading in millivolts, comma seperated integers. */
    representativeLeadV1?: string | undefined;
    /** Representative chest lead 2 reading in millivolts, comma seperated integers. */
    representativeLeadV2?: string | undefined;
    /** Representative chest lead 3 reading in millivolts, comma seperated integers. */
    representativeLeadV3?: string | undefined;
    /** Representative chest lead 4 reading in millivolts, comma seperated integers. */
    representativeLeadV4?: string | undefined;
    /** Representative chest lead 5 reading in millivolts, comma seperated integers. */
    representativeLeadV5?: string | undefined;
    /** Representative chest lead 6 reading in millivolts, comma seperated integers. */
    representativeLeadV6?: string | undefined;
    /** Rhythm analysis statement for the test. */
    analysisStatement?: string | undefined;
    /** Diagnostics statement for the test. */
    diagnosticStatement?: string | undefined;
    /** Summary statement for the test. */
    summaryStatement?: string | undefined;
    /** Date and time the test occurred. */
    occurred?: string;
    /** Comma delimited list of applied filters at the time of the test */
    currentFilters?: string | undefined;
}

/** Class to define the ECG test model. */
export interface EcgTest extends EcgTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: EcgSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define an ECG analysis set test mutation. */
export interface EcgAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Optional - The analysis acceptability of this test */
    accepted?: boolean | undefined;
    /** Optional - Annotations relating to the ECG analysis */
    annotations?: EcgAnalysisSetTestAnnotation[] | undefined;
    /** Optional - A Base 64 representation of the annotations in AMPS proprietary format */
    ampsAnnotationsTextBase64?: string | undefined;
    /** Optional - A Base 64 representation of the annotations in FDA HL7 format */
    hl7AnnotationsTextBase64?: string | undefined;
    /** Optional - The global RR interval for the analysis in milliseconds */
    rr?: number | undefined;
    /** Optional - The recalculated heart rate in beats per minute (bpm) from the RR interval */
    hr?: number | undefined;
    /** Optional - QT corrected using Bazetts formula */
    qTcBaz?: number | undefined;
    /** Optional - QT corrected using Fridericia formula */
    qTcFri?: number | undefined;
    /** Optional - QT corrected using Framingham formula */
    qTcFra?: number | undefined;
    /** Optional - QT corrected using Hodges formula */
    qTcHod?: number | undefined;
    /** The identifier of the analyst who performed the analysis of analysis set test */
    analystId?: string | undefined;
    /** The date and time the analysis of the test was last completed */
    analysisCompleted?: string | undefined;
    /** A collection of interpretations selected for the analysis set test */
    intepretations?: AnalysisSetTestFixedComment[] | undefined;
    /** A collection of alerts selected for the analysis set test */
    alerts?: AnalysisSetTestFixedComment[] | undefined;
}

/** Class to define an ECG analysis set test */
export interface EcgAnalysisSetTest extends EcgAnalysisSetTestMutation {
    /** The test this analysis test relates to. */
    test?: EcgTest | undefined;
    /** The analysis set this analysis relates to. */
    analysisSet?: EcgAnalysisSet | undefined;
    /** The analyst who performed the analysis of the analysis set test */
    analyst?: string | undefined;
}

export interface EcgAnalysisSetTestAnnotation {
    annotation?: string | undefined;
    leadIndex?: number;
    beatIndex?: number;
    value?: number | undefined;
}

/** Class to define an ECG analysis set creation. */
export interface EcgAnalysisSetCreation extends EcgAnalysisSetMutation {
}

export interface SingleResultOfEcgAnalysisSet extends SingleResult {
    queryable?: EcgAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfEcgAnalysisSetTest {
    /** Entities returned by the query. */
    value?: EcgAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfEcgAnalysisSetTest extends SingleResult {
    queryable?: EcgAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfEcgAnalysisSetType {
    /** Entities returned by the query. */
    value?: EcgAnalysisSetType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the analysis set types for ECG data. */
export interface EcgAnalysisSetType {
    /** The unique identifier for the  type */
    id?: string | undefined;
    /** The name of the type */
    name?: string | undefined;
}

export interface SingleResultOfEcgAnalysisSetType extends SingleResult {
    queryable?: EcgAnalysisSetType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfEcgSession {
    /** Entities returned by the query. */
    value?: EcgSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the ECG session creation model. */
export interface EcgSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the FVC session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Optional - Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the FVC session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Optional - Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Optional - Name of the technician that performed session. */
    technician?: string | undefined;
    /** Optional - Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Date of Birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG at the time the FVC session was performed. */
    weight?: number | undefined;
    /** Optional - The Body Mass Index of the subject at the time the session was performed. */
    bmi?: number | undefined;
    /** Optional - Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Optional - Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Optional - Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Optional - Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** Optional - The date and time the session occurred. */
    occurred?: string;
    /** Required - Tests relating to the session. */
    tests?: EcgTestCreation[] | undefined;
    /** Optional - Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    /** The average Heart rate across all recordings within this session */
    hrAvg?: number | undefined;
    /** The average QtcFri (Fridericia) across all recordings within this session */
    qtcFriAvg?: number | undefined;
    /** The average QtcFri (Framingham) across all recordings within this session */
    qtcFraAvg?: number | undefined;
    /** The average QtcBaz (Bazett) across all recordings within this session */
    qtcBazAvg?: number | undefined;
    /** The average QtcHod (Hodges) across all recordings within this session */
    qtcHodAvg?: number | undefined;
    /** The average RR interval in milliseconds across all recordings within this session */
    rrAvg?: number | undefined;
    /** The average PR interval in milliseconds across all recordings within this session */
    prAvg?: number | undefined;
    /** The average PQ interval in milliseconds across all recordings within this session */
    pqAvg?: number | undefined;
    /** The average QRS interval in milliseconds across all recordings within this session */
    qrsAvg?: number | undefined;
    /** The average QT (uncorrected) interval in milliseconds across all recordings within this session */
    qtAvg?: number | undefined;
    /** The average P in milliseconds across all recordings within this session */
    pAvg?: number | undefined;
    /** The average ST interval in milliseconds across all recordings within this session */
    stAvg?: number | undefined;
}

/** Class to define the ECG test creation model. */
export interface EcgTestCreation {
    /** Optional - Unique ID of test. */
    id?: string;
    /** Required - Session ID the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - Duration of recording in milliseconds. */
    duration?: number;
    /** Required - Heart rate in beats per minute. */
    hr?: number | undefined;
    /** Optional - Duration of P wave in milliseconds. */
    p?: number | undefined;
    /** Optional - Duration of Q, R and S waves in milliseconds. */
    qrs?: number | undefined;
    /** Optional - Interval between the start of the P wave until the start of the QRS complex in milliseconds. */
    pr?: number | undefined;
    /** Optional - Interval between the start of the P wave until the start of the QRS complex in milliseconds. */
    pq?: number | undefined;
    /** Optional - Duration of S upto T wave in milliseconds. */
    st?: number | undefined;
    /** Optional - Interval of Q upto T wave in milliseconds. */
    qt?: number | undefined;
    /** Optional - Interval of R upto R wave in milliseconds. */
    rr?: number | undefined;
    /** Optional - Corrected QT interval using Fredericia formula in milliseconds. */
    qtcFri?: number | undefined;
    /** Optional - Corrected QT interval using Framinham formula in milliseconds. */
    qtcFra?: number | undefined;
    /** Optional - Corrected QT interval using Bazett formula in milliseconds. */
    qtcBaz?: number | undefined;
    /** Optional - Corrected QT interval using Hodge formula in milliseconds. */
    qtcHod?: number | undefined;
    /** Required - Sample rate of recording in milliseconds. */
    sampleRate?: number;
    /** Required - Scale factor of recording. */
    scale?: number;
    /** Required - Right arm to left arm lead reading in millivolts, comma seperated integers. */
    leadI?: string | undefined;
    /** Required - Right arm to left leg lead reading in millivolts, comma seperated integers. */
    leadII?: string | undefined;
    /** Required - Left arm to left leg lead reading in millivolts, comma seperated integers. */
    leadIII?: string | undefined;
    /** Required - Right arm lead reading in millivolts, comma seperated integers. */
    leadAvr?: string | undefined;
    /** Required - Left arm lead reading in millivolts, comma seperated integers. */
    leadAvl?: string | undefined;
    /** Required - Feet lead reading in millivolts, comma seperated integers. */
    leadAvf?: string | undefined;
    /** Required - Chest lead 1 reading in millivolts, comma seperated integers. */
    leadV1?: string | undefined;
    /** Required - Chest lead 2 reading in millivolts, comma seperated integers. */
    leadV2?: string | undefined;
    /** Required - Chest lead 3 reading in millivolts, comma seperated integers. */
    leadV3?: string | undefined;
    /** Required - Chest lead 4 reading in millivolts, comma seperated integers. */
    leadV4?: string | undefined;
    /** Required - Chest lead 5 reading in millivolts, comma seperated integers. */
    leadV5?: string | undefined;
    /** Required - Chest lead 6 reading in millivolts, comma seperated integers. */
    leadV6?: string | undefined;
    /** Required - Representative right arm to left arm lead reading in millivolts, comma seperated integers. */
    representativeLeadI?: string | undefined;
    /** Required - Representative right arm to left leg lead reading in millivolts, comma seperated integers. */
    representativeLeadII?: string | undefined;
    /** Required - Representative left arm to left leg lead reading in millivolts, comma seperated integers. */
    representativeLeadIII?: string | undefined;
    /** Required - Representative right arm lead reading in millivolts, comma seperated integers. */
    representativeLeadAvr?: string | undefined;
    /** Required - Representative left arm lead reading in millivolts, comma seperated integers. */
    representativeLeadAvl?: string | undefined;
    /** Required - Representative feet lead reading in millivolts, comma seperated integers. */
    representativeLeadAvf?: string | undefined;
    /** Required - Representative chest lead 1 reading in millivolts, comma seperated integers. */
    representativeLeadV1?: string | undefined;
    /** Required - Representative chest lead 2 reading in millivolts, comma seperated integers. */
    representativeLeadV2?: string | undefined;
    /** Required - Representative chest lead 3 reading in millivolts, comma seperated integers. */
    representativeLeadV3?: string | undefined;
    /** Required - Representative chest lead 4 reading in millivolts, comma seperated integers. */
    representativeLeadV4?: string | undefined;
    /** Required - Representative chest lead 5 reading in millivolts, comma seperated integers. */
    representativeLeadV5?: string | undefined;
    /** Required - Representative chest lead 6 reading in millivolts, comma seperated integers. */
    representativeLeadV6?: string | undefined;
    /** Optional - P Axis at the time the test was performed. */
    pAxis?: number | undefined;
    /** Optional - Qrs Axis at the time the test was performed. */
    qrsAxis?: number | undefined;
    /** Optional - T Axis at the time the test was performed. */
    tAxis?: number | undefined;
    /** Optional - Rhythm analysis statement for the test. */
    analysisStatement?: string | undefined;
    /** Optional - Diagnostics statement for the test. */
    diagnosticStatement?: string | undefined;
    /** Optional - Summary statement for the test. */
    summaryStatement?: string | undefined;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Comma delimited list of applied filters at the time of the test */
    currentFilters?: string | undefined;
}

export interface DynamicObject {
}

export interface Delta extends DynamicObject {
    Kind?: DeltaItemKind;
}

export interface DeltaOfEcgSession extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export enum DeltaItemKind {
    Resource = 0,
    DeletedResource = 1,
    DeltaDeletedLink = 2,
    DeltaLink = 3,
    Unknown = 4,
}

export interface SingleResultOfEcgSession extends SingleResult {
    queryable?: EcgSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfEcgTest {
    /** Entities returned by the query. */
    value?: EcgTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DeltaOfEcgTest extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export interface SingleResultOfEcgTest extends SingleResult {
    queryable?: EcgTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFenoQC {
    /** Entities returned by the query. */
    value?: FenoQC[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface FenoQCMutation {
    occurred?: string;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    feno?: number | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    errorCodes?: string | undefined;
    remainingMeasurements?: string | undefined;
    technician?: string | undefined;
    alertNumber?: number | undefined;
    movingMeanDay1?: number | undefined;
    movingMeanDay2?: number | undefined;
    movingMeanDay3?: number | undefined;
    status?: string | undefined;
}

export interface FenoQC extends FenoQCMutation {
    id?: string;
    created?: string;
    modified?: string;
}

export interface FenoQCCreation {
    id?: string;
    occurred?: string;
    goodTest?: boolean | undefined;
    childMode?: boolean | undefined;
    feno?: number | undefined;
    serialNumber?: string | undefined;
    sensorSerialNumber?: string | undefined;
    appBuild?: string | undefined;
    appVersion?: string | undefined;
    botBuild?: string | undefined;
    botVersion?: string | undefined;
    counter?: number | undefined;
    errorCodes?: string | undefined;
    remainingMeasurements?: string | undefined;
    technician?: string | undefined;
    alertNumber?: number | undefined;
    movingMeanDay1?: number | undefined;
    movingMeanDay2?: number | undefined;
    movingMeanDay3?: number | undefined;
    status?: string | undefined;
}

export interface SingleResultOfFenoQC extends SingleResult {
    queryable?: FenoQC[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFenoSession {
    /** Entities returned by the query. */
    value?: FenoSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the FENO session mutation model. */
export interface FenoSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - Whether the site accepted the test. */
    goodSession?: boolean | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** The Body Mass Index of the subject at the time the session was performed. */
    bmi?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Id of best FENO Test calculated by spirotrac from tests ordered by best. */
    bestFirstTestId?: string | undefined;
    /** Id of second best FENO Test calculated by spirotrac from tests ordered by best. */
    bestSecondTestId?: string | undefined;
    /** Repeatability field of the session. */
    variance?: number | undefined;
    /** Best FENO test. */
    mean?: number | undefined;
    /** Numeric representation of QC test acceptability status. */
    qcAcceptStatus?: number | undefined;
    /** Cumulative status flag on whether the tests overall are repeatable. */
    qcRepeatStatus?: number | undefined;
    /** BestParam1 calculated from the best FENO test available. */
    best?: number | undefined;
}

/** Class to define the FENO session model. */
export interface FenoSession extends FenoSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: FenoTest[] | undefined;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the FENO test mutation model. */
export interface FenoTestMutation {
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** Feno in parts per billion. */
    feno?: number | undefined;
    /** Whether the test was good. */
    goodTest?: boolean | undefined;
    /** Whether a child performed the test. */
    childMode?: boolean | undefined;
    /** Serial number of device used in test. */
    serialNumber?: string | undefined;
    /** Serial number of sensor used in test. */
    sensorSerialNumber?: string | undefined;
    /** Application build number. */
    appBuild?: string | undefined;
    /** Application version number. */
    appVersion?: string | undefined;
    /** Bot build number. */
    botBuild?: string | undefined;
    /** Bot version number. */
    botVersion?: string | undefined;
    /** Counter for test. */
    counter?: number | undefined;
    /** Alert number for test. */
    alertNumber?: number | undefined;
    /** Error codes of test. */
    errorCodes?: string | undefined;
    /** Whether daily QC passed. */
    dailyQCPassed?: number | undefined;
    /** Expiry date of the device. */
    deviceExpiryDate?: string | undefined;
    /** Number of remaining tests for the device. */
    deviceRemainingTests?: number | undefined;
    /** Expiry date of the sensor. */
    sensorExpiryDate?: string | undefined;
    /** Number of remaining tests for the sensor. */
    sensorRemainingTests?: number | undefined;
    /** Expiry date of the scrubber. */
    handleScrubberExpiryDate?: string | undefined;
    /** Number of tests remaining on the scrubber. */
    handleScrubberRemainingTests?: number | undefined;
    /** Date and time the test occurred. */
    occurred?: string;
}

/** Class to define the FENO test model. */
export interface FenoTest extends FenoTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: FenoSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define the FENO session creation model. */
export interface FenoSessionCreation extends BaseSession {
    /** Unique identifier for the session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - Whether the site accepted the test. */
    goodSession?: boolean | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** The Body Mass Index of the subject at the time the session was performed. */
    bmi?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Tests relating to the session. */
    tests?: FenoTestCreation[] | undefined;
    /** Notes relating to the session. */
    notes?: SessionNoteCreation[] | undefined;
    /** Id of best FENO Test calculated by spirotrac from tests ordered by best. */
    bestFirstTestId?: string | undefined;
    /** Id of second best FENO Test calculated by spirotrac from tests ordered by best. */
    bestSecondTestId?: string | undefined;
    /** Repeatability field of the session. */
    variance?: number | undefined;
    /** Best FENO test. */
    mean?: number | undefined;
    /** Numeric representation of QC test acceptability status. */
    qcAcceptStatus?: number | undefined;
    /** Cumulative status flag on whether the tests overall are repeatable. */
    qcRepeatStatus?: number | undefined;
    /** BestParam1 calculated from the best FENO test available. */
    best?: number | undefined;
}

/** Class to define the FENO test creation model. */
export interface FenoTestCreation {
    /** Unique ID of test. */
    id?: string;
    /** Required - Session ID the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - Feno in parts per billion. */
    feno?: number | undefined;
    /** Whether the test was good. */
    goodTest?: boolean | undefined;
    /** Whether a child performed the test. */
    childMode?: boolean | undefined;
    /** Serial number of device used in test. */
    serialNumber?: string | undefined;
    /** Serial number of sensor used in test. */
    sensorSerialNumber?: string | undefined;
    /** Application build number. */
    appBuild?: string | undefined;
    /** Application version number. */
    appVersion?: string | undefined;
    /** Bot build number. */
    botBuild?: string | undefined;
    /** Bot version number. */
    botVersion?: string | undefined;
    /** Counter for test. */
    counter?: number | undefined;
    /** Alert number for test. */
    alertNumber?: number | undefined;
    /** Error codes of test. */
    errorCodes?: string | undefined;
    /** Whether daily QC passed. */
    dailyQCPassed?: number | undefined;
    /** Expiry date of the device. */
    deviceExpiryDate?: string | undefined;
    /** Number of remaining tests for the device. */
    deviceRemainingTests?: number | undefined;
    /** Expiry date of the sensor. */
    sensorExpiryDate?: string | undefined;
    /** Number of remaining tests for the sensor. */
    sensorRemainingTests?: number | undefined;
    /** Expiry date of the scrubber. */
    handleScrubberExpiryDate?: string | undefined;
    /** Number of tests remaining on the scrubber. */
    handleScrubberRemainingTests?: number | undefined;
    /** Required - Date and time the test occurred. */
    occurred?: string;
}

/** Class to capture a creation of a session note */
export interface SessionNoteCreation {
    /** Unique ID for the session note */
    id?: string;
    /** Required - The related session for the note */
    sessionId?: string;
    /** The email address of the user creating the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

export interface SingleResultOfFenoSession extends SingleResult {
    queryable?: FenoSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFenoTest {
    /** Entities returned by the query. */
    value?: FenoTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfFenoTest extends SingleResult {
    queryable?: FenoTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFileAttachment {
    /** Entities returned by the query. */
    value?: FileAttachment[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface FileAttachment {
    id?: string;
    relatedEntityId?: number;
    fileId?: number;
    file?: File | undefined;
}

export interface FileCreation {
    fileName?: string | undefined;
    fileSizeInBytes?: number | undefined;
    contentType?: string | undefined;
    /** The content of the file in bytes */
    fileContent?: string | undefined;
    studyIds?: string[] | undefined;
}

export interface File extends FileCreation {
    id?: string;
    downloadLink?: string | undefined;
    fullFilePath?: string | undefined;
    lastModified?: string | undefined;
    studies?: StudyFile[] | undefined;
    fileEntityAttachments?: FileAttachment[] | undefined;
}

/** Class to represent a study file */
export interface StudyFile {
    /** The study this relates to */
    studyId?: string;
    /** The file this relates to */
    fileId?: string;
    /** The study this relates to */
    study?: Study | undefined;
    /** The file this relates to */
    file?: File | undefined;
}

export interface SingleResultOfFileAttachment extends SingleResult {
    queryable?: FileAttachment[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFile {
    /** Entities returned by the query. */
    value?: File[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfFile extends SingleResult {
    queryable?: File[] | undefined;
}

/** Represents the model for receiving a partialfile upload object */
export interface FileUpload {
    /** The identifier of the associated entity. */
    id?: string;
    /** The start position wherein the file part aligns. */
    startPosition?: number;
    /** The file part contents. */
    filePart?: string | undefined;
    /** The total size of the upload. */
    totalSize?: number;
}

export interface SingleResultOfFileUpload extends SingleResult {
    queryable?: FileUpload[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFixedComment {
    /** Entities returned by the query. */
    value?: FixedComment[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface FixedCommentCreation {
    /** Optional - The unique identifier of the fixed comment */
    id?: string;
    /** Required - The unique identifier of the parent fixed comment set */
    setId?: string;
    /** Required - The fixed comment text */
    comment?: string | undefined;
    /** Optional - A description for the fixed comment */
    description?: string | undefined;
    /** Required - Whether a follow on comment is available to the user when selecting this comment */
    followOnCommentAvailable?: boolean;
    /** Required - Whether a follow on comment is required to be entered when selecting this comment */
    followOnCommentRequired?: boolean;
    /** A annotation to be displayed when requesting the follow on comment */
    followOnCommentAnnotation?: string | undefined;
    /** Required - Whether the fixed comment is disabled or not */
    disabled?: boolean;
    /** A zero counting display order for the fixed comment within the set where the lower number is displayed first */
    displayOrder?: number;
}

export interface FixedComment extends FixedCommentCreation {
    /** A bit wise mask for the comment */
    mask?: number;
}

export interface SingleResultOfFixedComment extends SingleResult {
    queryable?: FixedComment[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFixedCommentSetEntityType {
    /** Entities returned by the query. */
    value?: FixedCommentSetEntityType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the fixed comment entity types. */
export interface FixedCommentSetEntityType {
    /** The unique identifier for the fixed comment entity type */
    id?: string | undefined;
    /** The name of the fixed comment entity type */
    name?: string | undefined;
}

export interface SingleResultOfFixedCommentSetEntityType extends SingleResult {
    queryable?: FixedCommentSetEntityType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFixedCommentSet {
    /** Entities returned by the query. */
    value?: FixedCommentSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to represent a fixed comment set */
export interface FixedCommentSet {
    /** Unique ID of the fixed comment set */
    id?: string;
    /** The study set this set belongs to */
    studySetId?: string;
    /** The study set this set belongs to */
    studySet?: StudyFixedCommentSet | undefined;
    /** The fixed comment entity type (such as Session or Test) */
    entityType?: string | undefined;
    /** Optional - A default comment that will automatically selected if the fixed comment selection is left blank */
    defaultCommentId?: string | undefined;
    /** Optional - A default comment that will automatically selected if the fixed comment selection is left blank */
    defaultComment?: FixedComment | undefined;
    /** A collection of the fixed comments that belong to the set */
    comments?: FixedComment[] | undefined;
}

/** Class to represent a study fixed comment set */
export interface StudyFixedCommentSet {
    /** Unique ID of the fixed comment set */
    id?: string;
    /** The study the fixed comment set relates to */
    studyId?: string;
    /** The session type the fixed comment set relates to */
    sessionType?: string | undefined;
    /** The comment set type */
    commentSetType?: string | undefined;
    /** A collection of fixed comments sets */
    fixedCommentSets?: FixedCommentSet[] | undefined;
}

export interface SingleResultOfFixedCommentSet extends SingleResult {
    queryable?: FixedCommentSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFixedCommentSetType {
    /** Entities returned by the query. */
    value?: FixedCommentSetType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the fixed comment set types. */
export interface FixedCommentSetType {
    /** The unique identifier for the fixed comment set type */
    id?: string | undefined;
    /** The name of the fixed comment set type */
    name?: string | undefined;
}

export interface SingleResultOfFixedCommentSetType extends SingleResult {
    queryable?: FixedCommentSetType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFvcSession {
    /** Entities returned by the query. */
    value?: FvcSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the FVC session mutation model. */
export interface FvcSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the FVC session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the FVC session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the FVC session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the FVC session was performed. */
    postureType?: string | undefined;
    /** Identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Gender of the subject at the time the FVC session was performed. Required or Optional based on the study configuration. */
    gender?: string | undefined;
    /** Age of the subject at the time the FVC session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. Required or Optional based on the study configuration. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the FVC session was performed, if specified then age cannot be. Required or Optional based on the study configuration. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the FVC session was performed. Required or Optional based on the study configuration. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the FVC session was performed. Required or Optional based on the study configuration. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the FVC session was performed. Required or Optional based on the study configuration. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the FVC session was performed. Required or Optional based on the study configuration. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. Required or Optional based on the study configuration. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the FVC session was performed. */
    ulna?: number | undefined;
    /** Dose amount of a medication given to the subject at the time of the session. */
    doseAmount?: number | undefined;
    /** Time of the dose of medication given to the subject at the time of the session. */
    doseTime?: string | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Optional - Overread challenge status of the session either ORS_NOT_CHALLENGED or ORS_CHALLENGED. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
    /** Predicted FEV1 value (Forced Expiratory Volume in the first 1 seconds) in litres. */
    predictedFev1?: number | undefined;
    /** Predicted FVC (Forced Vital Capacity) value in litres. */
    predictedFvc?: number | undefined;
    /** Optional - The predicted FEV1 over FVC ratio. */
    predictedFev1Fvc?: number | undefined;
    /** Predicted PEF (Peak Expiratory Flow) value in litres per minute. */
    predictedPefMin?: number | undefined;
    /** Predicted PEF (Peak Expiratory Flow) value in litres per second. */
    predictedPefSec?: number | undefined;
    /** Predicted mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    predictedFef2575?: number | undefined;
    /** Predicted FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    predictedFev6?: number | undefined;
    /** Predicted FEV6 over FVC value in litres */
    predictedFev6Fvc?: number | undefined;
    /** Predicted Forced inspiratory Flow in the first 75th percentile of the curve in litres per second. */
    predictedFef75?: number | undefined;
    /** Predicted FEF2575 over FVC ratio. */
    predictedFef2575Fvc?: number | undefined;
    /** Predicted SVC (Slow Vital Capacity) value in litres */
    predictedSvc?: number | undefined;
    /** Predicted FEV0.5 value in litres */
    predictedFev05?: number | undefined;
    /** Predicted FEV0.5 over FVC ratio */
    predictedFev05Fvc?: number | undefined;
    /** Predicted FEV0.75 value in litres */
    predictedFev075?: number | undefined;
    /** Predicted FEV0.75 over FVC ratio */
    predictedFev075Fvc?: number | undefined;
    /** Predicted FEV1 over PEF ratio */
    predictedFev1Pef?: number | undefined;
    /** Predicted FEV3 value in litres */
    predictedFev3?: number | undefined;
    /** Predicted FEV3 over FVC value in litres */
    predictedFev3Fvc?: number | undefined;
    /** Predicted FEF 0.2-1.2 in litres per second */
    predictedFef0212?: number | undefined;
    /** Predicted FEV 75-85 in litres per second */
    predictedFef7585?: number | undefined;
    /** Predicted FEF 25 in litres per second */
    predictedFef25?: number | undefined;
    /** Predicted FEF 50 in litres per second */
    predictedFef50?: number | undefined;
    /** Predicted FIVC (Forced inspiratory vital capacity) in litres */
    predictedFivc?: number | undefined;
    /** Predicted FIVC over FVC ratio */
    predictedFivcFvc?: number | undefined;
    /** Predicted PIF (Peak Inspiratory Flow) value in litres per minute. */
    predictedPifMin?: number | undefined;
    /** Predicted PIF (Peak Inspiratory Flow) value in litres per second. */
    predictedPifSec?: number | undefined;
    /** Predicted FIF 25 in litres per second */
    predictedFif25?: number | undefined;
    /** Predicted FIF 50 in litres per second */
    predictedFif50?: number | undefined;
    /** Predicted FIF 75 in litres per second */
    predictedFif75?: number | undefined;
    /** Predicted FIF 50 over FEF 50 ratio */
    predictedFifFef50?: number | undefined;
    /** Predicted FMFT (Forced mid flow time) in seconds */
    predictedFmft?: number | undefined;
    /** Predicted IC in litres */
    predictedIc?: number | undefined;
    /** Predicted MVVIND in litres per minute */
    predictedMvvind?: number | undefined;
    /** Predicted FRC in litres */
    predictedFrc?: number | undefined;
    /** Predicted RV in litres */
    predictedRv?: number | undefined;
    /** Predicted TLC in litres */
    predictedTlc?: number | undefined;
    /** Predicted ERV in litres */
    predictedErv?: number | undefined;
    /** Predicted FEV1 Ratio in litres */
    predictedFev1R?: number | undefined;
    /** Predicted FET in seconds */
    predictedFet?: number | undefined;
    /** Predicted IRV (Inspiratory Reserve Volume) in litres */
    predictedIrv?: number | undefined;
    /** Predicted TV (Tidal Volume) in litres */
    predictedTv?: number | undefined;
    /** Predicted FIV1 (Forced Inspiratory Volume) in litres */
    predictedFiv1?: number | undefined;
    predictedEOTV?: number | undefined;
    predictedEv?: number | undefined;
    predictedEvFvc?: number | undefined;
    predictedFef50Fif50?: number | undefined;
    predictedFefMax?: number | undefined;
    predictedFev1Fev6?: number | undefined;
    predictedFev1Fivc?: number | undefined;
    predictedFev1Ht2?: number | undefined;
    predictedFev1Ivc?: number | undefined;
    predictedFev1Q?: number | undefined;
    predictedFev1Vc?: number | undefined;
    predictedFev3Vc?: number | undefined;
    predictedFiv1Fivc?: number | undefined;
    predictedFiv1Fvc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedRawind?: number | undefined;
    predictedRisetime?: number | undefined;
    predictedText?: number | undefined;
    predictedThes?: number | undefined;
    predictedTpef?: number | undefined;
    predictedIfr?: number | undefined;
    /** The FEV1 absolute repeatability calculated at site */
    siteFev1AbsoluteRepeatability?: number | undefined;
    /** The FVC absolute repeatability calculated at site */
    siteFvcAbsoluteRepeatability?: number | undefined;
    /** The FVC percentage repeatability calculated at site */
    siteFvcPercentageRepeatability?: number | undefined;
    /** The FEV1 percentage repeatability calculated at site */
    siteFev1PercentageRepeatability?: number | undefined;
    /** Status of the session whether it's completed or in progress */
    status?: string | undefined;
    /** Lower Limit of Normality for fvc */
    llnFvc?: number | undefined;
    /** Lower Limit of Normality for fev1 */
    llnFev1?: number | undefined;
    /** Lower Limit of Normality for fev1Fvc */
    llnFev1Fvc?: number | undefined;
    /** Lower Limit of Normality for pef */
    llnPef?: number | undefined;
    /** Lower Limit of Normality for fef2575 */
    llnFef2575?: number | undefined;
    /** drop Percentage in FEV1 from baseline */
    fev1Drop?: number | undefined;
}

/** Class to define the FVC session query model. */
export interface FvcSession extends FvcSessionMutation {
    /** Unique identifier for the FVC session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    lastReceived?: string | undefined;
    /** Tests relating to the FVC session. */
    tests?: FvcTest[] | undefined;
    /** Number of tests relating to the FVC session. */
    testsCount?: number;
    /** Notes relating to the FVC session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: FvcAnalysisSet[] | undefined;
    /** Overreader name. */
    overreader?: string | undefined;
    /** The analysis status of the overreading analysis set */
    overreadStatus?: string | undefined;
}

/** Class to define the FVC test mutation model. */
export interface FvcTestMutation {
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** The start of test quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    startOfTestQuality?: string | undefined;
    /** The flow plateau quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    flowPlateauQuality?: string | undefined;
    /** The cough free quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    coughFreeQuality?: string | undefined;
    /** The end of forced expiration (EOFE) artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    eofeQuality?: string | undefined;
    /** The FIVC - FVC quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fivcFvcQuality?: string | undefined;
    /** The FEV1 quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fev1Quality?: string | undefined;
    /** The FVC quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fvcQuality?: string | undefined;
    /** The date and time the test occurred. */
    occurred?: string;
    /** The sample rate in milliseconds, optional if 'TimeData' is set */
    sampleRate?: number;
    /** A comma seperated string of the volume value in Litres at each sample point */
    volumeData?: string | undefined;
    /** The total length of the volume data's sample points */
    volumeDataLength?: number;
    /** A comma seperated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Optional - For data that has an inconsistent sample rate (compressed data). A comma seperated string of the time values in seconds */
    timeData?: string | undefined;
    /** The duration of the FVC test in milliseconds */
    duration?: number;
    /** The test duration artefact, accepts a status of ART_ACCEPTABLE, ART_NOTACCEPTABLE */
    testDurationQuality?: string | undefined;
    /** The FVC (Forced Vital Capacity) value in litres. */
    fvc?: number | undefined;
    /** The FEV1 value (Forced Expiratory Volume in the first 1 second) in litres. */
    fev1?: number | undefined;
    /** The FEV3 value (Forced Expiratory Volume in the first 3 seconds) in litres. */
    fev3?: number | undefined;
    /** The FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    fev6?: number | undefined;
    /** The FEV 0.5 value (Forced Expiratory Volume in the first 0.5 seconds) in litres. */
    fev05?: number | undefined;
    /** The FEV 0.75 value (Forced Expiratory Volume in the first 0.75 seconds) in litres. */
    fev075?: number | undefined;
    /** The PEF (Peak Expiratory Flow) value in litres per second. */
    pefSec?: number | undefined;
    /** The PEF (Peak Expiratory Flow) value in litres per minute. */
    pefMin?: number | undefined;
    /** The PIF (Peak Inspiratory Flow) value in litres per second. */
    pifSec?: number | undefined;
    /** The PIF (Peak Inspiratory Flow) value in litres per minute. */
    pifMin?: number | undefined;
    /** The BEV (Extrapolated Volume) value in litres */
    bev?: number | undefined;
    /** The mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    fef2575?: number | undefined;
    /** Time to Peak Expiratory Flow in milliseconds. */
    tPef?: number | undefined;
    /** The Forced Expiratory Time in seconds. */
    fet?: number | undefined;
    /** The Forced Inspiratory Vital Capacity in litres. */
    fivc?: number | undefined;
    /** The FEV1 over FEV6 ratio. */
    fev1Fev6?: number | undefined;
    /** The FEV1 over FVC ratio. */
    fev1Fvc?: number | undefined;
    /** The FEV0.5 over FVC ratio. */
    fev05Fvc?: number | undefined;
    /** The tidal volume in litres */
    tv?: number | undefined;
    /** Inspiratory reserve volume in litres */
    irv?: number | undefined;
    /** Expiratory reserve volume in litres */
    erv?: number | undefined;
    /** Inspiratory capacity in litres */
    ic?: number | undefined;
    /** The FEV0.75 over FVC ratio */
    fev075Fvc?: number | undefined;
    /** The FEV3 over FVC ratio */
    fev3Fvc?: number | undefined;
    /** The FEV6 over FVC ratio */
    fev6Fvc?: number | undefined;
    /** The forced expiratory flow between 0.2 and 1.2 s */
    fef0212?: number | undefined;
    /** Gets the FEF2575 over FVC ratio. */
    fef2575Fvc?: number | undefined;
    /** The forced expiratory flow between 75 and 85 percent of FVC */
    fef7585?: number | undefined;
    /** The forced inspiratory vital capacity over FVC */
    fivcFvc?: number | undefined;
    /** Gets the Forced expiratory Flow in the first 75th percentile of the curve in litres per second. */
    fef75?: number | undefined;
    /** Gets the Forced expiratory Flow in the first 25th percentile of the curve in litres per second. */
    fef25?: number | undefined;
    /** Gets the Forced expiratory Flow in the first 50th percentile of the curve in litres per second. */
    fef50?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 25th percentile of the curve in litres per second. */
    fif25?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 50th percentile of the curve in litres per second. */
    fif50?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 75th percentile of the curve in litres per second. */
    fif75?: number | undefined;
    /** The FEV1 over PEF ratio. */
    fev1Pef?: number | undefined;
    /** The FIF 50 over FEF 50 ratio. */
    fif50Fef50?: number | undefined;
    /** The FIV1 value (Forced Inspiratory Volume in the first 1 seconds) in litres. */
    fiv1?: number | undefined;
    /** The FEV1 over FIVC ratio. */
    fev1Fivc?: number | undefined;
    /** The FIV1 over FIVC ratio. */
    fiv1Fivc?: number | undefined;
    /** The FIV1 over FVC ratio. */
    fiv1Fvc?: number | undefined;
    /** The FEF50 over FIF50 ratio. */
    fef50Fif50?: number | undefined;
    /** The Maximal Voluntary Ventilation in litres per minute */
    mvvInd?: number | undefined;
    /** The End of test volume in litres */
    eotv?: number | undefined;
    /** Forced mid-expiratory time between 25% and 75% */
    fmft?: number | undefined;
    /** The FEV1 over IVC ratio. */
    fev1Ivc?: number | undefined;
    /** The IVC (Inspiratory Vital Capacity) value in litres. */
    ivc?: number | undefined;
    /** The extrapolated time */
    tExt?: number | undefined;
    /** Time zero */
    tZero?: number | undefined;
    /** Hesitation Time in seconds */
    tHes?: number | undefined;
    /** The maximum instantaneous flow achieved during a FVC maneuver in Litres per second */
    fefMax?: number | undefined;
    /** EV over FVC ratio */
    evFvc?: number | undefined;
    /** The VC value in litres. */
    vc?: number | undefined;
    /** The FEV1/VC ratio. */
    fev1Vc?: number | undefined;
    /** The FEV1 ratio. */
    fev1R?: number | undefined;
    /** Rise Time in milliseconds */
    tRise?: number | undefined;
    /** Fev1Q in Liter */
    fev1Q?: number | undefined;
    /** Inspiratory Flow Rate in Litres per minute */
    ifr?: number | undefined;
    fev1Ht2?: number | undefined;
    fev3Vc?: number | undefined;
    frc?: number | undefined;
    rawind?: number | undefined;
    rv?: number | undefined;
    tlc?: number | undefined;
    fev3Fev6?: number | undefined;
}

/** Class to define the FVC test query model. */
export interface FvcTest extends FvcTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define a FVC analysis set mutation. */
export interface FvcAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** The best FEV1 value (Forced Expiratory Volume in the first 1 seconds) in litres. */
    bestFev1?: number | undefined;
    /** The best FVC (Forced Vital Capacity) value in litres. */
    bestFvc?: number | undefined;
    /** The best PEF (Peak Expiratory Flow) value in litres per minute. */
    bestPefMin?: number | undefined;
    /** The best mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    bestFef2575?: number | undefined;
    /** The best FEV1 over FVC ratio. */
    bestFev1Fvc?: number | undefined;
    /** The best FEF25 value */
    bestFef25?: number | undefined;
    /** The best FEF50 value */
    bestFef50?: number | undefined;
    /** The best FEF75 value */
    bestFef75?: number | undefined;
    /** The best FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    bestFev6?: number | undefined;
    /** Optional - The FEV1 test quality grade */
    fev1Grade?: string | undefined;
    /** Optional - The FVC test quality grade */
    fvcGrade?: string | undefined;
    /** Optional - The FEV1Q best value */
    bestFev1Q?: number | undefined;
    /** Optional - The FEV1Q  Post-Bronchodilator responsiveness */
    fev1Bdr?: number | undefined;
    /** Optional - The Fvc Post-Bronchodilator responsiveness  */
    fvcBdr?: number | undefined;
    /** Optional - The Fev1 Reversibility Absolute Change */
    fev1ReversibilityAbsoluteChange?: number | undefined;
    /** Optional - The Fev1 Reversibility Percentage Change */
    fev1ReversibilityPercentageChange?: number | undefined;
    /** Optional - The Baseline Fev1 % */
    percentBaselineFev1?: number | undefined;
    /** Optional - The Baseline Drop Fev1 % */
    percentBaselineDropFev1?: number | undefined;
    /** Optional - The user (site technician or over-reader) that is responsible for the analysis */
    user?: string | undefined;
    bestEOTV?: number | undefined;
    bestErv?: number | undefined;
    bestEv?: number | undefined;
    bestEvFvc?: number | undefined;
    bestFef0212?: number | undefined;
    bestFef2575Fvc?: number | undefined;
    bestFef50Fif50?: number | undefined;
    bestFef7585?: number | undefined;
    bestFefMax?: number | undefined;
    bestFet?: number | undefined;
    bestFev05?: number | undefined;
    bestFev05Fvc?: number | undefined;
    bestFev075?: number | undefined;
    bestFev075Fvc?: number | undefined;
    bestFev1Fev6?: number | undefined;
    bestFev1Fivc?: number | undefined;
    bestFev1Ht2?: number | undefined;
    bestFev1Ivc?: number | undefined;
    bestFev1Pef?: number | undefined;
    bestFev1R?: number | undefined;
    bestFev1Vc?: number | undefined;
    bestFev3?: number | undefined;
    bestFev3Fvc?: number | undefined;
    bestFev3Vc?: number | undefined;
    bestFif25?: number | undefined;
    bestFif50?: number | undefined;
    bestFif50Fef50?: number | undefined;
    bestFif75?: number | undefined;
    bestFiv1?: number | undefined;
    bestFiv1Fivc?: number | undefined;
    bestFiv1Fvc?: number | undefined;
    bestFivc?: number | undefined;
    bestFivcFvc?: number | undefined;
    bestFmft?: number | undefined;
    bestFrc?: number | undefined;
    bestIc?: number | undefined;
    bestIrv?: number | undefined;
    bestIvc?: number | undefined;
    bestMvvind?: number | undefined;
    bestPefSec?: number | undefined;
    bestPifMin?: number | undefined;
    bestPifSec?: number | undefined;
    bestRawind?: number | undefined;
    bestRisetime?: number | undefined;
    bestRv?: number | undefined;
    bestText?: number | undefined;
    bestThes?: number | undefined;
    bestTlc?: number | undefined;
    bestTpef?: number | undefined;
    bestTv?: number | undefined;
    bestFev6Fvc?: number | undefined;
    bestIfr?: number | undefined;
    bestFev3Fev6?: number | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
}

/** Class to define a spirometry analysis set. */
export interface FvcAnalysisSet extends FvcAnalysisSetMutation {
    /** The FEV1 absolute repeatability. */
    fev1AbsoluteRepeatability?: number | undefined;
    /** The FVC absolute repeatability. */
    fvcAbsoluteRepeatability?: number | undefined;
    /** The date and time the analysis set was started */
    started?: string;
    /** The date and time the analysis set was created */
    created?: string;
    /** The date and time the analysis set was last modified */
    modified?: string;
    /** The date and time the analysis set was first marked as accepted or rejected */
    firstCompleted?: string | undefined;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The test analysis sets associated with the session. */
    tests?: FvcAnalysisSetTest[] | undefined;
    /** The user id of the analyst of this set. */
    analystUserId?: string;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
}

export interface FvcAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
    /** FVC Repeatability (ml) */
    repeatabilityFvcAbsolute?: number | undefined;
    /** FVC Repeatability (%) */
    repeatabilityFvcPercentage?: number | undefined;
    /** FEV1 Repeatability (ml) */
    repeatabilityFev1Absolute?: number | undefined;
    /** FEV1 Repeatability (%) */
    repeatabilityFev1Percentage?: number | undefined;
    /** PEF Repeatability (L/min) */
    repeatabilityPefAbsolute?: number | undefined;
    /** PEF Repeatability (%) */
    repeatabilityPefPercentage?: number | undefined;
    /** The individual FEV1 acceptability, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fev1Acceptability?: string | undefined;
    /** The individual FVC acceptability, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fvcAcceptability?: string | undefined;
}

/** Class to define a analysis of a test */
export interface FvcAnalysisSetTest extends FvcAnalysisSetTestMutation {
    /** The related core test for this analysis set */
    test?: FvcTest | undefined;
}

/** Class to define the FVC session creation model. */
export interface FvcSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the FVC session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Required - The name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - The date and time the session occurred. */
    occurred?: string;
    /** Optional - The user name of the technician that performed the FVC session. */
    technician?: string | undefined;
    /** Optional - The temperate recorded on the device (if applicable) at the time the FVC session was performed. */
    temperature?: number | undefined;
    /** Optional - Type of medication in use by subject at the time the FVC session was performed. */
    medicationType?: string | undefined;
    /** Optional - The posture of the subject at the time the FVC session was performed. */
    postureType?: string | undefined;
    /** Optional - The identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Gender of the subject at the time the FVC session was performed. Required or Optional based on the study configuration. */
    gender?: string | undefined;
    /** Age of the subject at the time the FVC session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. Required or Optional based on the study configuration. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the FVC session was performed, if specified then age cannot be. Required or Optional based on the study configuration. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the FVC session was performed. Required or Optional based on the study configuration. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the FVC session was performed. Required or Optional based on the study configuration. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the FVC session was performed. Required or Optional based on the study configuration. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the FVC session was performed. Required or Optional based on the study configuration. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. Required or Optional based on the study configuration. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) in CM at the time the FVC session was performed. */
    ulna?: number | undefined;
    /** Optional - A dose amount of a medication given to the subject at the time of the session. */
    doseAmount?: number | undefined;
    /** Optional - The time of the dose of medication given to the subject at the time of the session. */
    doseTime?: string | undefined;
    /** Optional - The identifier of a session that should be considered the preceding session for this session. */
    preSessionId?: string | undefined;
    /** Optional - The predicted FEV1 value (Forced Expiratory Volume in the first 1 seconds) in litres. */
    predictedFev1?: number | undefined;
    /** Optional - The predicted FVC (Forced Vital Capacity) value in litres. */
    predictedFvc?: number | undefined;
    /** Optional - The predicted FEV1 over FVC ratio. */
    predictedFev1Fvc?: number | undefined;
    /** Optional - The predicted PEF (Peak Expiratory Flow) value in litres per minute. */
    predictedPefMin?: number | undefined;
    /** Predicted PEF (Peak Expiratory Flow) value in litres per second. */
    predictedPefSec?: number | undefined;
    /** Optional - The predicted mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    predictedFef2575?: number | undefined;
    /** Optional - The predicted FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    predictedFev6?: number | undefined;
    /** Predicted FEV6 over FVC value in litres */
    predictedFev6Fvc?: number | undefined;
    /** Optional - Gets the predicted Forced inspiratory Flow in the first 75th percentile of the curve in litres per second. */
    predictedFef75?: number | undefined;
    /** Optional - Gets the predicted FEF2575 over FVC ratio. */
    predictedFef2575Fvc?: number | undefined;
    /** Predicted SVC (Slow Vital Capacity) value in litres */
    predictedSvc?: number | undefined;
    /** Predicted FEV0.5 value in litres */
    predictedFev05?: number | undefined;
    /** Predicted FEV0.5 over FVC ratio */
    predictedFev05Fvc?: number | undefined;
    /** Predicted FEV0.75 value in litres */
    predictedFev075?: number | undefined;
    /** Predicted FEV0.75 over FVC ratio */
    predictedFev075Fvc?: number | undefined;
    /** Predicted FEV1 over PEF ratio */
    predictedFev1Pef?: number | undefined;
    /** Predicted FEV3 value in litres */
    predictedFev3?: number | undefined;
    /** Predicted FEV3 over FVC value in litres */
    predictedFev3Fvc?: number | undefined;
    /** Predicted FEF 0.2-1.2 in litres per second */
    predictedFef0212?: number | undefined;
    /** Predicted FEV 75-85 in litres per second */
    predictedFef7585?: number | undefined;
    /** Predicted FEF 25 in litres per second */
    predictedFef25?: number | undefined;
    /** Predicted FEF 50 in litres per second */
    predictedFef50?: number | undefined;
    /** Predicted FIVC (Forced inspiratory vital capacity) in litres */
    predictedFivc?: number | undefined;
    /** Predicted FIVC over FVC ratio */
    predictedFivcFvc?: number | undefined;
    /** Predicted PIF (Peak Inspiratory Flow) value in litres per minute. */
    predictedPifMin?: number | undefined;
    /** Predicted PIF (Peak Inspiratory Flow) value in litres per second. */
    predictedPifSec?: number | undefined;
    /** Predicted FIF 25 in litres per second */
    predictedFif25?: number | undefined;
    /** Predicted FIF 50 in litres per second */
    predictedFif50?: number | undefined;
    /** Predicted FIF 75 in litres per second */
    predictedFif75?: number | undefined;
    /** Predicted FIF 50 over FEF 50 ratio */
    predictedFifFef50?: number | undefined;
    /** Predicted FMFT (Forced mid flow time) in seconds */
    predictedFmft?: number | undefined;
    /** Predicted IC in litres */
    predictedIc?: number | undefined;
    /** Predicted MVVIND in litres per minute */
    predictedMvvind?: number | undefined;
    /** Predicted FRC in litres */
    predictedFrc?: number | undefined;
    /** Predicted RV in litres */
    predictedRv?: number | undefined;
    /** Predicted TLC in litres */
    predictedTlc?: number | undefined;
    /** Predicted ERV in litres */
    predictedErv?: number | undefined;
    /** Predicted FEV1 Ratio in litres */
    predictedFev1R?: number | undefined;
    /** Predicted FET in seconds */
    predictedFet?: number | undefined;
    /** Predicted IRV (Inspiratory Reserve Volume) in litres */
    predictedIrv?: number | undefined;
    /** Predicted TV (Tidal Volume) in litres */
    predictedTv?: number | undefined;
    /** Predicted FIV1 (Forced Inspiratory Volume) in litres */
    predictedFiv1?: number | undefined;
    /** The FEV1 absolute repeatability calculated at site */
    siteFev1AbsoluteRepeatability?: number | undefined;
    /** The FVC absolute repeatability calculated at site */
    siteFvcAbsoluteRepeatability?: number | undefined;
    /** The FEV1 percentage repeatability calculated at site */
    siteFvcPercentageRepeatability?: number | undefined;
    /** The FEV1 percentage repeatability calculated at site */
    siteFev1PercentageRepeatability?: number | undefined;
    /** Status of the session whether it's completed or in progress */
    status?: string | undefined;
    /** Lower Limit of Normality for fvc */
    llnFvc?: number | undefined;
    /** Lower Limit of Normality for fev1 */
    llnFev1?: number | undefined;
    /** Lower Limit of Normality for fev1Fvc */
    llnFev1Fvc?: number | undefined;
    /** Lower Limit of Normality for pef */
    llnPef?: number | undefined;
    /** Lower Limit of Normality for fef2575 */
    llnFef2575?: number | undefined;
    /** drop Percentage in FEV1 from baseline */
    fev1Drop?: number | undefined;
    /** Optional - Tests relating to the FVC session. */
    tests?: FvcTestCreation[] | undefined;
    /** Optional - Notes relating to the FVC session. */
    notes?: SessionNote[] | undefined;
    predictedEOTV?: number | undefined;
    predictedEv?: number | undefined;
    predictedEvFvc?: number | undefined;
    predictedFef50Fif50?: number | undefined;
    predictedFefMax?: number | undefined;
    predictedFev1Fev6?: number | undefined;
    predictedFev1Fivc?: number | undefined;
    predictedFev1Ht2?: number | undefined;
    predictedFev1Ivc?: number | undefined;
    predictedFev1Q?: number | undefined;
    predictedFev1Vc?: number | undefined;
    predictedFev3Vc?: number | undefined;
    predictedFiv1Fivc?: number | undefined;
    predictedFiv1Fvc?: number | undefined;
    predictedIvc?: number | undefined;
    predictedRawind?: number | undefined;
    predictedRisetime?: number | undefined;
    predictedText?: number | undefined;
    predictedThes?: number | undefined;
    predictedTpef?: number | undefined;
    predictedIfr?: number | undefined;
}

/** Class to define the FVC test creation model. */
export interface FvcTestCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The start of test quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    startOfTestQuality?: string | undefined;
    /** Required - The flow plateau quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    flowPlateauQuality?: string | undefined;
    /** Required - The cough free quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    coughFreeQuality?: string | undefined;
    /** Required - The end of forced expiration (EOFE) artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    eofeQuality?: string | undefined;
    /** Required - The FIVC - FVC quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fivcFvcQuality?: string | undefined;
    /** Required - The FEV1 quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fev1Quality?: string | undefined;
    /** Required - The FVC quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    fvcQuality?: string | undefined;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The sample rate in milliseconds */
    sampleRate?: number;
    /** Required - A comma separated string of the volume value in Litres at each sample point */
    volumeData?: string | undefined;
    /** Required - The total length of the volume data's sample points */
    volumeDataLength?: number;
    /** Required - A comma separated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Optional - For data that has an inconsistent sample rate (compressed data). A comma seperated string of the time values in milliseconds */
    timeData?: string | undefined;
    /** Required - The duration of the FVC test in milliseconds */
    duration?: number;
    fvc?: number | undefined;
    /** The FEV1 value (Forced Expiratory Volume in the first 1 seconds) in litres. */
    fev1?: number | undefined;
    fev3?: number | undefined;
    /** The FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    fev6?: number | undefined;
    fev05?: number | undefined;
    fev075?: number | undefined;
    /** The PEF (Peak Expiratory Flow) value in litres per second. */
    pefSec?: number | undefined;
    /** The PEF (Peak Expiratory Flow) value in litres per minute. */
    pefMin?: number | undefined;
    pifSec?: number | undefined;
    pifMin?: number | undefined;
    /** The BEV (Extrapolated Volume) value in litres */
    bev?: number | undefined;
    /** The mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    fef2575?: number | undefined;
    /** Time to Peak Expiratory Flow in milliseconds. */
    tPef?: number | undefined;
    /** The Forced Expiratory Time in seconds. */
    fet?: number | undefined;
    /** The Forced Inspiratory Vital Capacity in litres. */
    fivc?: number | undefined;
    /** The FEV1 over FEV6 ratio. */
    fev1Fev6?: number | undefined;
    /** The FEV1 over FVC ratio. */
    fev1Fvc?: number | undefined;
    fev05Fvc?: number | undefined;
    tv?: number | undefined;
    irv?: number | undefined;
    erv?: number | undefined;
    ic?: number | undefined;
    fev075Fvc?: number | undefined;
    fev3Fvc?: number | undefined;
    fev6Fvc?: number | undefined;
    fef0212?: number | undefined;
    /** Gets the FEF2575 over FVC ratio. */
    fef2575Fvc?: number | undefined;
    fef7585?: number | undefined;
    fivcFvc?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 75th percentile of the curve in litres per second. */
    fef75?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 25th percentile of the curve in litres per second. */
    fef25?: number | undefined;
    /** Gets the Forced inspiratory Flow in the first 50th percentile of the curve in litres per second. */
    fef50?: number | undefined;
    fif25?: number | undefined;
    fif50?: number | undefined;
    fif75?: number | undefined;
    fev1Pef?: number | undefined;
    fif50Fef50?: number | undefined;
    fiv1?: number | undefined;
    fev1Fivc?: number | undefined;
    fiv1Fivc?: number | undefined;
    fiv1Fvc?: number | undefined;
    fef50Fif50?: number | undefined;
    mvvInd?: number | undefined;
    eotv?: number | undefined;
    fmft?: number | undefined;
    fev1Ivc?: number | undefined;
    ivc?: number | undefined;
    /** Gets the extrapolated time */
    tExt?: number | undefined;
    testDurationQuality?: string | undefined;
    tZero?: number | undefined;
    tHes?: number | undefined;
    fefMax?: number | undefined;
    evFvc?: number | undefined;
    /** The VC value in litres. */
    vc?: number | undefined;
    /** The FEV1/VC ratio. */
    fev1Vc?: number | undefined;
    /** The FEV1 ratio. */
    fev1R?: number | undefined;
    /** Rise Time in milliseconds */
    tRise?: number | undefined;
    /** Fev1Q in litres */
    fev1Q?: number | undefined;
    /** Inspiratory Flow Rate in Litres per minute */
    ifr?: number | undefined;
    fev1Ht2?: number | undefined;
    fev3Vc?: number | undefined;
    frc?: number | undefined;
    rawind?: number | undefined;
    rv?: number | undefined;
    tlc?: number | undefined;
    fev3Fev6?: number | undefined;
}

export interface SingleResultOfFvcSession extends SingleResult {
    queryable?: FvcSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFvcTest {
    /** Entities returned by the query. */
    value?: FvcTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfFvcTest extends SingleResult {
    queryable?: FvcTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfInhalerTrainingSession {
    /** Entities returned by the query. */
    value?: InhalerTrainingSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface InhalerTrainingSessionMutation extends BaseSession {
    /** Optional - Unique identifier for the inhaler training session. */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optional - User name of the technician that performed the inhaler training session. */
    technician?: string | undefined;
    /** Optional - Tests relating to the inhaler training session. */
    tests?: InhalerTrainingTest[] | undefined;
    /** Optional - Notes relating to the inhaler training session. */
    notes?: SessionNote[] | undefined;
}

export interface InhalerTrainingSession extends InhalerTrainingSessionMutation {
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
}

export interface InhalerTrainingTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The test type identifier, either TEST_INHALER_MDI, TEST_INHALER_MDI_SPACER or TEST_INHALER_DPI, indicating the type of inhaler used in the test. */
    testTypeId?: string | undefined;
    /** Optional - The inspiratory flow rate quality grade, accepts a value of IG_GOOD, IG_LOW, IG_HIGH, IG_OKAY, IG_UNSPECIFIED */
    flowRate?: string | undefined;
    /** Optional - Summary text relating to the inspiratory flow rate grade */
    flowRateSummary?: string | undefined;
    /** Optional - The breath hold quality grade, accepts a status of IG_GOOD, IG_POOR, IG_UNSPECIFIED */
    breathHoldGrade?: string | undefined;
    /** Optional - Summary text relating to the breath hold grade */
    breathHoldSummary?: string | undefined;
    /** Optional - The overall result grading of the inhalation, accepts a status of IG_GOOD, IG_POOR, IG_UNSPECIFIED */
    inhalationGrade?: string | undefined;
    /** Optional - Summary text relating to the overall result of the test */
    inhalationSummary?: string | undefined;
    /** Optional - Whether the MDI canister was activated during the test, if applicable. */
    mdiCanisterActivation?: boolean | undefined;
    /** Optional - The lung deposition site, accepts a value of AL_BACK_OF_THROAT, AL_OUTSIDE_MOUTH, AL_UPPER_LUNG, AL_LOWER_LUNG, AL_UPPER_LUNG_ADEQUATE, AL_UPPER_LUNG_INADEQUATE or AL_UNSPECIFIED, indicating where the medication was deposited in the lungs. */
    lungDepositionSite?: string | undefined;
}

export interface InhalerTrainingTest extends InhalerTrainingTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

export interface InhalerTrainingSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the inhaler training session. */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optional - User name of the technician that performed the inhaler training session. */
    technician?: string | undefined;
    /** Optional - Tests relating to the inhaler training session. */
    tests?: InhalerTrainingTestCreation[] | undefined;
    /** Optional - Notes relating to the inhaler training session. */
    notes?: SessionNote[] | undefined;
}

export interface InhalerTrainingTestCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The test type identifier, either TEST_INHALER_MDI, TEST_INHALER_MDI_SPACER or TEST_INHALER_DPI, indicating the type of inhaler used in the test. */
    testTypeId?: string | undefined;
    /** Required - The inspiratory flow rate quality grade, accepts a value of IG_GOOD, IG_LOW, IG_HIGH, IG_OKAY, IG_UNSPECIFIED */
    flowRate?: string | undefined;
    /** Required - Summary text relating to the inspiratory flow rate grade */
    flowRateSummary?: string | undefined;
    /** Required - The breath hold quality grade, accepts a status of IG_GOOD, IG_POOR, IG_UNSPECIFIED */
    breathHoldGrade?: string | undefined;
    /** Required - Summary text relating to the breath hold grade */
    breathHoldSummary?: string | undefined;
    /** Required - The overall result grading of the inhalation, accepts a status of IG_GOOD, IG_POOR, IG_UNSPECIFIED */
    inhalationGrade?: string | undefined;
    /** Required - Summary text relating to the overall result of the test */
    inhalationSummary?: string | undefined;
    /** Optional - Whether the MDI canister was activated during the test, if applicable. */
    mdiCanisterActivation?: boolean | undefined;
    /** Required - The lung deposition site, accepts a value of AL_BACK_OF_THROAT, AL_OUTSIDE_MOUTH, AL_UPPER_LUNG, AL_LOWER_LUNG, AL_UPPER_LUNG_ADEQUATE, AL_UPPER_LUNG_INADEQUATE or AL_UNSPECIFIED, indicating where the medication was deposited in the lungs. */
    lungDepositionSite?: string | undefined;
}

export interface SingleResultOfInhalerTrainingSession extends SingleResult {
    queryable?: InhalerTrainingSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfInhalerTrainingTest {
    /** Entities returned by the query. */
    value?: InhalerTrainingTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfInhalerTrainingTest extends SingleResult {
    queryable?: InhalerTrainingTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfLanguage {
    /** Entities returned by the query. */
    value?: Language[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface Language {
    id?: string | undefined;
    name?: string | undefined;
    localeName?: string | undefined;
}

export interface SingleResultOfLanguage extends SingleResult {
    queryable?: Language[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfLungVolumeAnalysisSet {
    /** Entities returned by the query. */
    value?: LungVolumeAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface LungVolumeAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string | undefined;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** The analyst performing the analysis. */
    analyst?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - FRC value in Litres (L) */
    bestFrc?: number | undefined;
    /** Optional - TLC value in Litres (L) */
    bestTlc?: number | undefined;
    /** Optional - RV value in Litres (L) */
    bestRv?: number | undefined;
    /** Optional - IC value in Litres (L) */
    bestIc?: number | undefined;
    /** Optional - VC value in Litres (L) */
    bestVc?: number | undefined;
    /** Optional - ERV value in Litres (L) */
    bestErv?: number | undefined;
    /** Optional - RV/TLC */
    bestRvTlc?: number | undefined;
    /** Optional - CEV value in Litres (L) */
    bestCev?: number | undefined;
    /** Optional - LCI value is ratio calculated as CEV / FRC */
    bestLci?: number | undefined;
    /** Optional - Session Grade as determined at time of testing */
    grade?: string | undefined;
}

export interface LungVolumeAnalysisSet extends LungVolumeAnalysisSetMutation {
    /** Unique ID of the test */
    id?: string;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The analyst id. */
    analystId?: string | undefined;
    /** The analyst email. */
    analystEmail?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The test analysis sets associated with the session. */
    tests?: LungVolumeAnalysisSetTest[] | undefined;
}

export interface LungVolumeAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface LungVolumeAnalysisSetTest extends LungVolumeAnalysisSetTestMutation {
}

export interface LungVolumeAnalysisSetCreation extends LungVolumeAnalysisSetMutation {
    /** Optional - Unique ID of the test */
    id?: string;
}

export interface SingleResultOfLungVolumeAnalysisSet extends SingleResult {
    queryable?: LungVolumeAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfLungVolumeAnalysisSetTest {
    /** Entities returned by the query. */
    value?: LungVolumeAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfLungVolumeAnalysisSetTest extends SingleResult {
    queryable?: LungVolumeAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfLungVolumeSession {
    /** Entities returned by the query. */
    value?: LungVolumeSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface LungVolumeSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** The Body Mass Index of the subject at the time the session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optional - FRC value in Litres (L) */
    predictedFrc?: number | undefined;
    /** Optional - TLC value in Litres (L) */
    predictedTlc?: number | undefined;
    /** Optional - RV value in Litres (L) */
    predictedRv?: number | undefined;
    /** Optional - IC value in Litres (L) */
    predictedIc?: number | undefined;
    /** Optional - VC value in Litres (L) */
    predictedVc?: number | undefined;
    /** Optional - ERV value in Litres (L) */
    predictedErv?: number | undefined;
    /** Optional - RV/TLC */
    predictedRvTlc?: number | undefined;
    /** Optional - Cev value in Litres (L) */
    predictedCev?: number | undefined;
    /** Optional - LCI value is ratio calculated as CEV / FRC */
    predictedLci?: number | undefined;
    /** Optional - Overread challenge status of the session either ORS_NOT_CHALLENGED or ORS_CHALLENGED. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
    /** Optional - The humidity % value, recorded as part of a LV session. */
    humidity?: number | undefined;
    /** Optional - The atmospheric pressure value in hPa, recorded as part of a LV session. */
    atmosphericPressure?: number | undefined;
    /** Differentiates a real-time LV/MBW session from a MDE LV session. Defaults to false  */
    isRealtimeTesting?: boolean | undefined;
    /** Optional - The VC of the latest SVC session that was performed. */
    referenceVC?: number | undefined;
}

export interface LungVolumeSession extends LungVolumeSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** Unique identifier for the analysisSet. */
    analysisSetId?: string;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: LungVolumeTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    status?: string | undefined;
    overreader?: string | undefined;
    received?: string;
    analysisSets?: LungVolumeAnalysisSet[] | undefined;
}

export interface LungVolumeTestMutation {
    /** Required - Automatically assigned LV test number (2 for He, 1-5 for Pleth) */
    testNumber?: number;
    /** User entered panting frequency value in Hz (Pleth only) */
    pantingFrequency?: number | undefined;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Optional - FRC value in Litres (L) */
    frc?: number | undefined;
    /** Optional - TLC value in Litres (L) */
    tlc?: number | undefined;
    /** Optional - RV value in Litres (L) */
    rv?: number | undefined;
    /** Optional - IC value in Litres (L) */
    ic?: number | undefined;
    /** Optional - VC value in Litres (L) */
    vc?: number | undefined;
    /** Optional - ERV value in Litres (L) */
    erv?: number | undefined;
    /** Optional - RVTLC value as a Percentage (%) */
    rvTlc?: number | undefined;
    /** Optional - CEV value in Litres (L) */
    cev?: number | undefined;
    /** Optional - LCI value in Litres (L) */
    lci?: number | undefined;
}

export interface LungVolumeTest extends LungVolumeTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: LungVolumeSession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

export interface LungVolumeSessionCreation extends LungVolumeSessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** Tests relating to the session. */
    tests?: LungVolumeTestCreation[] | undefined;
    /** Notes relating to the session. */
    notes?: SessionNoteCreation[] | undefined;
}

export interface LungVolumeTestCreation extends LungVolumeTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Required - Session ID the test belongs to. */
    sessionId?: string;
}

export interface SingleResultOfLungVolumeSession extends SingleResult {
    queryable?: LungVolumeSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfLungVolumeTest {
    /** Entities returned by the query. */
    value?: LungVolumeTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfLungVolumeTest extends SingleResult {
    queryable?: LungVolumeTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMappedServerDirectory {
    /** Entities returned by the query. */
    value?: MappedServerDirectory[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface MappedServerDirectory {
    id?: string;
    serverDirectory?: string | undefined;
    name?: string | undefined;
    userRoles?: string[] | undefined;
}

export interface SingleResultOfMappedServerDirectory extends SingleResult {
    queryable?: MappedServerDirectory[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMedicationRecord {
    /** Entities returned by the query. */
    value?: MedicationRecord[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define medication record mutation model. */
export interface MedicationRecordMutation {
    /** Medication record date and time. */
    dateTime?: string;
    /** Medication. */
    medication?: string | undefined;
    /** Medication dose. */
    dose?: number;
    /** Unit type. */
    unitType?: string | undefined;
}

/** Class to define medication record model. */
export interface MedicationRecord extends MedicationRecordMutation {
    /** Medication record ID. */
    id?: string;
    /** Medication record test ID. */
    testId?: string;
}

/** Class to define medication record creation model. */
export interface MedicationRecordCreation extends MedicationRecord {
}

export interface SingleResultOfMedicationRecord extends SingleResult {
    queryable?: MedicationRecord[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMepAnalysisSet {
    /** Entities returned by the query. */
    value?: MepAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe pressure analysis set mutation model */
export interface PressureAnalysisSetMutation {
    /** The analysis status */
    status?: string | undefined;
    /** The date and time the analysis was started */
    started?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
}

/** Class to desribe MEP analysis set mutation model */
export interface MepAnalysisSetMutation extends PressureAnalysisSetMutation {
    /** The best MEP value. */
    bestMep?: number | undefined;
    /** The best PEP value. */
    bestPep?: number | undefined;
}

/** Class to desribe MEP analysis set base (query) model */
export interface MepAnalysisSet extends MepAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The analyst username. */
    analyst?: string | undefined;
    /** The analyst id. */
    analystId?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The analysis set tests associated with the session. */
    tests?: MepAnalysisSetTest[] | undefined;
}

/** Class to desribe pressure analysis set test mutation model */
export interface PressureAnalysisSetTestMutation {
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

/** Class to desribe MEP analysis set test mutation model */
export interface MepAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    /** MIP/MEP Repeatability parameter value. */
    mipMepRepeatability?: number | undefined;
    /** MIP/MEP repeatability percent parameter value. */
    mipMepRepeatabilityPercent?: number | undefined;
}

/** Class to desribe MEP analysis set test base (query) model */
export interface MepAnalysisSetTest extends MepAnalysisSetTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The test ID this analysis relates to. */
    testId?: string;
    /** The test this analysis relates to. */
    test?: MepTest | undefined;
    /** The analysis set this test analysis relates to */
    analysisSetId?: string;
}

/** Class to define the pressure test mutation model. */
export interface PressureTestMutation {
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The data and time of the test start. */
    occurred?: string;
    /** The short duration quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    shortDurationQuality?: string | undefined;
    /** The sample rate in milliseconds */
    sampleRate?: number;
    /** A comma seperated string of the pressure values in cm/H2o at each sample point */
    pressureData?: string | undefined;
    /** A comma seperated string of the time values in millieseconds at each sample point */
    timeData?: string | undefined;
}

/** Class to define the MEP test mutation model. */
export interface MepTestMutation extends PressureTestMutation {
    /** MEP parameter value. */
    mep?: number | undefined;
    /** PEP parameter value. */
    pep?: number | undefined;
}

/** Class to define the MEP test query model. */
export interface MepTest extends MepTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to desribe MEP analysis set creation model */
export interface MepAnalysisSetCreation extends MepAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The session analyst username. */
    analyst?: string | undefined;
}

export interface SingleResultOfMepAnalysisSet extends SingleResult {
    queryable?: MepAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMepAnalysisSetTest {
    /** Entities returned by the query. */
    value?: MepAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe MEP analysis set creation model */
export interface MepAnalysisSetTestCreation extends MepAnalysisSetTest {
}

export interface SingleResultOfMepAnalysisSetTest extends SingleResult {
    queryable?: MepAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMepSession {
    /** Entities returned by the query. */
    value?: MepSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the pressure session mutation model. */
export interface PressureSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the pressure session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the pressure session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the pressure session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the pressure session was performed. */
    postureType?: string | undefined;
    /** Gender of the subject at the time the pressure session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the pressure session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the pressure session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the pressure session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the pressure session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the pressure session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the pressure session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the pressure session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Overread challenge status of the session that preceeded this session. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
}

/** Class to define the MEP session mutation model. */
export interface MepSessionMutation extends PressureSessionMutation {
    /** Predicted MEP parameter value. */
    predictedMep?: number | undefined;
}

/** Class to define the MEP session query model. */
export interface MepSession extends MepSessionMutation {
    /** Unique identifier for the pressure session. */
    id?: string;
    /** Unique identifier for the analysisSet. */
    analysisSetId?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Unique identifier for the type of session. */
    sessionTypeId?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    received?: string | undefined;
    /** Tests related to the MEP session. */
    tests?: MepTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Status of the overread. */
    status?: string | undefined;
    /** Overreader name. */
    overreader?: string | undefined;
    /** Notes relating to the MEP session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: PressureAnalysisSet[] | undefined;
}

/** Class to describe pressure analysis set base (query) model */
export interface PressureAnalysisSet extends PressureAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The analyst username. */
    analyst?: string | undefined;
    /** The analyst userid. */
    analystId?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The analysis set tests associated with the session. */
    tests?: PressureAnalysisSetTest[] | undefined;
}

/** Class to describe pressure analysis set test base (query) model */
export interface PressureAnalysisSetTest extends PressureAnalysisSetTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The test this analysis relates to. */
    testId?: string;
    /** The test this analysis relates to. */
    test?: PressureTest | undefined;
    /** The analysis set this test analysis relates to */
    analysisSetId?: string;
}

/** Class to define the pressure test query model. */
export interface PressureTest extends PressureTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define the MEP session creation model. */
export interface MepSessionCreation extends MepSessionMutation {
    /** Optional - Unique identifier for the MEP session. */
    id?: string;
    /** Optional - Tests relating to the MEP session. */
    tests?: MepTestCreation[] | undefined;
    /** Optional - Notes relating to the SNIP session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the MEP test creation model. */
export interface MepTestCreation extends MepTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
}

export interface SingleResultOfMepSession extends SingleResult {
    queryable?: MepSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMepTest {
    /** Entities returned by the query. */
    value?: MepTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfMepTest extends SingleResult {
    queryable?: MepTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMipAnalysisSet {
    /** Entities returned by the query. */
    value?: MipAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe MIP analysis set mutation model */
export interface MipAnalysisSetMutation extends PressureAnalysisSetMutation {
    /** The best MIP value. */
    bestMip?: number | undefined;
    /** The best PIP value. */
    bestPip?: number | undefined;
}

/** Class to desribe MIP analysis set base (query) model */
export interface MipAnalysisSet extends MipAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The analyst username. */
    analyst?: string | undefined;
    /** The analyst id. */
    analystId?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The analysis set tests associated with the session. */
    tests?: MipAnalysisSetTest[] | undefined;
}

/** Class to desribe MIP analysis set test mutation model */
export interface MipAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    /** MIP/MEP Repeatability parameter value. */
    mipMepRepeatability?: number | undefined;
    /** MIP/MEP repeatability percent parameter value. */
    mipMepRepeatabilityPercent?: number | undefined;
}

/** Class to desribe MIP analysis set test base (query) model */
export interface MipAnalysisSetTest extends MipAnalysisSetTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The test ID this analysis relates to. */
    testId?: string;
    /** The test this analysis relates to. */
    test?: MipTest | undefined;
    /** The analysis set this test analysis relates to */
    analysisSetId?: string;
}

/** Class to define the MIP test mutation model. */
export interface MipTestMutation extends PressureTestMutation {
    /** MIP parameter value. */
    mip?: number | undefined;
    /** PIP parameter value. */
    pip?: number | undefined;
}

/** Class to define the MIP test query model. */
export interface MipTest extends MipTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to desribe MIP analysis set creation model */
export interface MipAnalysisSetCreation extends MipAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The session analyst username. */
    analyst?: string | undefined;
}

export interface SingleResultOfMipAnalysisSet extends SingleResult {
    queryable?: MipAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMipAnalysisSetTest {
    /** Entities returned by the query. */
    value?: MipAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe MIP analysis set creation model */
export interface MipAnalysisSetTestCreation extends MipAnalysisSetTest {
}

export interface SingleResultOfMipAnalysisSetTest extends SingleResult {
    queryable?: MipAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMipSession {
    /** Entities returned by the query. */
    value?: MipSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the MIP session mutation model. */
export interface MipSessionMutation extends PressureSessionMutation {
    /** Predicted MIP parameter value. */
    predictedMip?: number | undefined;
}

/** Class to define the MIP session query model. */
export interface MipSession extends MipSessionMutation {
    /** Unique identifier for the pressure session. */
    id?: string;
    /** Unique identifier for the analysisSet. */
    analysisSetId?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Unique identifier for the type of session. */
    sessionTypeId?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    received?: string | undefined;
    /** Tests related to the MIP session. */
    tests?: MipTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Status of the overread. */
    status?: string | undefined;
    /** Overreader name. */
    overreader?: string | undefined;
    /** Notes relating to the MIP session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: PressureAnalysisSet[] | undefined;
}

/** Class to define the MIP session creation model. */
export interface MipSessionCreation extends MipSessionMutation {
    /** Optional - Unique identifier for the MIP session. */
    id?: string;
    /** Optional - Tests relating to the MIP session. */
    tests?: MipTestCreation[] | undefined;
    /** Optional - Notes relating to the SNIP session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the MIP test creation model. */
export interface MipTestCreation extends MipTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
}

export interface SingleResultOfMipSession extends SingleResult {
    queryable?: MipSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMipTest {
    /** Entities returned by the query. */
    value?: MipTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfMipTest extends SingleResult {
    queryable?: MipTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfMiscField {
    /** Entities returned by the query. */
    value?: MiscField[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface MiscFieldMuation {
    value?: string | undefined;
}

export interface MiscField extends MiscFieldMuation {
    id?: string;
    entityTypeName?: string | undefined;
    recordId?: string;
    fieldName?: string | undefined;
}

export interface MiscFieldCreation {
    id?: string;
    entityTypeName?: string | undefined;
    recordId?: string;
    fieldName?: string | undefined;
    value?: string | undefined;
}

export interface SingleResultOfMiscField extends SingleResult {
    queryable?: MiscField[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfNotificationSubscription {
    /** Entities returned by the query. */
    value?: NotificationSubscription[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface NotificationSubscriptionMutation extends NotificationSubscriptionCreation {
}

export interface SingleResultOfNotificationSubscription extends SingleResult {
    queryable?: NotificationSubscription[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOscillometryAnalysisSet {
    /** Entities returned by the query. */
    value?: OscillometryAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface OscillometryAnalysisSetMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - Best R5  value in cmH2O.s/L - Resistance at 5Hz */
    bestR5?: number | undefined;
    /** Optional - Best R20 value in cmH2O.s/L - Resistance at 20Hz */
    bestR20?: number | undefined;
    /** Optional - Best R5R20 value in cmH2O.s/L - Difference in resistance */
    bestR5R20?: number | undefined;
    /** Optional - Best Ax value in cmH2O/L - Area of reactance */
    bestAx?: number | undefined;
    /** Optional - Best R7 value in cmH2O.s/L - Resistance at 7Hz */
    bestR7?: number | undefined;
    /** Optional - Best R7R20 value in cmH2O.s/L - Difference in resistance */
    bestR7R20?: number | undefined;
    /** Optional - Best Fres value in Hz - Resonance Frequency */
    bestFres?: number | undefined;
    /** Optional - Best X5 value in cmH2O.s/L - Reactance at 5Hz */
    bestX5?: number | undefined;
    /** Optional - Best Tidal Volume(Litres) */
    bestVt?: number | undefined;
    /** Optional - Mean Average R5(cmH2O.s/L) */
    averageR5?: number | undefined;
    /** Optional - Mean Average R20(cmH2O.s/L) */
    averageR20?: number | undefined;
    /** Optional -  Mean Average R5R20(cmH2O.s/L) */
    averageR5R20?: number | undefined;
    /** Optional - Mean Average R7(cmH2O.s/L) */
    averageR7?: number | undefined;
    /** Optional - Mean Average R7R20(cmH2O.s/L) */
    averageR7R20?: number | undefined;
    /** Optional - Mean Average X5(cmH2O.s/L) */
    averageX5?: number | undefined;
    /** Optional - Mean Average Ax(cmH2O/L) */
    averageAx?: number | undefined;
    /** Optional - Mean Average Tidal Volume(Litres) */
    averageVt?: number | undefined;
    /** Optional - Mean Average Fres (Hertz) */
    averageFres?: number | undefined;
    /** Optional - Z Score R5 */
    zR5?: number | undefined;
    /** Optional - Z Score R20 */
    zR20?: number | undefined;
    /** Optional - Z Score R5R20 */
    zR5R20?: number | undefined;
    /** Optional - Z Score Ax */
    zAx?: number | undefined;
    /** Optional - Z Score R7 */
    zR7?: number | undefined;
    /** Optional - Best Tidal Volume(Litres) */
    zR7R20?: number | undefined;
    /** Optional -  Z Score X5 */
    zX5?: number | undefined;
    /** Optional - Coefficient Variation Ax(%) */
    cvAx?: number | undefined;
    /** Optional - Coefficient Variation Vt(%) */
    cvVt?: number | undefined;
    /** Optional - Coefficient Variation R5(%) */
    cvR5?: number | undefined;
    /** Optional -Percentage Predicted R5(%) */
    percentPredictedR5?: number | undefined;
    /** Optional -  Percentage Predicted R20(%) */
    percentPredictedR20?: number | undefined;
    /** Optional - Percentage Predicted R5R20(%) */
    percentPredictedR5R20?: number | undefined;
    /** Optional - Percentage Predicted Ax(%) */
    percentPredictedAx?: number | undefined;
    /** Optional - Percentage Predicted R7(%) */
    percentPredictedR7?: number | undefined;
    /** Optional - Percentage Predicted R7R20(%) */
    percentPredictedR7R20?: number | undefined;
    /** Optional - Percentage Predicted X5(%) */
    percentPredictedX5?: number | undefined;
    /** Optional - Percentage Predicted Fres(%) */
    percentPredictedFres?: number | undefined;
    /** Optional - Mean Average R19(cmH2O.s/L) */
    averageR19?: number | undefined;
    /** Optional -  Mean Average R5R19(cmH2O.s/L) */
    averageR5R19?: number | undefined;
    /** Optional -  Percentage Predicted R19(%) */
    percentPredictedR19?: number | undefined;
    /** Optional - Percentage Predicted R5R19(%) */
    percentPredictedR5R19?: number | undefined;
    /** Optional - Coefficient Variation R7(%) */
    cvR7?: number | undefined;
    /** Optional - Coefficient Variation R19(%) */
    cvR19?: number | undefined;
    /** Optional - Coefficient Variation R20(%) */
    cvR20?: number | undefined;
    /** Optional - Coefficient Variation Fres(%) */
    cvFres?: number | undefined;
    /** Optional - Z Score R19 */
    zR19?: number | undefined;
    /** Optional - Z Score R5R19 */
    zR5R19?: number | undefined;
}

export interface OscillometryAnalysisSet extends OscillometryAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The session analysis. */
    analyst?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The test analysis sets associated with the session. */
    tests?: OscillometryAnalysisSetTest[] | undefined;
}

export interface OscillometryAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

export interface OscillometryAnalysisSetTest extends OscillometryAnalysisSetTestMutation {
}

export interface OscillometryAnalysisSetCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** The date and time the analysis was started */
    started?: string;
    /** Required - The session the analysis set belongs to. */
    sessionId?: string;
    /** Required - The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** Required - The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - Best R5  value in cmH2O.s/L - Resistance at 5Hz */
    bestR5?: number | undefined;
    /** Optional - Best R20 value in cmH2O.s/L - Resistance at 20Hz */
    bestR20?: number | undefined;
    /** Optional - Best R5R20 value in cmH2O.s/L - Difference in resistance */
    bestR5R20?: number | undefined;
    /** Optional - Best Ax value in cmH2O/L - Area of reactance */
    bestAx?: number | undefined;
    /** Optional - Best R7 value in cmH2O.s/L - Resistance at 7Hz */
    bestR7?: number | undefined;
    /** Optional - Best R7R20 value in cmH2O.s/L - Difference in resistance */
    bestR7R20?: number | undefined;
    /** Optional - Best Fres value in Hz - Resonance Frequency */
    bestFres?: number | undefined;
    /** Optional - Best X5 value in cmH2O.s/L - Reactance at 5Hz */
    bestX5?: number | undefined;
    /** Optional - Best Tidal Volume(Litres) */
    bestVt?: number | undefined;
    /** Optional - Mean Average R5(cmH2O.s/L) */
    averageR5?: number | undefined;
    /** Optional - Mean Average R20(cmH2O.s/L) */
    averageR20?: number | undefined;
    /** Optional -  Mean Average R5R20(cmH2O.s/L) */
    averageR5R20?: number | undefined;
    /** Optional - Mean Average R7(cmH2O.s/L) */
    averageR7?: number | undefined;
    /** Optional - Mean Average R7R20(cmH2O.s/L) */
    averageR7R20?: number | undefined;
    /** Optional - Mean Average X5(cmH2O.s/L) */
    averageX5?: number | undefined;
    /** Optional - Mean Average Ax(cmH2O/L) */
    averageAx?: number | undefined;
    /** Optional - Mean Average Tidal Volume(Litres) */
    averageVt?: number | undefined;
    /** Optional - Mean Average Fres (Hertz) */
    averageFres?: number | undefined;
    /** Optional - Z Score R5 */
    zR5?: number | undefined;
    /** Optional - Z Score R20 */
    zR20?: number | undefined;
    /** Optional - Z Score R5R20 */
    zR5R20?: number | undefined;
    /** Optional - Z Score Ax */
    zAx?: number | undefined;
    /** Optional - Z Score R7 */
    zR7?: number | undefined;
    /** Optional - Best Tidal Volume(Litres) */
    zR7R20?: number | undefined;
    /** Optional -  Z Score X5 */
    zX5?: number | undefined;
    /** Optional - Coefficient Variation Ax(%) */
    cvAx?: number | undefined;
    /** Optional - Coefficient Variation Vt(%) */
    cvVt?: number | undefined;
    /** Optional - Coefficient Variation R5(%) */
    cvR5?: number | undefined;
    /** Optional -Percentage Predicted R5(%) */
    percentPredictedR5?: number | undefined;
    /** Optional -  Percentage Predicted R20(%) */
    percentPredictedR20?: number | undefined;
    /** Optional - Percentage Predicted R5R20(%) */
    percentPredictedR5R20?: number | undefined;
    /** Optional - Percentage Predicted Ax(%) */
    percentPredictedAx?: number | undefined;
    /** Optional - Percentage Predicted R7(%) */
    percentPredictedR7?: number | undefined;
    /** Optional - Percentage Predicted R7R20(%) */
    percentPredictedR7R20?: number | undefined;
    /** Optional - Percentage Predicted X5(%) */
    percentPredictedX5?: number | undefined;
    /** Optional - Percentage Predicted Fres(%) */
    percentPredictedFres?: number | undefined;
    /** Optional - Mean Average R19(cmH2O.s/L) */
    averageR19?: number | undefined;
    /** Optional -  Mean Average R5R19(cmH2O.s/L) */
    averageR5R19?: number | undefined;
    /** Optional -  Percentage Predicted R19(%) */
    percentPredictedR19?: number | undefined;
    /** Optional - Percentage Predicted R5R19(%) */
    percentPredictedR5R19?: number | undefined;
    /** Optional - Coefficient Variation R7(%) */
    cvR7?: number | undefined;
    /** Optional - Coefficient Variation R19(%) */
    cvR19?: number | undefined;
    /** Optional - Coefficient Variation R20(%) */
    cvR20?: number | undefined;
    /** Optional - Coefficient Variation Fres(%) */
    cvFres?: number | undefined;
    /** Optional - Z Score R19 */
    zR19?: number | undefined;
    /** Optional - Z Score R5R19 */
    zR5R19?: number | undefined;
}

export interface SingleResultOfOscillometryAnalysisSet extends SingleResult {
    queryable?: OscillometryAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOscillometryAnalysisSetTest {
    /** Entities returned by the query. */
    value?: OscillometryAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe Oscillometry analysis set creation model */
export interface OscillometryAnalysisSetTestCreation extends OscillometryAnalysisSetTest {
}

export interface SingleResultOfOscillometryAnalysisSetTest extends SingleResult {
    queryable?: OscillometryAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOscillometrySession {
    /** Entities returned by the query. */
    value?: OscillometrySession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface OscillometrySessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Optional - Predicted R5  value in cmH2O.s/L - Resistance at 5Hz */
    predictedR5?: number | undefined;
    /** Optional - Predicted R20 value in cmH2O.s/L - Resistance at 20Hz */
    predictedR20?: number | undefined;
    /** Optional - Predicted R5R20 value in cmH2O.s/L - Difference in resistance */
    predictedR5R20?: number | undefined;
    /** Optional - PredictedAx value in cmH2O/L - Area of reactance */
    predictedAx?: number | undefined;
    /** Optional - Predicted R7 value in cmH2O.s/L - Resistance at 7Hz */
    predictedR7?: number | undefined;
    /** Optional - Predicted R7R20 value in cmH2O.s/L - Difference in resistance */
    predictedR7R20?: number | undefined;
    /** Optional - Predicted X5 value in cmH2O.s/L - Reactance at 5Hz */
    predictedX5?: number | undefined;
    /** Optional - Predicted Fres  Resonance Frequency measured value in Hz */
    predictedFres?: number | undefined;
    /** Optional - Coefficient of Variance for Ax as % */
    cvAx?: number | undefined;
    /** Optional - Coefficient of Variance for R5 as % */
    cvR5?: number | undefined;
    /** Optional - Coefficient of Variance for R7 as % */
    cvR7?: number | undefined;
    /** Optional - Predicted R19 value in cmH2O.s/L - Resistance at 19Hz */
    predictedR19?: number | undefined;
    /** Optional - Predicted R5R19 value in cmH2O.s/L - Difference in resistance */
    predictedR5R19?: number | undefined;
}

export interface OscillometrySession extends OscillometrySessionMutation {
    /** Unique identifier for the session. */
    id?: string;
    /** Unique identifier for the analysisSet. */
    analysisSetId?: string;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Tests relating to the session. */
    tests?: OscillometryTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    status?: string | undefined;
    overreader?: string | undefined;
}

export interface OscillometryTestMutation {
    /** Required - Automatically assigned  test number */
    testNumber?: number;
    /** The short duration quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    shortDurationQuality?: string | undefined;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Optional - R5  value in cmH2O.s/L - Resistance at 5Hz */
    r5?: number | undefined;
    /** Optional - R20 value in cmH2O.s/L - Resistance at 20Hz */
    r20?: number | undefined;
    /** Optional - R5R20 value in cmH2O.s/L - Difference in resistance */
    r5R20?: number | undefined;
    /** Optional - Ax value in cmH2O/L - Area of reactance */
    ax?: number | undefined;
    /** Optional - R7  value in cmH2O.s/L - Resistance at 7Hz */
    r7?: number | undefined;
    /** Optional - R7R20 value in cmH2O.s/L - Difference in resistance */
    r7R20?: number | undefined;
    /** Optional - X5 value in cmH2O.s/L - Reactance at 5Hz */
    x5?: number | undefined;
    /** Optional - FRES - Resonance Frequency measured in Hz */
    fres?: number | undefined;
    /** Optional - Tidal Volume(Litres) */
    vt?: number | undefined;
    /** Optional - R19 value in cmH2O.s/L - Resistance at 19Hz */
    r19?: number | undefined;
    /** Optional - R5R19 value in cmH2O.s/L - Difference in resistance */
    r5R19?: number | undefined;
}

export interface OscillometryTest extends OscillometryTestMutation {
    /** Unique ID of test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Session relating to the test. */
    session?: OscillometrySession | undefined;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

export interface OscillometrySessionCreation extends BaseSession {
    /** Unique identifier for the session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Population group ID the subject belongs to at the time the session was performed. */
    populationGroupId?: string | undefined;
    /** Required - Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Temperate recorded on the device at the time the session was performed. */
    temperature?: number | undefined;
    /** Name of the technician that performed session. */
    technician?: string | undefined;
    /** Gender of the subject at the time the session was performed. */
    gender?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the session was performed, if specified then DateOfBirth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the session was performed. */
    weight?: number | undefined;
    /** Length of ulna in CM at the time the session was performed. */
    ulna?: number | undefined;
    /** Type of smoker the subject is at the time the session was performed. */
    smokerType?: string | undefined;
    /** Type of posture the subject was in at the time the session was performed. */
    postureType?: string | undefined;
    /** Type of medication the subject had taken at the time the session was performed. */
    medicationType?: string | undefined;
    /** The date and time the session occurred. */
    occurred?: string;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Tests relating to the session. */
    tests?: OscillometryTestCreation[] | undefined;
    /** Notes relating to the session. */
    notes?: SessionNote[] | undefined;
    /** Optional - Predicted R5  value in cmH2O.s/L - Resistance at 5Hz */
    predictedR5?: number | undefined;
    /** Optional - Predicted R20 value in cmH2O.s/L - Resistance at 20Hz */
    predictedR20?: number | undefined;
    /** Optional - Predicted R5R20 value in cmH2O.s/L - Difference in resistance */
    predictedR5R20?: number | undefined;
    /** Optional - PredictedAx value in cmH2O/L - Area of reactance */
    predictedAx?: number | undefined;
    /** Optional - Predicted R7 value in cmH2O.s/L - Resistance at 7Hz */
    predictedR7?: number | undefined;
    /** Optional - Predicted R7R20 value in cmH2O.s/L - Difference in resistance */
    predictedR7R20?: number | undefined;
    /** Optional - Predicted X5 value in cmH2O.s/L - Reactance at 5Hz */
    predictedX5?: number | undefined;
    /** Optional - Predicted Fres  Resonance Frequency measured value in Hz */
    predictedFres?: number | undefined;
    /** Optional - Coefficient of Variance for Ax as % */
    cvAx?: number | undefined;
    /** Optional - Coefficient of Variance for R5 as % */
    cvR5?: number | undefined;
    /** Optional - Coefficient of Variance for R7 as % */
    cvR7?: number | undefined;
    /** Optional - Predicted R19 value in cmH2O.s/L - Resistance at 19Hz */
    predictedR19?: number | undefined;
    /** Optional - Predicted R5R19 value in cmH2O.s/L - Difference in resistance */
    predictedR5R19?: number | undefined;
}

export interface OscillometryTestCreation {
    /** Unique ID of test. */
    id?: string;
    /** Required - Session ID the test belongs to. */
    sessionId?: string;
    /** Required - Automatically assigned  test number */
    testNumber?: number;
    /** The short duration quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    shortDurationQuality?: string | undefined;
    /** Required - Date and time the test occurred. */
    occurred?: string;
    /** Optional - R5  value in cmH2O.s/L - Resistance at 5Hz */
    r5?: number | undefined;
    /** Optional - R20 value in cmH2O.s/L - Resistance at 20Hz */
    r20?: number | undefined;
    /** Optional - R5R20 value in cmH2O.s/L - Difference in resistance */
    r5R20?: number | undefined;
    /** Optional - Ax value in cmH2O/L - Area of reactance */
    ax?: number | undefined;
    /** Optional - R7  value in cmH2O.s/L - Resistance at 7Hz */
    r7?: number | undefined;
    /** Optional - R7R20 value in cmH2O.s/L - Difference in resistance */
    r7R20?: number | undefined;
    /** Optional - X5 value in cmH2O.s/L - Reactance at 5Hz */
    x5?: number | undefined;
    /** Optional - FRES - Resonance Frequency measured in Hz */
    fres?: number | undefined;
    /** Optional - Tidal Volume(Litres) */
    vt?: number | undefined;
    /** Optional - R19 value in cmH2O.s/L - Resistance at 19Hz */
    r19?: number | undefined;
    /** Optional - R5R19 value in cmH2O.s/L - Difference in resistance */
    r5R19?: number | undefined;
}

export interface SingleResultOfOscillometrySession extends SingleResult {
    queryable?: OscillometrySession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOscillometryTest {
    /** Entities returned by the query. */
    value?: OscillometryTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfOscillometryTest extends SingleResult {
    queryable?: OscillometryTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOverreadChallengeStatus {
    /** Entities returned by the query. */
    value?: OverreadChallengeStatus[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class representing an over-read status */
export interface OverreadChallengeStatus {
    /** Unique ID of the over-read status */
    id?: string | undefined;
    /** The name of the over-read status */
    name?: string | undefined;
}

export interface SingleResultOfOverreadChallengeStatus extends SingleResult {
    queryable?: OverreadChallengeStatus[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfOverreadStatus {
    /** Entities returned by the query. */
    value?: OverreadStatus[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class representing an over-read status */
export interface OverreadStatus {
    /** Unique ID of the over-read status */
    id?: string | undefined;
    /** The name of the over-read status */
    name?: string | undefined;
}

export interface SingleResultOfOverreadStatus extends SingleResult {
    queryable?: OverreadStatus[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfParameter {
    /** Entities returned by the query. */
    value?: Parameter[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface Parameter {
    id?: string | undefined;
    decimalPlaces?: number;
    unitName?: string | undefined;
    legacyId?: number;
}

export interface SingleResultOfParameter extends SingleResult {
    queryable?: Parameter[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPcfAnalysisSet {
    /** Entities returned by the query. */
    value?: PcfAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a PCF analysis set mutation. */
export interface PcfAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** The best PCF value in litres per second. */
    bestPcf?: number | undefined;
    /** The best PCF value in litres per minute. */
    bestPcfMin?: number | undefined;
    /** The PCF absolute repeatability. */
    pcfAbsoluteRepeatability?: number | undefined;
    /** The PCF percentage repeatability. */
    pcfPercentageRepeatability?: number | undefined;
}

/** Class to define a PCF analysis set. */
export interface PcfAnalysisSet extends PcfAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The test analysis sets associated with the session. */
    tests?: PcfAnalysisSetTest[] | undefined;
}

/** Class to define a PCF analysis set test mutation. */
export interface PcfAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean | undefined;
}

/** Class to define a PCF analysis set test. */
export interface PcfAnalysisSetTest extends PcfAnalysisSetTestMutation {
}

/** Class to define a PCF analysis set creation. */
export interface PcfAnalysisSetCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the analysis set belongs to. */
    sessionId?: string;
    /** Required - The type of analysis set such as Site */
    type?: string | undefined;
    /** Required - The analysis status */
    status?: string | undefined;
    /** Optional - The best PCF value in litres per second */
    bestPcf?: number | undefined;
    /** Optional - The best PCF value in litres per minute */
    bestPcfMin?: number | undefined;
    /** The PCF absolute repeatability. */
    pcfAbsoluteRepeatability?: number | undefined;
    /** The PCF percentage repeatability. */
    pcfPercentageRepeatability?: number | undefined;
}

export interface SingleResultOfPcfAnalysisSet extends SingleResult {
    queryable?: PcfAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPcfAnalysisSetTest {
    /** Entities returned by the query. */
    value?: PcfAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a PCF analysis set test creation. */
export interface PcfAnalysisSetTestCreation extends PcfAnalysisSetTest {
}

export interface SingleResultOfPcfAnalysisSetTest extends SingleResult {
    queryable?: PcfAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPcfSession {
    /** Entities returned by the query. */
    value?: PcfSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the PCF session mutation model. */
export interface PcfSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the PCF session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the PCF session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the PCF session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the PCF session was performed. */
    postureType?: string | undefined;
    /** Identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Gender of the subject at the time the PCF session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the PCF session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the PCF session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the PCF session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the PCF session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the PCF session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the PCF session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the PCF session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Optional - The predicted PCF value (in Litres per minute) */
    predictedPcf?: number | undefined;
}

/** Class to define the PCF session query model. */
export interface PcfSession extends PcfSessionMutation {
    /** Unique identifier for the PCF session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Tests relating to the PCF session. */
    tests?: PcfTest[] | undefined;
    /** Notes relating to the PCF session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the PCF test mutation model. */
export interface PcfTestMutation {
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** The date and time the test occurred. */
    occurred?: string;
    /** The total length of the flow data's sample points */
    flowDataLength?: number;
    /** A comma seperated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Required - The sample rate in milliseconds */
    sampleRate?: number;
    /** The duration of the PCF test in milliseconds */
    duration?: number;
    /** Required - The PCF (Peak Cough Flow) value in litres per second. */
    pcf?: number | undefined;
    /** Required - The PCF (Peak Cough Flow) value in litres per minute. */
    pcfMin?: number | undefined;
}

/** Class to define the PCF test query model. */
export interface PcfTest extends PcfTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define the PCF session creation model. */
export interface PcfSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the PCF session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Required - The name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - The date and time the session occurred. */
    occurred?: string;
    /** Optional - The user name of the technician that performed the PCF session. */
    technician?: string | undefined;
    /** Optional - The temperate recorded on the device (if applicable) at the time the PCF session was performed. */
    temperature?: number | undefined;
    /** Optional - Type of medication in use by subject at the time the PCF session was performed. */
    medicationType?: string | undefined;
    /** Optional - The posture of the subject at the time the PCF session was performed. */
    postureType?: string | undefined;
    /** Optional - The identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Optional - Gender of the subject at the time the PCF session was performed. */
    gender?: string | undefined;
    /** Optional - Age of the subject at the time the PCF session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Date of Birth of the subject at the time the PCF session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Height of subject in CM at the time the PCF session was performed. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG at the time the PCF session was performed. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Optional - Type of smoker the subject is at the time the PCF session was performed. */
    smokerType?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the PCF session was performed. */
    populationGroupId?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) in CM at the time the PCF session was performed. */
    ulna?: number | undefined;
    /** Optional - The identifier of a session that should be considered the preceding session for this session. */
    preSessionId?: string | undefined;
    /** Optional - The predicted PCF value (in Litres per minute) */
    predictedPcf?: number | undefined;
    /** Optional - Tests relating to the PCF session. */
    tests?: PcfTestCreation[] | undefined;
    /** Optional - Notes relating to the PCF session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the PCF test creation model. */
export interface PcfTestCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The sample rate in milliseconds */
    sampleRate?: number;
    /** The total length of the flow data's sample points */
    flowDataLength?: number;
    /** Required - A comma separated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Required - The duration of the PCF test in milliseconds */
    duration?: number;
    /** Required - The PCF (Peak Cough Flow) value in litres per second. */
    pcf?: number | undefined;
    /** Required - The PCF (Peak Cough Flow) value in litres per minute. */
    pcfMin?: number | undefined;
}

export interface SingleResultOfPcfSession extends SingleResult {
    queryable?: PcfSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPcfTest {
    /** Entities returned by the query. */
    value?: PcfTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPcfTest extends SingleResult {
    queryable?: PcfTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPefAnalysisSet {
    /** Entities returned by the query. */
    value?: PefAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a PEF analysis set mutation. */
export interface PefAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** The best PEF value in litres per second. */
    bestPefSec?: number | undefined;
    /** The best PEF value in litres per minute. */
    bestPefMin?: number | undefined;
    /** The PEF absolute repeatability. */
    pefAbsoluteRepeatability?: number | undefined;
    /** The PEF percentage repeatability. */
    pefPercentageRepeatability?: number | undefined;
    /** The user id of the analyst of this set. */
    analyst?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** The identifier of the QC batch this analysis set was generated with, if this analysis set is related to a batch generation */
    batchId?: string | undefined;
}

/** Class to define a PEF analysis set. */
export interface PefAnalysisSet extends PefAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The test analysis sets associated with the session. */
    tests?: PefAnalysisSetTest[] | undefined;
    analystUserName?: string | undefined;
    /** The date and time the analysis set was first marked as accepted or rejected */
    firstCompleted?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
}

/** Class to define a PEF analysis set test mutation. */
export interface PefAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean | undefined;
    /** PEF Repeatability (L/min) */
    repeatabilityPefAbsolute?: number | undefined;
    /** PEF Repeatability (%) */
    repeatabilityPefPercentage?: number | undefined;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

/** Class to define a PEF analysis set test. */
export interface PefAnalysisSetTest extends PefAnalysisSetTestMutation {
    /** The related core test for this analysis set */
    test?: PefTest | undefined;
}

/** Class to define the PEF test mutation model. */
export interface PefTestMutation {
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** The date and time the test occurred. */
    occurred?: string;
    /** The total length of the flow data's sample points */
    flowDataLength?: number;
    /** A comma seperated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Required - The sample rate in milliseconds */
    sampleRate?: number;
    /** A comma seperated string of the volume value in Litres at each sample point */
    volumeData?: string | undefined;
    /** The total length of the volume data's sample points */
    volumeDataLength?: number;
    /** The duration of the PEF test in milliseconds */
    duration?: number;
    /** Required - The start of test quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    startOfTestQuality?: string | undefined;
    /** Required - The cough free quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    coughFreeQuality?: string | undefined;
    /** Optional - The PEF value in litres per minute. */
    pefMin?: number | undefined;
    /** Optional - The PEF value in litres per second. */
    pefSec?: number | undefined;
    /** Optional - Time to Peak Expiratory Flow in milliseconds. */
    tPef?: number | undefined;
    /** Optional - Tidal PEF in litres per second. */
    tidalPef?: number | undefined;
    /** Rise Time in milliseconds */
    tRise?: number | undefined;
}

/** Class to define the PEF test query model. */
export interface PefTest extends PefTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define a PEF analysis set creation. */
export interface PefAnalysisSetCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the analysis set belongs to. */
    sessionId?: string;
    /** Required - The type of analysis set such as Site */
    type?: string | undefined;
    /** Required - The analysis status */
    status?: string | undefined;
    /** Optional - The best PEF value in litres per minute */
    bestPefMin?: number | undefined;
    /** Optional - The best PEF value in litres per second */
    bestPefSec?: number | undefined;
    /** The PEF absolute repeatability. */
    pefAbsoluteRepeatability?: number | undefined;
    /** The PEF percentage repeatability. */
    pefPercentageRepeatability?: number | undefined;
    /** The user id of the analyst of this set. */
    analyst?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** The identifier of the QC batch this analysis set was generated with, if this analysis set is related to a batch generation */
    batchId?: string | undefined;
}

export interface SingleResultOfPefAnalysisSet extends SingleResult {
    queryable?: PefAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPefAnalysisSetTest {
    /** Entities returned by the query. */
    value?: PefAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a PEF analysis set test creation. */
export interface PefAnalysisSetTestCreation extends PefAnalysisSetTest {
}

export interface SingleResultOfPefAnalysisSetTest extends SingleResult {
    queryable?: PefAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPefSession {
    /** Entities returned by the query. */
    value?: PefSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the PCF session mutation model. */
export interface PefSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the PEF session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the PEF session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the PEF session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the PEF session was performed. */
    postureType?: string | undefined;
    /** Gender of the subject at the time the PEF session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the PEF session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the PEF session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the PEF session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the PEF session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the PEF session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the PEF session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the PEF session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Optional - The predicted PEF value (in Litres per minute) */
    predictedPefMin?: number | undefined;
    /** Optional - The predicted PEF value (in Litres per second) */
    predictedPefSec?: number | undefined;
    /** Optional - The identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Optional - Overread challenge status of the session either ORS_NOT_CHALLENGED or ORS_CHALLENGED. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
}

/** Class to define the PEF session query model. */
export interface PefSession extends PefSessionMutation {
    /** Unique identifier for the PEF session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Tests relating to the PEF session. */
    tests?: PefTest[] | undefined;
    /** Notes relating to the PEF session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the PEF session creation model. */
export interface PefSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the PEF session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Required - The name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - The date and time the session occurred. */
    occurred?: string;
    /** Optional - The user name of the technician that performed the PEF session. */
    technician?: string | undefined;
    /** Optional - The temperate recorded on the device (if applicable) at the time the PEF session was performed. */
    temperature?: number | undefined;
    /** Optional - Type of medication in use by subject at the time the PEF session was performed. */
    medicationType?: string | undefined;
    /** Optional - The posture of the subject at the time the PEF session was performed. */
    postureType?: string | undefined;
    /** Optional - Gender of the subject at the time the PEF session was performed. */
    gender?: string | undefined;
    /** Optional - Age of the subject at the time the PEF session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Date of Birth of the subject at the time the PEF session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Height of subject in CM at the time the PEF session was performed. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG at the time the PEF session was performed. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Optional - Type of smoker the subject is at the time the PEF session was performed. */
    smokerType?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the PEF session was performed. */
    populationGroupId?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) in CM at the time the PEF session was performed. */
    ulna?: number | undefined;
    /** Optional - The identifier of a session that should be considered the preceding session for this session. */
    preSessionId?: string | undefined;
    /** Optional - The predicted PEF value (in Litres per minute) */
    predictedPefMin?: number | undefined;
    /** Optional - The predicted PEF value (in Litres per second) */
    predictedPefSec?: number | undefined;
    /** Optional - The identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Optional - Tests relating to the PEF session. */
    tests?: PefTestCreation[] | undefined;
    /** Optional - Notes relating to the PEF session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the PEF test creation model. */
export interface PefTestCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The sample rate in milliseconds */
    sampleRate?: number;
    /** The total length of the flow data's sample points */
    flowDataLength?: number;
    /** Required - A comma separated string of the flow values in Litres per second at each sample point */
    flowData?: string | undefined;
    /** Required - The duration of the PEF test in milliseconds */
    duration?: number;
    /** Required - The start of test quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    startOfTestQuality?: string | undefined;
    /** Required - The cough free quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    coughFreeQuality?: string | undefined;
    /** Required - A comma separated string of the volume value in Litres at each sample point */
    volumeData?: string | undefined;
    /** Required - The total length of the volume data's sample points */
    volumeDataLength?: number;
    /** Optional - The PEF value in litres per minute. */
    pefMin?: number | undefined;
    /** Optional - The PEF value in litres per second. */
    pefSec?: number | undefined;
    /** Optional - Time to Peak Expiratory Flow in milliseconds. */
    tPef?: number | undefined;
    /** Optional - Tidal PEF in litres per second. */
    tidalPef?: number | undefined;
    /** Rise Time in milliseconds */
    tRise?: number | undefined;
}

export interface SingleResultOfPefSession extends SingleResult {
    queryable?: PefSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPefTest {
    /** Entities returned by the query. */
    value?: PefTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPefTest extends SingleResult {
    queryable?: PefTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPermissionCategory {
    /** Entities returned by the query. */
    value?: PermissionCategory[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPermissionCategory extends SingleResult {
    queryable?: PermissionCategory[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPermission {
    /** Entities returned by the query. */
    value?: Permission[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPermission extends SingleResult {
    queryable?: Permission[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPftAccuracyTestMeasurement {
    /** Entities returned by the query. */
    value?: PftAccuracyTestMeasurement[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface PftAccuracyTestMeasurementMutation {
    /** The gas type identifier */
    gasType?: string | undefined;
    /** The measured gas concentration */
    measuredConcentration?: number | undefined;
}

export interface PftAccuracyTestMeasurement extends PftAccuracyTestMeasurementMutation {
    /** External identifier */
    id?: string;
    accuracyTestId?: string;
}

export interface PftAccuracyTestMeasurementCreation {
    /** Optional - external identifier (client can supply or server generates) */
    id?: string | undefined;
    accuracyTestId?: string;
    /** The gas type identifier */
    gasType?: string | undefined;
    /** The measured gas concentration */
    measuredConcentration: number;
}

export interface SingleResultOfPftAccuracyTestMeasurement extends SingleResult {
    queryable?: PftAccuracyTestMeasurement[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPftAccuracyTest {
    /** Entities returned by the query. */
    value?: PftAccuracyTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface PftAccuracyTestMutation extends AccuracyTest {
    result?: string | undefined;
    calibrationType?: string | undefined;
    tested?: string;
    accuracyTestMeasurements?: PftAccuracyTestMeasurement[] | undefined;
}

export interface PftAccuracyTest extends PftAccuracyTestMutation {
}

export interface PftAccuracyTestCreation extends BaseAccuracyTest {
    result?: string | undefined;
    calibrationType?: string | undefined;
    tested?: string;
    accuracyTestMeasurements?: PftAccuracyTestMeasurement[] | undefined;
}

export interface SingleResultOfPftAccuracyTest extends SingleResult {
    queryable?: PftAccuracyTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPftCalibration {
    /** Entities returned by the query. */
    value?: PftCalibration[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface PftCalibration extends BaseCalibration {
    /** Date and time the calibration was first created. */
    created?: string;
    /** Date and time the calibration was last modified. */
    modified?: string;
    /** Optional - Accuracy tests */
    accuracyTests?: PftAccuracyTest[] | undefined;
}

/** Class to defined the calibration (accuracy check) */
export interface CalibrationBaseMutation {
    /** Id of the calibration. */
    id?: string;
    /** Optional - Site Id of the site which the calibration belongs to */
    siteId?: string | undefined;
    /** Required - The type of the device that the calibration was performed on */
    deviceType?: string | undefined;
    /** Optional - The user performing the calibration */
    user?: string | undefined;
    /** Required - The date and time the calibration was checked */
    checked?: string;
    /** Optional - The serial number of the device performing the calibration */
    serialNumber?: string | undefined;
    /** Optional - The measured temperature value at the time of the calibration */
    temperature?: number | undefined;
    /** Optional - The pressure value at the time of the calibration */
    pressure?: number | undefined;
    /** Optional - The humidity value at the time of the calibration */
    humidity?: number | undefined;
    /** Optional - The altitude value at the time of the calibration */
    altitude?: number | undefined;
}

export interface PftCalibrationMutation extends CalibrationBaseMutation {
}

export interface PftCalibrationCreation extends PftCalibrationMutation {
    accuracyTests?: PftAccuracyTestCreation[] | undefined;
}

export interface SingleResultOfPftCalibration extends SingleResult {
    queryable?: PftCalibration[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPhase {
    /** Entities returned by the query. */
    value?: Phase[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** The study schedule phase */
export interface Phase {
    /** The unique identifier for the phase */
    id?: string | undefined;
    /** The name of the study schedule phase */
    name?: string | undefined;
    /** The order the phases should be displayed in the user interface */
    displayOrder?: number;
}

export interface SingleResultOfPhase extends SingleResult {
    queryable?: Phase[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPopulationGroup {
    /** Entities returned by the query. */
    value?: PopulationGroup[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a population group */
export interface PopulationGroup {
    /** Unique ID of the population group */
    id?: string;
    /** The name of the population group */
    name?: string | undefined;
    /** The related core race for the population group */
    race?: string | undefined;
    raceName?: string | undefined;
    predictedSetId?: string | undefined;
    predictedSetKey?: string | undefined;
    correctionFactor?: number;
    studyId?: string;
    isDisabled?: boolean;
}

export interface SingleResultOfPopulationGroup extends SingleResult {
    queryable?: PopulationGroup[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPredictedSet {
    /** Entities returned by the query. */
    value?: PredictedSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Represents a predicted set of predicted values for a demographic */
export interface PredictedSet {
    /** The unique identifier of the predicted set */
    id?: string | undefined;
    /** The name of the predicted set */
    name?: string | undefined;
}

export interface SingleResultOfPredictedSet extends SingleResult {
    queryable?: PredictedSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPulseOximetryAnalysisSet {
    /** Entities returned by the query. */
    value?: PulseOximetryAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a Pulse Oximetry analysis set mutation. */
export interface PulseOximetryAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site */
    type?: string | undefined;
}

/** Class to define a Pulse Oximetry analysis set. */
export interface PulseOximetryAnalysisSet extends PulseOximetryAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The test analysis sets associated with the session. */
    tests?: PulseOximetryAnalysisSetTest[] | undefined;
}

export interface PulseOximetryAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
}

/** Class to define a analysis of a test */
export interface PulseOximetryAnalysisSetTest extends PulseOximetryAnalysisSetTestMutation {
}

export interface SingleResultOfPulseOximetryAnalysisSet extends SingleResult {
    queryable?: PulseOximetryAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPulseOximetryAnalysisSetTest {
    /** Entities returned by the query. */
    value?: PulseOximetryAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPulseOximetryAnalysisSetTest extends SingleResult {
    queryable?: PulseOximetryAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPulseOximetrySession {
    /** Entities returned by the query. */
    value?: PulseOximetrySession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Contract for Pulse Oximetry session mutation properties */
export interface PulseOximetrySessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the Pulse Oximetry session. */
    technician?: string | undefined;
    /** The gender of the subject */
    gender?: string | undefined;
    /** Date of birth of the subject at the time the session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Age of the subject at the time the Pulse Oximetry session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Height of subject in CM at the time the Pulse Oximetry session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the Pulse Oximetry session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the Pulse Oximetry session was performed. */
    smokerType?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the Pulse Oximetry session was performed. */
    populationGroupId?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) at the time the Pulse Oximetry session was performed. */
    ulna?: number | undefined;
}

/** Contract for Pulse Oximetry session creation properties */
export interface PulseOximetrySession extends PulseOximetrySessionMutation {
    /** Unique identifier for the Pulse Oximetry session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Optional - Revision of the hardware on the device at the time the Pulse Oximetry session was performed. */
    hardwareVersion?: string | undefined;
    /** Tests relating to the Pulse Oximetry session. */
    tests?: PulseOximetryTest[] | undefined;
    /** The comments relating to the subject. */
    subjectComments?: string | undefined;
    /** Notes relating to the Pulse Oximetry session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis). */
    analysisSets?: PulseOximetryAnalysisSet[] | undefined;
}

/** Contract for Pulse Oximetry test mutation properties */
export interface PulseOximetryTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
    /** Required - The value indicating whether the test was completed or otherwise interrupted. */
    endOfTestReached?: boolean;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The duration of the Pulse Oximetry test in seconds */
    duration?: number | undefined;
    /** Required - The SpO2 minimum value */
    spO2Min?: number | undefined;
    /** Required - The SpO2 maximum value */
    spO2Max?: number | undefined;
    /** Required - The SpO2 mean value */
    spO2Mean?: number | undefined;
    /** Required - The SpO2 medium value */
    spO2Median?: number | undefined;
    /** Required - The BP minimum value */
    bpMin?: number | undefined;
    /** Required - The BP maximum value */
    bpMax?: number | undefined;
    /** Required - The BP mean value */
    bpMean?: number | undefined;
    /** Required - The BP median value */
    bpMedian?: number | undefined;
    /** Optional - Specify SpO2 Percent when end of test is not reached. */
    spo2Percent?: number | undefined;
    /** Optional - Specify Percent Complete when end of test is not reached. */
    percentComplete?: number | undefined;
    /** Optional - Heart rate in beats per minute */
    hr?: number | undefined;
    /** Posture of the subject at the time the SpO2 test was performed. */
    postureType?: string | undefined;
}

/** Contract for Pulse Oximetry test creation properties */
export interface PulseOximetryTest extends PulseOximetryTestMutation {
}

export interface SingleResultOfPulseOximetrySession extends SingleResult {
    queryable?: PulseOximetrySession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfPulseOximetryTest {
    /** Entities returned by the query. */
    value?: PulseOximetryTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfPulseOximetryTest extends SingleResult {
    queryable?: PulseOximetryTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfQuestionnaireTestAnswer {
    /** Entities returned by the query. */
    value?: QuestionnaireTestAnswer[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfQuestionnaireTestAnswer extends SingleResult {
    queryable?: QuestionnaireTestAnswer[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfQuestionnaireTest {
    /** Entities returned by the query. */
    value?: QuestionnaireTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfQuestionnaireTest extends SingleResult {
    queryable?: QuestionnaireTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfCoreRace {
    /** Entities returned by the query. */
    value?: CoreRace[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface CoreRace {
    id?: number;
    name?: string | undefined;
    coreRaceKey?: string | undefined;
    externalCode?: string | undefined;
}

export interface SingleResultOfCoreRace extends SingleResult {
    queryable?: CoreRace[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfRole {
    /** Entities returned by the query. */
    value?: Role[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class for the role creation model. */
export interface RoleCreation extends RoleMutation {
    /** Unique identifier for the role. */
    id?: string;
}

export interface SingleResultOfRole extends SingleResult {
    queryable?: Role[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfServiceResourceCreation {
    /** Entities returned by the query. */
    value?: ServiceResourceCreation[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Modification model for an existing service resource */
export interface ServiceResourceMutation {
    /** Name  */
    name?: string | undefined;
    /** Summary text  */
    description?: string | undefined;
    /** Device Type */
    deviceType?: string | undefined;
    /** Name of the attached file */
    softwareFileName?: string | undefined;
    /** Software version of the attached file */
    softwareVersion?: string | undefined;
    /** Type of software */
    softwareType?: string | undefined;
    /** Software subtype */
    subType?: string | undefined;
    /** Revision number */
    revisionNumber?: number;
    /** Created date time */
    createdDateTime?: string;
    /** Last modified date time */
    lastModifiedDateTime?: string;
}

/** Creation model for a new service resource */
export interface ServiceResourceCreation extends ServiceResourceMutation {
    /** The id */
    id?: string;
    /** Id of the study associated */
    studyId?: string;
}

export interface SingleResultOfServiceResourceCreation extends SingleResult {
    queryable?: ServiceResourceCreation[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSessionAttachment {
    /** Entities returned by the query. */
    value?: SessionAttachment[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SessionAttachment {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    content?: string | undefined;
    sessionId?: string;
    session?: SessionFile | undefined;
    createdDate?: string;
    modifiedDate?: string;
}

/** Class to represent a sessions file */
export interface SessionFile {
    /** The session this relates to */
    sessionId?: string;
    /** The file this relates to */
    fileId?: string;
    /** The session this relates to */
    session?: Session | undefined;
    /** The file this relates to */
    file?: File | undefined;
}

export interface SessionAttachmentMutation {
    name?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export interface SessionAttachmentCreation extends SessionAttachmentMutation {
    id?: string;
    sessionId?: string;
}

export interface SingleResultOfSessionAttachment extends SingleResult {
    queryable?: SessionAttachment[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSessionNote {
    /** Entities returned by the query. */
    value?: SessionNote[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSessionNote extends SingleResult {
    queryable?: SessionNote[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSession {
    /** Entities returned by the query. */
    value?: Session[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSession extends SingleResult {
    queryable?: Session[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSessionType {
    /** Entities returned by the query. */
    value?: SessionType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SessionType {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SingleResultOfSessionType extends SingleResult {
    queryable?: SessionType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSite {
    /** Entities returned by the query. */
    value?: Site[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the site creation model. Optional and Required fields are dependant on the Study Customization */
export interface SiteCreation {
    /** Unique ID of subject, if unspecified one will be generated.  */
    id?: string;
    /** Study ID the study the site belongs to. */
    studyId?: string;
    /** SiteNumber of the site. */
    number?: string | undefined;
    /** Name of the site. */
    name?: string | undefined;
    /** Address of the site. */
    address?: string | undefined;
    /** Email address of the site. */
    email?: string | undefined;
    /** Phone number of the site. */
    phone?: string | undefined;
    /** Name of the site contact. */
    contact?: string | undefined;
    /** Fax number of the site. */
    fax?: string | undefined;
    /** Country which the site is in. */
    country?: string | undefined;
    /** TimeZone which the site is in. */
    timeZone?: string | undefined;
}

export interface SingleResultOfSite extends SingleResult {
    queryable?: Site[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSixMinuteWalkRestPeriod {
    /** Entities returned by the query. */
    value?: SixMinuteWalkRestPeriod[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define six-minute-walk rest period mutation model. */
export interface SixMinuteWalkRestPeriodMutation {
    /** Rest period date and time. */
    dateTime?: string;
    /** Rest period comments. */
    comments?: string | undefined;
    /** Rest period duration (in seconds). */
    durationInSeconds?: number | undefined;
}

/** Class to define six-minute-walk rest period model. */
export interface SixMinuteWalkRestPeriod extends SixMinuteWalkRestPeriodMutation {
    /** Rest period ID. */
    id?: string;
    /** Rest period test ID. */
    testId?: string;
}

/** Class to define six-minute-walk rest period creation model. */
export interface SixMinuteWalkRestPeriodCreation extends SixMinuteWalkRestPeriod {
}

export interface SingleResultOfSixMinuteWalkRestPeriod extends SingleResult {
    queryable?: SixMinuteWalkRestPeriod[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSixMinuteWalkSession {
    /** Entities returned by the query. */
    value?: SixMinuteWalkSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the six-minute-walk session mutation model. */
export interface SixMinuteWalkSessionMutation extends BaseSession {
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the six-minute-walk session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the six-minute-walk session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the six-minute-walk session was performed. */
    medicationType?: string | undefined;
    /** Posture of the subject at the time the six-minute-walk session was performed. */
    postureType?: string | undefined;
    /** Gender of the subject at the time the six-minute-walk session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the six-minute-walk session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the six-minute-walk session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the six-minute-walk session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the six-minute-walk session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the six-minute-walk session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the six-minute-walk session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the six-minute-walk session was performed. */
    ulna?: number | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
}

/** Class to define the six-minute-walk session query model. */
export interface SixMinuteWalkSession extends SixMinuteWalkSessionMutation {
    /** Unique identifier for the six-minute-walk session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Tests relating to the six-minute-walk session. */
    tests?: SixMinuteWalkTest[] | undefined;
    /** Notes relating to the six-minute-walk session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the six-minute-walk test mutation model. */
export interface SixMinuteWalkTestMutation {
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Six-minute-walk test type ID. */
    testTypeId?: string | undefined;
    /** Required - The data and time of the test start. */
    startTestDateTime?: string;
    /** Required - The data and time of the test end. */
    endTestDateTime?: string;
    /** Distance walked (in meters). */
    distanceWalked?: number;
    /** Predicted distance (in meters). */
    predictedDistance?: number | undefined;
    /** Lap length (in meters). */
    lapLength?: number;
    /** Number of laps. */
    numberOfLaps?: number;
    /** BODE Index value */
    bodeIndex?: number | undefined;
    /** mMRC dyspnea ID. */
    dyspnoeaMmrcId?: string | undefined;
    /** Nadir SpO2 value. */
    nadirSpO2?: number;
    /** FVC parameter value of the related FVC session */
    fvc?: number | undefined;
    /** The session date time of the related FVC session */
    relatedFvcSessionDateTime?: string | undefined;
    /** FEV1 parameter value of the related FVC session */
    fev1?: number | undefined;
    /** FEV1 percentage of predicted FEV1 of the related FVC session */
    fev1PercentPredicted?: number | undefined;
    /** Systolic parameter value. */
    systolic?: number | undefined;
    /** Diastolic parameter value. */
    diastolic?: number | undefined;
    /** Baseline observation. */
    baselineObservation?: SixMinuteWalkObservation | undefined;
    /** Final observation. */
    finalObservation?: SixMinuteWalkObservation | undefined;
    /** Flag that distance walked was manual data entry */
    distanceMde?: boolean | undefined;
    /** Flag that spirometry values were manual data entry */
    spirometryMde?: boolean | undefined;
    /** Sensor type Unique Identifier */
    sensorTypeId?: string | undefined;
}

/** Class to define the six-minute-walk test query model. */
export interface SixMinuteWalkTest extends SixMinuteWalkTestMutation {
    /** Unique identifier for the six-minute-walk test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
    /** Six-minute-walk rest periods. */
    restPeriods?: SixMinuteWalkRestPeriod[] | undefined;
    /** Medication records to the six-minute-walk session. */
    medicationRecords?: MedicationRecord[] | undefined;
}

/** Class to define six-minute-walk observation model. */
export interface SixMinuteWalkObservation {
    /** Observation date and time. */
    observationDateTime?: string;
    /** Dyspnoea grade. */
    dyspnoea?: number;
    /** Fatigue grade. */
    fatigue?: number;
    /** HR value. */
    hr?: number;
    /** SpO2 percentage. */
    spO2Percentage?: number;
    bloodPressureSystolic?: number | undefined;
    bloodPressureDiastolic?: number | undefined;
    /** Flag that blood pressure values were manual data entry
             */
    bloodPressureMde?: boolean | undefined;
    /** Flag that SpO2 values were manual data entry
             */
    spO2Mde?: boolean | undefined;
}

/** Class to define the six-minute-walk session creation model. */
export interface SixMinuteWalkSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the six-minute-walk session. */
    id?: string;
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Required - The name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Required - The date and time the session occurred. */
    occurred?: string;
    /** Optional - The user name of the technician that performed the six-minute-walk session. */
    technician?: string | undefined;
    /** Optional - The temperate recorded on the device (if applicable) at the time the six-minute-walk session was performed. */
    temperature?: number | undefined;
    /** Optional - Type of medication in use by subject at the time the six-minute-walk session was performed. */
    medicationType?: string | undefined;
    /** Optional - The posture of the subject at the time the six-minute-walk session was performed. */
    postureType?: string | undefined;
    /** Optional - Gender of the subject at the time the six-minute-walk session was performed. */
    gender?: string | undefined;
    /** Optional - Age of the subject at the time the six-minute-walk session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Date of Birth of the subject at the time the six-minute-walk session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Height of subject in CM at the time the six-minute-walk session was performed. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG at the time the six-minute-walk session was performed. */
    weight?: number | undefined;
    /** Optiona - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Optional - Type of smoker the subject is at the time the six-minute-walk session was performed. */
    smokerType?: string | undefined;
    /** Optional - Population group ID the subject belongs to at the time the six-minute-walk session was performed. */
    populationGroupId?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Length of ulna (forearm bone) in CM at the time the six-minute-walk session was performed. */
    ulna?: number | undefined;
    /** Optional - The identifier of a session that should be considered the preceding session for this session. */
    preSessionId?: string | undefined;
    /** Optional - Tests relating to the six-minute-walk session. */
    tests?: SixMinuteWalkTestCreation[] | undefined;
    /** Optional - Notes relating to the six-minute-walk session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the six-minute-walk session creation model. */
export interface SixMinuteWalkTestCreation extends SixMinuteWalkTestMutation {
    /** Unique identifier for the six-minute-walk test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Six-minute-walk rest periods. */
    restPeriods?: SixMinuteWalkRestPeriod[] | undefined;
    /** Medication records to the six-minute-walk session. */
    medicationRecords?: MedicationRecord[] | undefined;
}

export interface SingleResultOfSixMinuteWalkSession extends SingleResult {
    queryable?: SixMinuteWalkSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSixMinuteWalkTest {
    /** Entities returned by the query. */
    value?: SixMinuteWalkTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSixMinuteWalkTest extends SingleResult {
    queryable?: SixMinuteWalkTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSnipAnalysisSet {
    /** Entities returned by the query. */
    value?: SnipAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe SNIP analysis set mutation model */
export interface SnipAnalysisSetMutation extends PressureAnalysisSetMutation {
    /** The best SNIP value. */
    bestSnip?: number | undefined;
}

/** Class to desribe SNIP analysis set base (query) model */
export interface SnipAnalysisSet extends SnipAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The analyst username. */
    analyst?: string | undefined;
    /** The analyst id. */
    analystId?: string | undefined;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
    /** The analysis set tests associated with the session. */
    tests?: SnipAnalysisSetTest[] | undefined;
}

/** Class to desribe SNIP analysis set test mutation model */
export interface SnipAnalysisSetTestMutation extends PressureAnalysisSetTestMutation {
    /** SNIP repeatability. */
    snipRepeatability?: number | undefined;
    /** SNIP repeatability percent parameter value. */
    snipRepeatabilityPercent?: number | undefined;
}

/** Class to desribe SNIP analysis set test base (query) model */
export interface SnipAnalysisSetTest extends SnipAnalysisSetTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The test ID this analysis relates to. */
    testId?: string;
    /** The test this analysis relates to. */
    test?: SnipTest | undefined;
    /** The analysis set this test analysis relates to */
    analysisSetId?: string;
}

/** Class to define the SNIP test mutation model. */
export interface SnipTestMutation extends PressureTestMutation {
    /** SNIP parameter value. */
    snip?: number | undefined;
}

/** Class to define the SNIP test query model. */
export interface SnipTest extends SnipTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to desribe SNIP analysis set creation model */
export interface SnipAnalysisSetCreation extends SnipAnalysisSetMutation {
    /** Optional - Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set (Site or Over-read) */
    type?: string | undefined;
    /** The session analyst username. */
    analyst?: string | undefined;
}

export interface SingleResultOfSnipAnalysisSet extends SingleResult {
    queryable?: SnipAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSnipAnalysisSetTest {
    /** Entities returned by the query. */
    value?: SnipAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to desribe SNIP analysis set creation model */
export interface SnipAnalysisSetTestCreation extends SnipAnalysisSetTest {
}

export interface SingleResultOfSnipAnalysisSetTest extends SingleResult {
    queryable?: SnipAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSnipSession {
    /** Entities returned by the query. */
    value?: SnipSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the SNIP session mutation model. */
export interface SnipSessionMutation extends PressureSessionMutation {
    /** Predicted SNIP parameter value. */
    predictedSnip?: number | undefined;
}

/** Class to define the SNIP session query model. */
export interface SnipSession extends SnipSessionMutation {
    /** Unique identifier for the pressure session. */
    id?: string;
    /** Unique identifier for the analysisSet. */
    analysisSetId?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** Unique identifier for the type of session. */
    sessionTypeId?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Date and time the session was last modified. */
    modified?: string;
    /** Date and time the session was last received. */
    received?: string | undefined;
    /** Tests related to the SNIP session. */
    tests?: SnipTest[] | undefined;
    /** Number of tests relating to the session. */
    testsCount?: number;
    /** Status of the overread. */
    status?: string | undefined;
    /** Overreader name. */
    overreader?: string | undefined;
    /** Notes relating to the SNIP session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: PressureAnalysisSet[] | undefined;
}

/** Class to define the SNIP session creation model. */
export interface SnipSessionCreation extends SnipSessionMutation {
    /** Optional - Unique identifier for the SNIP session. */
    id?: string;
    /** Optional - Tests relating to the SNIP session. */
    tests?: SnipTestCreation[] | undefined;
    /** Optional - Notes relating to the SNIP session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the SNIP test creation model. */
export interface SnipTestCreation extends SnipTestMutation {
    /** Unique identifier for the pressure test. */
    id?: string;
    /** Session ID the test belongs to. */
    sessionId?: string;
}

export interface SingleResultOfSnipSession extends SingleResult {
    queryable?: SnipSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSnipTest {
    /** Entities returned by the query. */
    value?: SnipTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSnipTest extends SingleResult {
    queryable?: SnipTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFvcAnalysisSet {
    /** Entities returned by the query. */
    value?: FvcAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a spirometry analysis set creation. */
export interface FvcAnalysisSetCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The session the analysis set belongs to. */
    sessionId?: string;
    /** Required - The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** Required - The analysis status */
    status?: string | undefined;
    /** Optional - The best FEV1 value (Forced Expiratory Volume in the first 1 seconds) in litres. */
    bestFev1?: number | undefined;
    /** Optional - The best FVC (Forced Vital Capacity) value in litres. */
    bestFvc?: number | undefined;
    /** Optional - The best PEF (Peak Expiratory Flow) value in litres per minute. */
    bestPefMin?: number | undefined;
    /** Optional - The best mean Forced Expiratory Flow between the 25th and 75th percentile in litres per second. */
    bestFef2575?: number | undefined;
    /** Optional - The best FEV1 over FVC ratio. */
    bestFev1Fvc?: number | undefined;
    /** The best FEV6 value (Forced Expiratory Volume in the first 6 seconds) in litres. */
    bestFev6?: number | undefined;
    /** Optional - The FEV1 test quality grade */
    fev1Grade?: string | undefined;
    /** The best FEF25 value */
    bestFef25?: number | undefined;
    /** The best FEF50 value */
    bestFef50?: number | undefined;
    /** The best FEF75 value */
    bestFef75?: number | undefined;
    /** Optional - The FVC test quality grade */
    fvcGrade?: string | undefined;
    /** Optional - The FEV1Q best value */
    bestFev1Q?: number | undefined;
    /** Optional - The FEV1Q  Post-Bronchodilator responsiveness */
    fev1Bdr?: number | undefined;
    /** Optional - The Fvc Post-Bronchodilator responsiveness  */
    fvcBdr?: number | undefined;
    /** Optional - The Fev1 Reversibility Absolute Change */
    fev1ReversibilityAbsoluteChange?: number | undefined;
    /** Optional - The Fev1 Reversibility Percentage Change */
    fev1ReversibilityPercentageChange?: number | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - The Baseline Fev1 % */
    percentBaselineFev1?: number | undefined;
    /** Optional - The Baseline Drop Fev1 % */
    percentBaselineDropFev1?: number | undefined;
    bestEOTV?: number | undefined;
    bestErv?: number | undefined;
    bestEv?: number | undefined;
    bestEvFvc?: number | undefined;
    bestFef0212?: number | undefined;
    bestFef2575Fvc?: number | undefined;
    bestFef50Fif50?: number | undefined;
    bestFef7585?: number | undefined;
    bestFefMax?: number | undefined;
    bestFet?: number | undefined;
    bestFev05?: number | undefined;
    bestFev05Fvc?: number | undefined;
    bestFev075?: number | undefined;
    bestFev075Fvc?: number | undefined;
    bestFev1Fev6?: number | undefined;
    bestFev1Fivc?: number | undefined;
    bestFev1Ht2?: number | undefined;
    bestFev1Ivc?: number | undefined;
    bestFev1Pef?: number | undefined;
    bestFev1R?: number | undefined;
    bestFev1Vc?: number | undefined;
    bestFev3?: number | undefined;
    bestFev3Fvc?: number | undefined;
    bestFev3Vc?: number | undefined;
    bestFif25?: number | undefined;
    bestFif50?: number | undefined;
    bestFif50Fef50?: number | undefined;
    bestFif75?: number | undefined;
    bestFiv1?: number | undefined;
    bestFiv1Fivc?: number | undefined;
    bestFiv1Fvc?: number | undefined;
    bestFivc?: number | undefined;
    bestFivcFvc?: number | undefined;
    bestFmft?: number | undefined;
    bestFrc?: number | undefined;
    bestIc?: number | undefined;
    bestIrv?: number | undefined;
    bestIvc?: number | undefined;
    bestMvvind?: number | undefined;
    bestPefSec?: number | undefined;
    bestPifMin?: number | undefined;
    bestPifSec?: number | undefined;
    bestRawind?: number | undefined;
    bestRisetime?: number | undefined;
    bestRv?: number | undefined;
    bestText?: number | undefined;
    bestThes?: number | undefined;
    bestTlc?: number | undefined;
    bestTpef?: number | undefined;
    bestTv?: number | undefined;
    bestFev6Fvc?: number | undefined;
    bestIfr?: number | undefined;
}

export interface SingleResultOfFvcAnalysisSet extends SingleResult {
    queryable?: FvcAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfFvcAnalysisSetTest {
    /** Entities returned by the query. */
    value?: FvcAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfFvcAnalysisSetTest extends SingleResult {
    queryable?: FvcAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSpirotracUserGroup {
    /** Entities returned by the query. */
    value?: SpirotracUserGroup[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Model to describe spirotrac user group */
export interface SpirotracUserGroup {
    /** Unique identifier of the group */
    id?: string | undefined;
    /** Name of the group */
    name?: string | undefined;
}

export interface SingleResultOfSpirotracUserGroup extends SingleResult {
    queryable?: SpirotracUserGroup[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudy {
    /** Entities returned by the query. */
    value?: Study[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DeltaOfStudy extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export interface SingleResultOfStudy extends SingleResult {
    queryable?: Study[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyCoughEventType {
    /** Entities returned by the query. */
    value?: StudyCoughEventType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface StudyCoughEventType {
    id?: string;
    studyId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    period?: boolean;
    colour?: string | undefined;
    hidden?: boolean;
    counted?: boolean;
    deviceButton?: number | undefined;
    refEventTypeId?: string | undefined;
}

export interface DeltaOfStudyCoughEventType extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export interface SingleResultOfStudyCoughEventType extends SingleResult {
    queryable?: StudyCoughEventType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyCountry {
    /** Entities returned by the query. */
    value?: StudyCountry[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface StudyCountry {
    id?: string;
    countryCode?: string | undefined;
    name?: string | undefined;
    tollFreeNumber?: string | undefined;
    localPostalAddress?: string | undefined;
    studyId?: string;
}

export interface DeltaOfStudyCountry extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export interface SingleResultOfStudyCountry extends SingleResult {
    queryable?: StudyCountry[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyFixedCommentSet {
    /** Entities returned by the query. */
    value?: StudyFixedCommentSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfStudyFixedCommentSet extends SingleResult {
    queryable?: StudyFixedCommentSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyLanguage {
    /** Entities returned by the query. */
    value?: StudyLanguage[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface StudyLanguage {
    studyId?: string;
    id?: string | undefined;
    name?: string | undefined;
    localeName?: string | undefined;
}

export interface SingleResultOfStudyLanguage extends SingleResult {
    queryable?: StudyLanguage[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyPhase {
    /** Entities returned by the query. */
    value?: StudyPhase[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** A study specific name for a study schedule phase */
export interface StudyPhase {
    /** The unique identifier of this phase */
    id?: string;
    /** The reference phase this study specific name relates to */
    phaseId?: string | undefined;
    /** The study specific name of the study schedule phase */
    name?: string | undefined;
    /** The study the name relates to */
    studyId?: string;
    /** The order the phases should be displayed in the user interface */
    displayOrder?: number;
}

export interface SingleResultOfStudyPhase extends SingleResult {
    queryable?: StudyPhase[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudySchedule {
    /** Entities returned by the query. */
    value?: StudySchedule[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface StudyScheduleCreation {
    id?: string;
    studyId?: string;
    studyScheduleVisits?: StudyScheduleVisitCreation[] | undefined;
}

export interface StudyScheduleVisitCreation {
    id?: string;
    studyScheduleId?: string;
    phaseId?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    ordinal?: number;
    disabled?: boolean;
    mandatory?: boolean;
    obligation?: string | undefined;
    spanDays?: boolean;
    commentRequired?: boolean;
    confirmationRequired?: boolean;
    cohort?: string | undefined;
    studyScheduleSessions?: StudyScheduleSessionCreation[] | undefined;
}

export interface SingleResultOfStudySchedule extends SingleResult {
    queryable?: StudySchedule[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyScheduleSession {
    /** Entities returned by the query. */
    value?: StudyScheduleSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface DeltaOfStudyScheduleSession extends Delta {
    Kind?: DeltaItemKind;
    StructuredType?: string | undefined;
    ExpectedClrType?: string | undefined;
    UpdatableProperties?: string[] | undefined;
    IsComplexType?: boolean;
}

export interface SingleResultOfStudyScheduleSession extends SingleResult {
    queryable?: StudyScheduleSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudyScheduleVisit {
    /** Entities returned by the query. */
    value?: StudyScheduleVisit[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfStudyScheduleVisit extends SingleResult {
    queryable?: StudyScheduleVisit[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfStudySessionType {
    /** Entities returned by the query. */
    value?: StudySessionType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface StudySessionType {
    id?: string | undefined;
    name?: string | undefined;
    studyId?: string;
    sessionTypeId?: number;
}

export interface SingleResultOfStudySessionType extends SingleResult {
    queryable?: StudySessionType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSubjectNote {
    /** Entities returned by the query. */
    value?: SubjectNote[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to capture a modification of a subject note */
export interface SubjectNoteMutation {
    /** Required - The related subject for the note */
    subjectId?: string;
    /** The email address of the user modifying the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

/** Class to represent a subject note. */
export interface SubjectNote extends SubjectNoteMutation {
    /** Unique ID of the test note */
    id?: string;
}

/** Class to capture a creation of a subject note */
export interface SubjectNoteCreation {
    /** Unique ID for the subject note */
    id?: string;
    /** Required - The related subject for the note */
    subjectId?: string;
    /** The email address of the user creating the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

export interface SingleResultOfSubjectNote extends SingleResult {
    queryable?: SubjectNote[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSubject {
    /** Entities returned by the query. */
    value?: Subject[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the subject creation model. */
export interface SubjectCreation {
    /** Optional - Unique ID of subject, if unspecified one will be generated.  */
    id?: string;
    /** Required - Site ID the subject belongs to. */
    siteId?: string;
    /** Optional - Population group ID the subject belongs to. */
    populationGroupId?: string | undefined;
    /** Optional - Status of the subject. */
    status?: string | undefined;
    /** Required - Unique subject number. */
    number?: string | undefined;
    /** Optional - Alternative subject number. */
    alternativeNumber?: string | undefined;
    /** Optional - Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Optional - Language code of the subject. */
    language?: string | undefined;
    /** Optional - Gender of the subject. */
    gender?: string | undefined;
    /** Optional - Date of Birth of the subject, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Optional - Age of the subject, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Optional - Height of subject in CM. */
    height?: number | undefined;
    /** Optional - Weight of subject in KG. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject. */
    bmi?: number | undefined;
    /** Optional - Length of ulna in CM. */
    ulna?: number | undefined;
    /** Optional - Type of medication in use by subject. */
    medicationType?: string | undefined;
    /** Optional - Type of smoker the subject is. */
    smokerType?: string | undefined;
    /** Optional - Number of subject for randomization. */
    randomizationNumber?: string | undefined;
    /** Date of randomization, if specified the randomization number must be given. */
    randomized?: string | undefined;
    /** Optional -  */
    pin?: string | undefined;
    /** Optional - Whether the source of the subject is Spirotrac V or not */
    createdWithSpirotracV?: boolean;
    /** Optional - The subject's bed time */
    bedTime?: string | undefined;
    /** Optional - A list of alarms that will be applied on the subject's eDiary */
    alarms?: SubjectAlarm[] | undefined;
    /** Optional - The study cohort */
    studyPart?: string | undefined;
    /** Optional - The subject's baseline PEF in L/min */
    baselinePef?: number | undefined;
    /** Optional - The subject's baseline FEV1 in Litres */
    baselineFev1?: number | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline1?: number | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline2?: number | undefined;
    /** Optional - A custom study specific baseline value for the subject */
    baseline3?: number | undefined;
}

export interface SingleResultOfSubject extends SingleResult {
    queryable?: Subject[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSubjectType {
    /** Entities returned by the query. */
    value?: SubjectType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a subject type */
export interface SubjectType {
    /** Unique ID of the subject type */
    id?: string | undefined;
    /** The name of the subject type */
    name?: string | undefined;
}

export interface SingleResultOfSubjectType extends SingleResult {
    queryable?: SubjectType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSurveyAnswer {
    /** Entities returned by the query. */
    value?: SurveyAnswer[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SurveyAnswerCreation {
    /** A unique identifier for the answer */
    id?: string;
    /** The identifier of the session this answer is part of */
    sessionId?: string;
    /** The identifier of the question the answer is for */
    questionId?: string;
    /** The user facing identifier for the question */
    questionNumber?: string | undefined;
    /** The English text displayed to the user for the question */
    questionText?: string | undefined;
    /** The index of the question within the survey, starting from 0 */
    index?: number;
    /** The type of the value possible options are ('DATETIMEPICKER', 'DATEPICKER', 'TIMEPICKER', 'FREETEXT', 'MULTILINEFREETEXT', 'NUMERIC', 'DECIMAL', 'NUMERICSCALE', 'VAS', 'SINGLESELECT', 'MULTISELECT', 'TRANSITION') */
    valueType?: string | undefined;
    /** The answer value */
    value?: any | undefined;
    /** Optional - The weight of the answer to factor into any scoring calculation */
    answerWeight?: number | undefined;
    /** Optional - The answer value in English text (if applicable) */
    valueText?: string | undefined;
    /** Optional - Whether the questionnaire was exited early before this question could be answered */
    exitedEarly?: boolean | undefined;
    /** Optional - Whether the answer was left blank by the user (if applicable within the questionnaire protocol) */
    leftBlank?: boolean | undefined;
}

export interface SurveyAnswer extends SurveyAnswerCreation {
    session?: SurveySession | undefined;
}

export interface SurveySessionMutation extends BaseSession {
    /** A unique identifier for this instance of a survey */
    id?: string;
    /** Optional - The parent visit identifier for this session */
    visitId?: string | undefined;
    /** Optional - The series identifier the survey is part of */
    seriesId?: string | undefined;
    /** Required - The session label */
    label?: string | undefined;
    /** Required - The identifier of subject who the survey relates to */
    subjectId?: string;
    /** Required - Whether the survey was completed by the subject or not, if the survey was completed by a site technician instead this should be 'false' */
    completedBySubject?: boolean;
    /** Optional - If the survey was completed by a site technician, the email address of the user who completed the survey */
    completedByUserId?: string | undefined;
    /** Optional - The type of device used for the survey */
    deviceTypeId?: string | undefined;
    /** Optional - The identifier of the survey */
    surveyId?: string | undefined;
    /** Required - The completion status of the survey ('complete' or 'incomplete') */
    status?: string | undefined;
    /** Required - The date and time the survey was started */
    startDateTime?: string;
    /** Optional - The date and time the survey was completed */
    endDateTime?: string | undefined;
    /** The set of answers to the survey */
    answers?: SurveyAnswer[] | undefined;
    /** Optional - Notes relating to the survey session. */
    notes?: SessionNote[] | undefined;
    /** Optional - A set of scores calculated from the server answers */
    scores?: SurveyScore[] | undefined;
}

export interface SurveySessionCreation extends SurveySessionMutation {
}

export interface SurveySession extends SurveySessionCreation {
    visit?: Visit | undefined;
}

export interface SurveyScore {
    /** Required - The name of the score */
    name?: string | undefined;
    /** Required - The score value */
    value?: string | undefined;
}

export interface SurveyAnswerMutation extends SurveyAnswerCreation {
}

export interface SingleResultOfSurveyAnswer extends SingleResult {
    queryable?: SurveyAnswer[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSurveySession {
    /** Entities returned by the query. */
    value?: SurveySession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSurveySession extends SingleResult {
    queryable?: SurveySession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSvcAnalysisSet {
    /** Entities returned by the query. */
    value?: SvcAnalysisSet[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a SVC analysis set mutation. */
export interface SvcAnalysisSetMutation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The overreader user name. */
    analystUserName?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - The VC best value */
    bestVc?: number | undefined;
    /** Optional - The IVC best value */
    bestIvc?: number | undefined;
    /** Optional - The EVC best value */
    bestEvc?: number | undefined;
    /** Optional - The IV best value */
    bestTv?: number | undefined;
    /** Optional - The IC best value */
    bestIc?: number | undefined;
    /** Optional - The ERV best value */
    bestErv?: number | undefined;
    /** Optional - The TLC best value */
    bestTlc?: number | undefined;
    /** Optional - The RV best value */
    bestRv?: number | undefined;
    /** Optional - The FRC best value */
    bestFrc?: number | undefined;
}

/** Class to define a spirometry analysis set. */
export interface SvcAnalysisSet extends SvcAnalysisSetMutation {
    /** The date and time the analysis was started */
    started?: string | undefined;
    /** The date and time the analysis was created */
    created?: string;
    /** The date and time the analysis was last modified */
    modified?: string;
    /** The session the analysis set is assigned to. */
    session?: Session | undefined;
    /** The test analysis sets associated with the session. */
    tests?: SvcAnalysisSetTest[] | undefined;
    /** The user id of the analyst of this set. */
    analystUserId?: string;
    /** Whether the user can edit the analysis set or not */
    canEdit?: boolean;
}

export interface SvcAnalysisSetTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Required - The test this analysis relates to. */
    testId?: string;
    /** Required - The analysis set this test analysis relates to */
    analysisSetId?: string;
    /** Required - The analysis acceptability of this test */
    accepted?: boolean;
    /** VC Repeatability (L) */
    repeatabilityVcAbsolute?: number | undefined;
    /** VC Repeatability (%) */
    repeatabilityVcPercentage?: number | undefined;
    /** A collection of fixed comments selected for the analysis set test */
    fixedComments?: AnalysisSetTestFixedComment[] | undefined;
}

/** Class to define a analysis of a test */
export interface SvcAnalysisSetTest extends SvcAnalysisSetTestMutation {
}

/** Class to define a SVC analysis set mutation. */
export interface SvcAnalysisSetCreation {
    /** Unique ID of the analysis set */
    id?: string;
    /** The session the analysis set belongs to. */
    sessionId?: string;
    /** The type of analysis set such as Site or Over-read */
    type?: string | undefined;
    /** The analysis status */
    status?: string | undefined;
    /** A collection of fixed comments selected for the analysis set */
    fixedComments?: AnalysisSetFixedComment[] | undefined;
    /** Optional - The VC best value */
    bestVc?: number | undefined;
    /** Optional - The IVC best value */
    bestIvc?: number | undefined;
    /** Optional - The EVC best value */
    bestEvc?: number | undefined;
    /** Optional - The IV best value */
    bestTv?: number | undefined;
    /** Optional - The IC best value */
    bestIc?: number | undefined;
    /** Optional - The ERV best value */
    bestErv?: number | undefined;
    /** Optional - The TLC best value */
    bestTlc?: number | undefined;
    /** Optional - The RV best value */
    bestRv?: number | undefined;
    /** Optional - The FRC best value */
    bestFrc?: number | undefined;
}

export interface SingleResultOfSvcAnalysisSet extends SingleResult {
    queryable?: SvcAnalysisSet[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSvcAnalysisSetTest {
    /** Entities returned by the query. */
    value?: SvcAnalysisSetTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSvcAnalysisSetTest extends SingleResult {
    queryable?: SvcAnalysisSetTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSvcAnalysisSetType {
    /** Entities returned by the query. */
    value?: SvcAnalysisSetType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define a spirometry analysis set type. */
export interface SvcAnalysisSetType {
    /** Gets the Id */
    id?: number;
    /** Gets the name */
    name?: string | undefined;
    /** Gets the external code */
    externalCode?: string | undefined;
}

export interface SingleResultOfSvcAnalysisSetType extends SingleResult {
    queryable?: SvcAnalysisSetType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSvcSession {
    /** Entities returned by the query. */
    value?: SvcSession[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to define the SVC session mutation model. */
export interface SvcSessionMutation extends BaseSession {
    /** Required - Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the SVC session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the SVC session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the SVC session was performed. */
    medicationType?: string | undefined;
    /** Identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Gender of the subject at the time the SVC session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the SVC session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the SVC session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the SVC session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the SVC session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the SVC session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the SVC session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the FVC session was performed. */
    ulna?: number | undefined;
    /** Dose amount of a medication given to the subject at the time of the session. */
    doseAmount?: number | undefined;
    /** Time of the dose of medication given to the subject at the time of the session. */
    doseTime?: string | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Overread challenge status of the session that preceeded this session. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
    /** Optional - The VC predicted value */
    predictedVc?: number | undefined;
    /** Optional - The IVC predicted value */
    predictedIvc?: number | undefined;
    /** Optional - The EVC predicted value */
    predictedEvc?: number | undefined;
    /** Optional - The IV predicted value */
    predictedTv?: number | undefined;
    /** Optional - The IC predicted value */
    predictedIc?: number | undefined;
    /** Optional - The ERV predicted value */
    predictedErv?: number | undefined;
    /** Optional - The TLC predicted value */
    predictedTlc?: number | undefined;
    /** Optional - The RV predicted value */
    predictedRv?: number | undefined;
    /** Optional - The FRC predicted value */
    predictedFrc?: number | undefined;
}

/** Class to define the SVC session query model. */
export interface SvcSession extends SvcSessionMutation {
    /** Unique identifier for the SVC session. */
    id?: string;
    /** Visit the session belongs to. */
    visit?: Visit | undefined;
    /** The type of session. */
    sessionType?: string | undefined;
    /** The device type used for the session. */
    deviceType?: string | undefined;
    /** Date and time the session was first created. */
    created?: string;
    /** Last time the session was received. */
    lastReceivedTime?: string | undefined;
    /** Date and time the session was last modified. */
    modified?: string;
    /** The name of the overreader. */
    analystUserName?: string | undefined;
    /** The id of the overreader. */
    analystUserId?: string;
    /** Number of tests relating to the SVC session. */
    testsCount?: number;
    /** Tests relating to the SVC session. */
    tests?: SvcTest[] | undefined;
    /** Notes relating to the SVC session. */
    notes?: SessionNote[] | undefined;
    /** Sets of analysis that capture a specific analysis of the session (such as site system analysis, over-reader analysis) */
    analysisSets?: SvcAnalysisSet[] | undefined;
    /** Status of the overread. */
    status?: string | undefined;
}

/** Class to define the SVC test mutation model. */
export interface SvcTestMutation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Index number of the test for the session, starting from 1. */
    index?: number;
    /** The date and time the test occurred. */
    occurred?: string;
    /** Gets or sets the quality indicator. */
    qualityIndicators?: number;
    /** Gets or sets the sample rate of the flow and volume data in milliseconds */
    sampleRate?: number;
    /** Gets or sets the length of the volume data. */
    volumeDataLength?: number;
    /** Required - The flow plateau quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    flowPlateauQuality?: string | undefined;
    /** Gets or sets the volume data. */
    volumeData?: string | undefined;
    /** Gets or sets the flow data. */
    flowData?: string | undefined;
    /** The duration of the SVC test in milliseconds */
    duration?: number;
    /** Gets or sets the Vc parameter */
    vc?: number | undefined;
    /** Gets or sets the Ivc parameter */
    ivc?: number | undefined;
    /** Gets or sets the Evc parameter */
    evc?: number | undefined;
    /** Gets or sets the Tv parameter */
    tv?: number | undefined;
    /** Gets or sets the Iv parameter */
    ic?: number | undefined;
    /** Gets or sets the Erv parameter */
    erv?: number | undefined;
    /** Gets or sets the Tlc parameter */
    tlc?: number | undefined;
    /** Gets or sets the Rv parameter */
    rv?: number | undefined;
    /** Gets or sets the Frc parameter */
    frc?: number | undefined;
}

/** Class to define the SVC test query model. */
export interface SvcTest extends SvcTestMutation {
    /** Unique ID of the test */
    id?: string;
    /** The session the test belongs to. */
    sessionId?: string;
    /** Date and time the test was first created. */
    created?: string;
    /** Date and time the test was last modified. */
    modified?: string;
}

/** Class to define the SVC session creation model. */
export interface SvcSessionCreation extends BaseSession {
    /** Optional - Unique identifier for the SVC session. */
    id?: string;
    /** Visit ID the session belongs to. */
    visitId?: string;
    /** Name of the session as defined by the study schedule. */
    name?: string | undefined;
    /** Date and time the session occurred. */
    occurred?: string;
    /** User name of the technician that performed the SVC session. */
    technician?: string | undefined;
    /** Temperate recorded on the device (if applicable) at the time the SVC session was performed. */
    temperature?: number | undefined;
    /** Type of medication in use by subject at the time the SVC session was performed. */
    medicationType?: string | undefined;
    /** Identifier of the last calibration record of the device that was used to perform this session. */
    lastCalibrationId?: string | undefined;
    /** Gender of the subject at the time the SVC session was performed. */
    gender?: string | undefined;
    /** Age of the subject at the time the SVC session was performed, if specified then Date of Birth cannot be. Percentage of year can be given as a decimal. */
    age?: number | undefined;
    /** Date of Birth of the subject at the time the SVC session was performed, if specified then age cannot be. */
    dateOfBirth?: string | undefined;
    /** Height of subject in CM at the time the SVC session was performed. */
    height?: number | undefined;
    /** Weight of subject in KG at the time the SVC session was performed. */
    weight?: number | undefined;
    /** Optional - Body Mass Index of subject as time of session was performed. */
    bmi?: number | undefined;
    /** Type of smoker the subject is at the time the SVC session was performed. */
    smokerType?: string | undefined;
    /** Population group ID the subject belongs to at the time the SVC session was performed. */
    populationGroupId?: string | undefined;
    /** Race as given by the subject, has no influence on population group. */
    race?: string | undefined;
    /** Length of ulna in CM at the time the SVC session was performed. */
    ulna?: number | undefined;
    /** Dose amount of a medication given to the subject at the time of the session. */
    doseAmount?: number | undefined;
    /** Time of the dose of medication given to the subject at the time of the session. */
    doseTime?: string | undefined;
    /** Session ID of the session that preceeded this session. */
    preSessionId?: string | undefined;
    /** Overread challenge status of the session that preceeded this session. */
    overreadChallengeStatus?: string | undefined;
    /** Whether the over-reading challenge for the session has been resolved or not */
    challengeIsClosed?: boolean;
    /** Optional - The VC predicted value */
    predictedVc?: number | undefined;
    /** Optional - The IVC predicted value */
    predictedIvc?: number | undefined;
    /** Optional - The EVC predicted value */
    predictedEvc?: number | undefined;
    /** Optional - The IV predicted value */
    predictedTv?: number | undefined;
    /** Optional - The IC predicted value */
    predictedIc?: number | undefined;
    /** Optional - The ERV predicted value */
    predictedErv?: number | undefined;
    /** Optional - The TLC predicted value */
    predictedTlc?: number | undefined;
    /** Optional - The RV predicted value */
    predictedRv?: number | undefined;
    /** Optional - The FRC predicted value */
    predictedFrc?: number | undefined;
    /** Optional - Tests relating to the SVC session. */
    tests?: SvcTestCreation[] | undefined;
    /** Optional - Notes relating to the SVC session. */
    notes?: SessionNote[] | undefined;
}

/** Class to define the SVC test creation model. */
export interface SvcTestCreation {
    /** Optional - Unique ID of the test */
    id?: string;
    /** Gets or sets the session identifier. */
    sessionId?: string;
    /** Required - Index number of the test for the session, starting from 1. */
    index?: number;
    /** Required - The date and time the test occurred. */
    occurred?: string;
    /** Required - The duration of the SVC test in milliseconds */
    duration?: number;
    /** Gets or sets the quality indicator. */
    qualityIndicators?: number;
    /** Gets or sets the sample rate of the flow and volume data in milliseconds */
    sampleRate?: number;
    /** Gets or sets the length of the volume data. */
    volumeDataLength?: number;
    /** Required - The flow plateau quality artefact, accepts a status of ART_UNDETERMINED, ART_ACCEPTABLE, ART_USABLE, ART_NOTACCEPTABLE */
    flowPlateauQuality?: string | undefined;
    /** Gets or sets the volume data. */
    volumeData?: string | undefined;
    /** Gets or sets the flow data. */
    flowData?: string | undefined;
    /** Gets or sets the Vc parameter */
    vc?: number | undefined;
    /** Gets or sets the Ivc parameter */
    ivc?: number | undefined;
    /** Gets or sets the Evc parameter */
    evc?: number | undefined;
    /** Gets or sets the Tv parameter */
    tv?: number | undefined;
    /** Gets or sets the Iv parameter */
    ic?: number | undefined;
    /** Gets or sets the Erv parameter */
    erv?: number | undefined;
    /** Gets or sets the Tlc parameter */
    tlc?: number | undefined;
    /** Gets or sets the Rv parameter */
    rv?: number | undefined;
    /** Gets or sets the Frc parameter */
    frc?: number | undefined;
}

export interface SingleResultOfSvcSession extends SingleResult {
    queryable?: SvcSession[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfSvcTest {
    /** Entities returned by the query. */
    value?: SvcTest[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfSvcTest extends SingleResult {
    queryable?: SvcTest[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfTestNote {
    /** Entities returned by the query. */
    value?: TestNote[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

/** Class to capture a modification of a test note */
export interface TestNoteMutation {
    /** Required - The related test for the note */
    testId?: string;
    /** The email address of the user modifying the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

/** Class to represent a test note. */
export interface TestNote extends TestNoteMutation {
    /** Unique ID of the test note */
    id?: string;
}

/** Class to capture a creation of a test note */
export interface TestNoteCreation {
    /** Unique ID for the session note */
    id?: string;
    /** Required - The related test for the note */
    testId?: string;
    /** The email address of the user creating the note */
    userEmailAddress?: string | undefined;
    /** The note contents */
    comment?: string | undefined;
    /** The date and time the note was recorded */
    recorded?: string;
}

export interface SingleResultOfTestNote extends SingleResult {
    queryable?: TestNote[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfTimeZone {
    /** Entities returned by the query. */
    value?: TimeZone[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface TimeZone {
    id?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    legacyId?: number;
    offsetInMinutes?: number;
}

export interface SingleResultOfTimeZone extends SingleResult {
    queryable?: TimeZone[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfUnitType {
    /** Entities returned by the query. */
    value?: UnitType[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface UnitType {
    id?: string | undefined;
    name?: string | undefined;
    dataItemTypeId?: string | undefined;
}

export interface SingleResultOfUnitType extends SingleResult {
    queryable?: UnitType[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfUser {
    /** Entities returned by the query. */
    value?: User[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface UserCreation extends UserMutation {
    /** Unique ID for the user */
    id?: string;
    /** Whether user has registered and requested access */
    hasRequest?: boolean;
}

export interface SingleResultOfUser extends SingleResult {
    queryable?: User[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfVisitObligation {
    /** Entities returned by the query. */
    value?: VisitObligation[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface VisitObligation {
    id?: string | undefined;
    name?: string | undefined;
}

export interface SingleResultOfVisitObligation extends SingleResult {
    queryable?: VisitObligation[] | undefined;
}

/** Defines the result of an OData query. */
export interface QueryOfVisit {
    /** Entities returned by the query. */
    value?: Visit[] | undefined;
    /** Count of the entities that match the query, this ignores skip or top so useful for paging. */
    "@odata.count"?: number;
}

export interface SingleResultOfVisit extends SingleResult {
    queryable?: Visit[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}